const pt_BR = {
  translations: {
    common: {
      copy: "Copiar",
      yes: "Sim",
      no: "Não",
    },
    menu_bar: {
      add_variables: "Adicionar variáveis",
    },
    home: {
      message: "Olá Mundo",
    },
    page: {
      panels: {
        title: "Painéis",
        edit: "Editar",
        search: "Procure por um painel",
        add: "Adicionar painel",
        sync_confirm: {
          title: "Atualizar dados",
          description:
            "Os dados deste painel serão reprocessados em segundo plano, considerando as informações até o dia anterior. Isso pode levar alguns minutos. Deseja continuar?",
          cancel: "Cancelar",
          confirm: "Sim, atualizar",
        },
        executions_modal: {
          title: "Atualizações de dados do painel",
          running_alert:
            "Já existe uma atualização em andamento para este painel. Acompanhe o progresso abaixo.",
          running_tooltip: "Aguarde a atualização em andamento terminar",
          no_data: "Nenhuma atualização de dados registrada para este painel.",
          sync: "Atualizar dados",
          close: "Fechar",
          of: "de",
        },
        sync_tooltip: "Atualizar Dados",
        refresh_tooltip: "Atualizar Dashboard",
        confirm: {
          title: "Deletar painel?",
          description:
            "Isso vai permanentemente deletar o painel,seus dashboards e todos os dados.",
        },
        name: "Nome",
        view_more: "Ver mais",
        no_data: "Nenhum painel encontrado",
        cancel_button: "Cancelar",
        confirm_button: "Sim, deletar",
        delete: "Deletar",
      },
      reports: {
        title: "Relatórios",
        search: "Procure por um relatório",
        code: "Código",
        name: "Nome",
        type: "Tipo",
        description: "Descrição",
        no_data: "Nenhum relatório encontrado",
        editDescription: {
          title: "Editar descrição",
          visual: "Visual",
          html: "Código HTML",
          htmlPlaceholder: "Cole ou digite o código HTML da descrição",
          save: "Salvar",
          cancel: "Cancelar",
        },
        execution: {
          title: "Execução do Relatório",
          startDate: "Data Inicial",
          endDate: "Data Final",
          ticketServices: "Serviços de Ticket",
          ticketService: "Serviço de tickets",
          workspaces: "Áreas de trabalho",
          channels: "Quadros",
          users: "Usuários",
          attendants: "Atendentes",
          created: "Criado",
          automationCode: "Automações",
          automationCodeExcept: "Exceto Automações",
          establishments: "Estabelecimentos",
          esignRules: "Regras de Assinatura",
          monthYear: "Mês/Ano",
          generate: "Gerar Relatório",
          search: "Pesquisar",
          back: "Voltar",
          code: "Código",
          reportLabel: "Relatório",
          all: "Todos",
          loading: "Carregando relatório...",
          noResultData: "Nenhum dado encontrado para os filtros selecionados.",
          group: "Grupo",
          validation: {
            startDateRequired: "A data inicial é obrigatória",
            endDateRequired: "A data final é obrigatória",
            createdRequired: "Selecione um mês",
            ticketServicesRequired: "Selecione ao menos um serviço de ticket",
            workspacesRequired: "Selecione ao menos uma área de trabalho",
            channelsRequired: "Selecione ao menos um quadro",
            invalidDateRange: "A data inicial não pode ser maior que a data final",
          },
          period: {
            thisMonth: "Mês atual",
            lastMonth: "Último mês",
            selectMonth: "Especificar mês",
          },
          header: {
            generatedAt: "Data e hora da geração",
            generatedBy: "Usuário",
            generatedLine: "Gerado em {{date}} por {{user}}",
          },
          actions: {
            print: "Imprimir",
            exportExcel: "Excel",
          },
          metadata: {
            title: "Filtros usados",
            month: "Mês",
            period: "Período",
            generatedAt: "Gerado em",
          },
          table: {
            reason: "Motivo",
            totalTickets: "Total de Tickets",
            monthReference: "Mês Referência",
            dateReference: "Data Referência",
            periodReference: "Período Referência",
            board: "Quadro",
            user: "Atendente",
            quantity: "Quantidade",
            name: "Nome",
            automation: "Automação",
            triggers: "Disparos",
            confirm: "Confirmar",
            cancel: "Cancelar",
            notMe: "Não sou eu",
            yes: "Sim",
            no: "Não",
            ok: "Ok",
            invalid: "Inválida",
            talkToAttendant: "Falar com Atendente",
            finish: "Finalizar",
            noResponse: "Sem Resposta",
            establishment: "Estabelecimento",
            client: "Cliente",
            sent: "Enviadas",
            received: "Recebidas",
            total: "Total",
            ticketsQuantity: "Quantidade de Tickets",
            tokenName: "Nome do Token",
            invalidResponse: "Resposta Inválida",
            service: "Serviço",
            displayOrder: "Ordem de exibição",
            area: "Área",
            clicks: "Cliques",
          },
        },
      },
      edit_panel: {
        title: "Painel",
        subtitle: "Novo painel",
        name: "Nome",
      },
      under_construction: {
        title: "Em construção",
        subtitle:
          "Esta seção está em construção, enquanto não terminada, visite uma das outras seções",
        button: "Visite Registro de Genéricos",
      },
      login: {
        login: "Acessar",
        accessing: "Acessando",
        welcome: "Bem-vindo de volta",
        rememberme: "Lembre de mim",
        forget_password: "Esqueceu a senha?",
        username: "CPF",
        password: "Senha",
      },
      dashboardExecutions: {
        title: "Atualizações de dados dos dashboards",
        search_placeholder: "Procure pelo nome do painel",
        view_details: "Ver detalhes",
        code: "Código",
        panel: "Painel",
        origin: "Origem",
        status_label: "Status",
        all_status: "Todos",
        progress: "Progresso",
        running_generates: "Em andamento",
        failed_generates: "Com falha",
        created: "Solicitado em",
        finished_date: "Finalizado em",
        start_date: "Data inicial",
        end_date: "Data final",
        failed_alert:
          "Alguns processamentos esgotaram as tentativas e não serão refeitos automaticamente. Os demais dados já foram atualizados.",
        purged_alert:
          "Os detalhes desta atualização foram removidos pela retenção em {{date}}.",
        status: {
          queued: "Na fila",
          processing: "Processando",
          failed: "Com falha",
          finished: "Concluída",
          finishedwitherror: "Concluída com erro",
        },
        detail: {
          header_title: "Atualização {{code}}",
          title: "Processamentos",
          reprocess_all: "Reprocessar falhas",
          reprocess_one: "Reprocessar",
          reprocess_success: "{{count}} processamento(s) enviado(s) para reprocessar.",
          reprocess_nothing:
            "Nada para reprocessar: só processamentos com as tentativas esgotadas podem ser reprocessados.",
          reprocess_confirm: {
            title: "Reprocessar",
            description_all:
              "Todos os processamentos com falha desta atualização voltarão para a fila e o painel ficará em atualização até terminarem. Deseja continuar?",
            description_one:
              "Este processamento voltará para a fila e o painel ficará em atualização até ele terminar. Deseja continuar?",
            cancel: "Cancelar",
            confirm: "Sim, reprocessar",
          },
          search_placeholder: "Procure pelo erro",
          component: "Componente",
          group_type: "Agrupamento",
          period: "Período",
          status: "Status",
          retries: "Tentativas",
          end_process_date: "Processado em",
          error: "Erro",
        },
      },
      dashboardGenerateConfig: {
        title: "Configuração da atualização de dados",
        subtitle: "Parâmetros do processamento dos dashboards",
        maxBatchSize: "Tamanho do lote",
        max_batch_size_helper: "Quantidade de processamentos em cada lote.",
        maxBatchNumbers: "Quantidade de lotes",
        max_batch_numbers_helper: "Quantidade de lotes por transação.",
        maxRetries: "Máximo de tentativas",
        max_retries_helper:
          "Quantas vezes um processamento com erro é refeito antes de ser considerado falha.",
        maxPendingBatchTransactions: "Máximo de transações pendentes",
        max_pending_batch_transactions_helper:
          "Quantas transações podem estar aguardando processamento antes de um novo loteamento.",
        retentionDaysReduced: "Retenção dos concluídos (dias)",
        retention_days_reduced_helper:
          "Por quantos dias os detalhes dos processamentos concluídos são mantidos.",
        retentionDaysFailed: "Retenção das falhas (dias)",
        retention_days_failed_helper:
          "Por quantos dias, contados da última falha, uma atualização com falha fica aberta para correção antes de ser encerrada.",
        alertEmails: "E-mails de alerta",
        alert_emails_helper:
          "Destinatários do aviso diário quando houver falhas, processamentos travados ou problemas na limpeza. Separe por vírgula ou ponto e vírgula. Vazio = sem aviso.",
        errors: {
          max_batch_size: "Informe um tamanho de lote maior que zero",
          max_batch_numbers: "Informe uma quantidade de lotes maior que zero",
          max_retries: "Informe um máximo de tentativas maior que zero",
          max_pending_batch_transactions:
            "Informe um máximo de transações pendentes maior que zero",
          retention_days_reduced: "Informe uma retenção maior que zero",
          retention_days_failed: "Informe uma retenção maior que zero",
          alert_emails:
            "Informe e-mails válidos, separados por vírgula ou ponto e vírgula",
        },
      },
      not_found: {
        page_not_found: "Ooops! Página não encontrada",
        back_to_begin: "Voltar ao início",
        server_not_responding: "O servidor não está respondendo",
        try_again: "Tente novamante",
        back_to_login: "Voltar ao login",
        something_went_wrong: "Algo deu errado :(",
      },
      dashboard: {
        dashboard: "Seja bem-vindo!",
        account_balance: "Saldo da conta",
        refresh_button: "Recarregar",
        idle: "Parado",
        active: "Ativo",
      },
      register: {
        generics: {
          identifier: "Identificador",
          code: "Código",
          value: "Valor",
          generics: "Genéricos",
          generic: "Genérico",
          delete_generics: "Excluir Genéricos",
          search_identifier: "Procure por um identificador",
          edit_generic: "Editar Genérico",
          description: "Descrição",
          new_generic: "Novo Genérico",
          confirm: {
            title: "Deletar genérico?",
            description: "Isso vai permanentemente deletar o genérico",
          },
          errors: {
            identifier: "O identificador é obrigatório",
            code: "O código é obrigatório",
            value: "O valor é obrigatório",
          },
        },
        roles: {
          name: "Nome",
          establishments: "Estabelecimentos",
          full_name: "Nome completo",
          privileges: "Privilégios",
          privileges_tab: "Privilégios",
          dashboards_tab: "Dashboards",
          reports_tab: "Relatórios",
          ticket_default_doc_categories_tab: "Categoria Protocolo Padrão",
          list_categories_tab: "DList Categorias",
          list_classifications_tab: "DList Classificações",
          dashboards_grid_title: "Dashboards",
          search_dashboard: "Pesquisar dashboard",
          add_dashboard: "Adicionar dashboard",
          dashboard: "Dashboard",
          linked_dashboard_remove_title: "Remover dashboard vinculado?",
          linked_dashboard_remove_description:
            "Isso removerá apenas o vínculo deste dashboard com o perfil.",
          linked_report_remove_title: "Remover relatório vinculado?",
          linked_report_remove_description:
            "Isso removerá apenas o vínculo deste relatório com o perfil.",
          linked_list_category_remove_title: "Remover categoria vinculada?",
          linked_list_category_remove_description:
            "Isso removerá apenas o vínculo desta categoria com o perfil.",
          linked_list_classification_remove_title:
            "Remover classificação vinculada?",
          linked_list_classification_remove_description:
            "Isso removerá apenas o vínculo desta classificação com o perfil.",
          linked_ticket_default_doc_category_remove_title:
            "Remover categoria vinculada?",
          linked_ticket_default_doc_category_remove_description:
            "Isso removerá apenas o vínculo desta categoria com o perfil.",
          dashboard_link_removed: "Dashboard desvinculado com sucesso",
          report_link_removed: "Relatório desvinculado com sucesso",
          reports: "Relatórios",
          search_report: "Pesquisar relatório",
          add_report: "Adicionar relatório",
          ticket_default_doc_categories: "Categorias de Protocolo Padrão",
          ticket_default_doc_category: "Categoria de Protocolo Padrão",
          search_ticket_default_doc_category: "Pesquisar categoria",
          add_ticket_default_doc_category: "Adicionar categoria",
          list_categories: "Categorias de Lista",
          list_category: "Categoria de Lista",
          search_list_category: "Pesquisar categoria",
          add_list_category: "Adicionar categoria",
          list_classifications: "Classificações de Lista",
          list_classification: "Classificação de Lista",
          search_list_classification: "Pesquisar classificação",
          add_list_classification: "Adicionar classificação",
          edit_link: "Editar vínculo",
          code: "Código",
          report: "Relatório",
          report_with_code: "#{{code}} - {{name}}",
          roles: "Perfil",
          enable: "Habilitar",
          profiles: "Papéis",
          roles_profile: "Papéis que terão este perfil vinculado",
          delete_role: "Excluir perfil",
          search_role: "Procure por um perfil",
          description: "Descrição",
          new_role: "Novo Perfil",
          software: "Software",
          select_software: "Selecione um software",
          config_access: "Configurações de acesso ao perfil",
          confirm: {
            title: "Deletar perfil?",
            description: "Isso vai permanentemente deletar o perfil",
          },
          errors: {
            name: "O nome é obrigatório",
            description: "A descrição é obrigatória",
            establishments: "Ao menos um estabelecimento é obrigatório",
            privilege: "Ao menos um privilégio é obrigatório",
            ticket_default_doc_category: "A categoria é obrigatória",
            list_category: "A categoria é obrigatória",
            list_classification: "A classificação é obrigatória",
            software: "O software é obrigatório",
          },
        },
        legalPerson: {
          new_legalPerson: "Nova pessoa Jurídica",
          legalPersons: "Pessoas Jurídicas",
          delete_legalPersons: "Deletar Pessoas Jurídicas",
          search_legalPerson:
            "Procure por Documento, Razão Social ou Nome Fantasia",
          add_legalPerson: "Adicionar Pessoa Jurídica",
          //
          document: "CNPJ",
          corporateName: "Razão social",
          tradingName: "Nome fantasia",
          taxRegime: "Regime tributário",
          fiscalContributor: "Contribuinte fiscal",
          stateRegistration: "Inscrição estadual",
          municipalInscription: "Inscrição municipal",
          foreigner: "Estrangeira",
          country: "País",
          //
          contactType: "Tipo de contato",
          addContact: "Adicionar contato",
          //
          addresses: "Endereços",
          add_address: "Adicionar endereço",
          addressType: "Tipo de endereço",
          zip_code: "CEP",
          city: "Cidade:",
          province: "Estado:",
          addressDescription: "Rua",
          establishmentId: "Estabelecimento",
          neighborhood: "Bairro",
          number: "Número",
          complement: "Complemento",
          //
          contacts: "Contatos",
          establishment_tooltip: "Ver estabelecimento",
          confirm: {
            title: "Deletar pessoa jurídica?",
            description: "Isso vai permanentemente deletar a pessoa jurídica",
            title_plural: "Deletar pessoas jurídicas?",
            description_plural:
              "Isso vai permanentemente deletar as pessoas jurídicas",
          },
          //
          errors: {
            document: {
              nomempty: "O documento é obrigatório",
              regex: "Número de CNPJ inválido",
            },
            corporateName: "O nome da empresa é obrigatório",
            country: "O País obrigatório",
            establishment: "O estabelecimento é obrigatório",
            fiscal_contribuitor: "O contribuinte fiscal é obrigatório",
            tax_regime: "O regime tributário é obrigatório",
            contact: {
              contactTypeId: "O tipo de contato é obrigatório",
              value: {
                phone: "Número de telefone inválido",
                email: "Email inválido",
                site: "Site inválido",
                other: "O valor é obrigatório",
              },
            },
            address: {
              zipCode: "Cep inválido",
              addressTypeId: "Selecione um tipo",
              city: "A cidade é obrigatória",
              province: "O estado é obrigatório",
              addressDescription: "A rua é obrigatória",
              neighborhood: "O bairro é obrigatório",
              number: "Número inválido",
            },
          },
        },
        languages: {
          languages: "Idiomas",
          new_language: "Novo idioma",
          edit_language: "Editar idioma",
          search_language: "Pesquise por um idioma",
          name: "Nome",
          code: "Código",
          establishments: "Estabelecimentos",
          establishment_tooltip: "Ver estabelecimentos",
          confirm: {
            title: "Deletar idioma?",
            description: "Isso vai permanentemente deletar o idioma",
          },
          errors: {
            name: "O nome é obrigatório",
            establishments: "O estabelecimento é obrigatório",
          },
        },
        users: {
          actives: "Ativos",
          inactives: "Inativos",
          start_date: "Data Inicial",
          end_date: "Data Final",
          users: "Usuários",
          user: "Usuário",
          new_user: "Novo usuário",
          full_name: "Nome completo",
          user_integration_type: "Tipo",
          integration: "Código de Integração",
          add_new_integration: "Adicionar Integração",
          user_integration: "Integração",
          integration_id: "Código de Integração",
          username: "CPF",
          user_profiles: "Perfis do usuário",
          user_roles: "Papéis do usuário",
          name: "Nome",
          enable: "Habilitar",
          document: "Documento",
          email: "E-mail",
          password: "Senha",
          individual: "Pessoa física",
          resend_mail: "Reenviar e-mail",
          beneficiary_sync: "Sincronização de Beneficiário",
          beneficiary_sync_success: "Beneficiário sincronizado com sucesso",
          beneficiary_sync_no_document: "Usuário não possui CPF cadastrado",
          email_confirmed_label: "Status do e-mail",
          email_confirmed_tag: "Confirmado",
          email_not_confirmed_tag: "Não confirmado",
          main_establishments:
            "Principal estabelecimento que o usuário possui vínculo legal",
          config: "Configurações de acesso do usuário",
          establishments_access:
            "Estabelecimentos que o usuário poderá acessar",
          establishments_tooltip: "Ver estabelecimentos",
          establishment_tooltip: "Ver estabelecimento",
          search_user: "Pesquise por um usuário",
          add_user: "Adicionar usuário",
          roles_inherited:
            "Perfis que o usuário herdou com base nos papéis que possui",
          none_roles_inherited: "Nenhum perfil herdado encontrado",
          roles_tooltip: "Ver perfis",
          email_tasy_warning:
            "Este é um campo informativo. Alterações neste campo não surtem efeito. Por favor altere o endereço de e-mail no Tasy.",
          email_not_confirmed: "Email não confirmado pelo usuário",
          email_confirmation_date: "Data da confirmação do e-mail",
          tooltip_main_estabishment:
            "Por padrão no momento da criação é definido o estabelecimento atual como principal estabelecimento",
          reset_password: {
            button: "Resetar senha",
            title:
              "Você tem tem certeza que deseja resetar a senha do usuário {{username}}?",
            title_form: "Resetar senha do usuário {{username}}",
            site: "Site",
            site_error: "O site é obrigatório",
            sending: "Enviando",
            email_sent: "Enviamos um link de alteração da senha para:",
            confirm: "Resetar",
            cancel: "Cancelar",
          },
          temporary_password: {
            button: "Senha temporária",
            password_copied: "Copiado com sucesso",
            copy: "Copiar",
            title: "Senha temporária",
          },
          change_pin: {
            button: "Alterar PIN",
            title: "Alterar o PIN do usuário {{username}}",
            pin: "Novo PIN",
            pin_error: "O PIN deve conter exatamente 4 dígitos",
            confirm: "Salvar",
            cancel: "Cancelar",
            success: "PIN alterado com sucesso",
          },
          errors: {
            username: "A CPF é obrigatória",
            password: "A senha é obrigatória",
            individual: "A Pessoa física é obrigatório",
            user_integration_type: "O tipo é obrigatório",
            integration: "O código de integração é obrigatório",
            email: "O email é obrigatório",
            establishments: "Selecione ao menos um estabelecimento",
            establishment_standard:
              "O principal estabelecimento que o usuário possui vínculo legal é obrigatório",
            profiles: "Pelo menos um papel do usuário deve ser selecionado",
          },
          confirm: {
            title: "Deletar usuário?",
            description: "Isso vai permanentemente deletar o usuário",
          },
        },
        establishmentParams: {
          establishmentParams: "Parâmetros Gerais",
          value: "Valor",
          description: "Descrição",
          public: "Público",
          establishmentParamTypeId: "Tipo de parâmetro",
          add_establishmentParam: "Adicionar parâmetro geral",
          search_param: "Pesquise por um parâmetro",
          new_param: "Novo parâmetro",
          confirm: {
            title: "Deletar parâmetro geral?",
            description: "Isso vai permanentemente deletar o parâmetro geral",
          },
          errors: {
            value: "O valor é obrigatório",
            description: "A descrição é obrigatória",
            establishmentParamTypeId: "O tipo de parâmetro é obrigatório",
          },
        },
        individuals: {
          sync_beneficiary: {
            button: "Sincronização de Beneficiário",
          },
          beneficiary_sync_success: "Beneficiário sincronizado com sucesso",
          beneficiary_sync_no_document:
            "Pessoa física não possui CPF cadastrado",
          individuals: "Pessoa Física",
          individual: "Pessoa Física",
          new_individual: "Nova Pessoa Física",
          search_individuals: "Pesquise por uma pessoa física",
          add_individual: "Adicionar Pessoa Física",
          foreigner: "Estrangeiro",
          identity_card: "RG",
          name: "Nome",
          document: "CPF",
          birth_date: "Data de nascimento",
          contacts: "Contatos",
          add_contact: "Adicionar Contato",
          contact_type: "Tipo de Contato",
          addresses: "Endereços",
          add_address: "Adicionar Endereço",
          address_type: "Tipo de Endereço",
          zip_code: "CEP",
          city: "Cidade",
          province: "Estado",
          country: "País",
          address_description: "Rua",
          neighborhood: "Bairro",
          number: "Número",
          complement: "Complemento",
          gender: "Gênero",
          family_group: "Grupo familiar",
          add_family_group: "Adicionar Grupo Familiar",
          family_individual: "Pessoa Física",
          kinship_degree: "Grau de Parentesco",
          imports: "Importações",
          confirm: {
            title: "Deletar pessoa física?",
            description: "Isso vai permanentemente deletar a pessoa física",
          },
          errors: {
            name: "O nome é obrigatório",
            document: "O documento é obrigatório",
            document_regex: "Precisa ser um CPF válido",
            birth_date: "A data de nascimento é obrigatória",
            country: "O país é obrigatório",
            gender: "O gênero é obrigatório",
            contact: {
              contactTypeId: "O tipo de contato é obrigatório",
              phone: "O número de telefone é obrigatório",
              email: "O e-mail é obrigatório",
              site: "O site é obrigatório",
              other: "O campo é obrigatório",
            },
            address: {
              addressTypeId: "O tipo de endereço é obrigatório",
              zipCode: "O CEP é obrigatório",
              city: "A cidade é obrigatória",
              provincy: "O estado é obrigatório",
              addressDescription: "A rua é obrigatória",
              neighborhood: "O bairro é obrigatório",
              number: "O número é obrigatório",
            },
            family_individual: "A pessoa física é obrigatória",
            kinship_degree: "O grau de parentesco é obrigatório",
          },
          establishments: {
            establishments: "Estabelecimentos",
          },
        },
        individualsImports: {
          imports: "Importações",
          import: "Importação",
          search: "Pesquise por uma importação",
          new_import: "Nova importação",
          file_name: "Nome do arquivo",
          normalized_file_name: "Nome do arquivo normalizado",
          status: "Status",
          add_import: "Adicionar importação",
          view_individuals: "Ver Pessoas Físicas",
          import_individuals: "Importar Pessoas Físicas",
          import_successfully: "Importação realizada com sucesso",
          download_model: "Baixar modelo",
          search_imports: "Procure por uma importação",
        },
        importList: {
          imports_individuals: "Pessoas Físicas da Importação",
          name: "Nome",
          document: "Documento",
          status: "Status",
          birth_date: "Data de nascimento",
          gender: "Gênero",
          foreigner: "Estrangeiro",
          yes: "Sim",
          no: "Não",
          cns: "CNS",
          address: "Endereço",
          number: "Número",
          neighborhood: "Bairro",
          complement: "Complemento",
          city: "Cidade",
          zip_code: "CEP",
          country: "País",
          neighborhood_code: "Código do bairro",
          city_ibge_code: "Código IBGE da cidade",
          identity_card: "RG",
          email: "E-mail",
          phone: "Telefone",
          view: "Ver mais",
        },
        documents: {
          documents: "Termos e políticas",
          version: "Versão",
          date: "Data",
          document: "Documento",
          add_document: "Adicionar documento",
          doc_type: "Tipo de documento",
          select_doc_type: "Selecione o tipo de documento",
          no_docs_selected: "Nenhum tipo de documento foi selecionado",
          no_docs_version: "Tipo de documento não possui uma versão",
          see_document: "Ver documento",
          table_title: "Histórico de versões",
          export_csv: "Exportar Csv",
          docsVersion: {
            last_version: "Última versão",
            new_version: "Nova versão",
            edit_version: "Editar",
          },
          create_document: {
            new_document: "Documento",
            add_new_language: "Adicionar novo idioma",
            version: "Versão",
            version_date: "Data da versão",
            add_document: "Adicionar documento",
            language: "Idioma",
            name: "Nome",
            content: "Conteúdo",
            enable: "Habilitar",
            language_tooltip: "Ver idioma",
          },
          document_modal: {
            version: "Versão",
            version_date: "Data da versão",
            name: "Nome",
            language: "Idioma",
            content: "Conteúdo",
          },
          errors: {
            version: "A versão é obrigatória",
            version_regex: "A versão deve ser um número",
            language: "O idioma é obrigatório",
            name: "O nome é obrigatório",
            content: "O conteúdo é obrigatório",
          },
        },
        establishments: {
          establishments: "Estabelecimentos",
          establishment: "Estabelecimento",
          new_establishment: "Novo estabelecimento",
          name: "Nome",
          ansCode: "Código da Operadora na ANS",
          integration: "Código de estabelecimento no cliente",
          domain_admin: "Domínio do painel administrativo",
          collector_host: "Host coletor",
          parent_host: "Host coletor da nuvem",
          real_time_host: "Host em tempo real",
          search_establishment: "Pesquise por um nome",
          add_establishment: "Adicionar estabelecimento",
          company: "Empresa",
          enable: "Habilitado",
          config_on_premise: "Configurações do ambiente on premise",
          notifications: "Notificações",
          critical_communication_emails: "E-mails para comunicações críticas",
          critical_communication_emails_info:
            "Informe os e-mails separados por vírgula",
          languages: "Idiomas",
          sync: "Sincronizar ambiente on premise",
          sync_beneficiaries: "Sincronizar beneficiários",
          see_establishments: "Ver Estabelecimento on premise",
          see_params: "Ver Parâmetros on premise",
          see_generics: "Ver Genéricos on premise",
          see_health: "Planos de Saúde sincronizados",
          see_medic_specialties_on_premise: "Ver especialidades médicas",
          see_medical_practice_areas: "Ver áreas de atuação médica",
          see_provider_types: "Ver tipos de prestadores",
          see_professional_councils: "Ver conselhos profissionais",
          see_extensions: "Ver extensões on premise",
          synced: "Sincronizado com sucesso",
          jobs: "Jobs",
          crmDomain: "Domínio do CRM",
          telemedDomain: "Domínio do 4uTelemed",
          languages_tooltip: "Ver idiomas",
          extensions_on_premise: "Extensões on premise",
          generics_on_premise: "Genéricos on premise",
          params_on_premise: "Parâmetros on premise",
          establishment_on_premise: "Estabelecimento on premise",
          health_on_premise: "Planos de Saúde sincronizados",
          provider_types_on_premise: "Tipos de prestadores",
          medic_specialties_on_premise: "Especialidades médicas",
          professional_councils_on_premise: "Conselhos profissionais",
          medical_practice_areas_on_premise: "Áreas de atuação médica",
          domain: "Domínio",
          filemanager_host: "Host do filemanager na nuvem",
          softwares: "Aplicações",
          legal_entity: "Pessoa Jurídica",
          confirm: {
            title: "Deletar estabelecimento?",
            description: "Isso vai permanentemente deletar o estabelecimento",
          },
          errors: {
            name: "O nome é obrigatório",
            company: "A empresa é obrigatória",
            languages: "Selecione ao menos um idioma",
            integration:
              "O código de estabelecimento no cliente deve ser maior que 1",
            domain_admin: "O domínio do painel administrativo é obrigatório",
            collector_https:
              "O host coletor precisa começar com 'http://' ou 'https://'",
            parent_https:
              "O host coletor da nuvem precisa começar com 'http://' ou 'https://'",
            real_time_https:
              "O host em tempo real precisa começar com 'http://' ou 'https://'",
            domain_admin_https:
              "O domínio do painel administrativo precisa começar com 'http://' ou 'https://'",
            ans_code: "O código da operadora na ANS é obrigatório",
            filemanager_host: "O host do filemanager na nuvem é obrigatório",
            filemanager_host_https:
              "O host do filemanager na nuvem precisa começar com 'http://' ou 'https://'",
            parent_host: "O host coletor da nuvem é obrigatório",
            collector_host: "O host coletor é obrigatório",
            real_time_host: "O host em tempo real é obrigatório",
            critical_communication_emails:
              "Informe e-mails válidos separados por vírgula",
          },
        },
        countries: {
          countries: "Países",
          country: "País",
          search_country: "Procure por um nome",
          add_country: "Adicionar país",
          new_country: "Novo país",
          name: "Nome",
          code: "Código",
          enable: "Habilitar",
          ddi_code: "Código DDI",
          phone_mask: "Máscara de telefone",
          phone_mask_help:
            "A máscara deve ser enviada conforme exemplo: (00)000000000, em que o 'zero' representa os números do telefone",
          confirm: {
            title: "Deletar país?",
            description: "Isso vai permanentemente deletar o país",
          },
          errors: {
            code: "O código é obrigatório",
            name: "O nome é obrigatório",
          },
        },
        cities: {
          cities: "Cidades",
          city: "Cidade",
          new_city: "Nova cidade",
          name: "Nome",
          provincy: "Estado",
          enable: "Habilitar",
          ibge_code: "Código do IBGE",
          correio_code: "Código dos Correios",
          search_city: "Procure por uma cidade",
          add_city: "Adicionar cidade",
          errors: {
            name: "O nome é obrigatório",
            ibge_code: "O código do IBGE é obrigatório",
            correio_code: "O código dos Correios é obrigatório",
            provincy: "O estado é obrigatório",
          },
        },
        neighborhoods: {
          neighborhoods: "Bairros",
          neighborhood: "Bairro",
          new_neighborhood: "Novo bairro",
          search_neighborhoods: "Procure por um bairro",
          add_neighborhood: "Adicionar bairro",
          name: "Nome",
          code: "Código dos Correios",
          city: "Cidade",
          enable: "Habilitar",
          errors: {
            name: "O nome é obrigatório",
            city: "A cidade é obrigatória",
          },
        },
        companies: {
          companies: "Empresas",
          company: "Empresa",
          search_company: "Pesquise por uma empresa",
          add_company: "Adicionar empresa",
          new_company: "Nova empresa",
          name: "Nome",
          code: "Código",
          enable: "Habilitar",
          company_group: "Grupo Empresarial",
          confirm: {
            title: "Deletar empresa?",
            description: "Isso vai permanentemente deletar a empresa",
          },
          errors: {
            name: "O nome é obrigatório",
            code: "O código é obrigatório",
            company_group: "O grupo empresarial é obrigatório",
          },
        },
        digital_certificates: {
          digital_certificates: "Certificados Digitais",
          digital_certificate: "Certificado Digital",
          search_digital_certificate: "Procure por um certificado digital",
          add_digital_certificate: "Adicionar Certificado Digital",
          new_digital_certificate: "Novo Certificado Digital",
          type_document: "Tipo de documento",
          document: "Documento",
          useCertillionLocalAgent: "Usar certillion local",
          name: "Nome",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          enable: "Habilitar",
          created_successfully: "Certificado Digital criado com sucesso",
          digital_certificate_files: "Arquivos de Certificado Digital",
          yes: "Sim",
          no: "Não",
          digitalCertificateFile: {
            digital_certificate_files: "Arquivos de Certificado Digital",
            digital_certificate_file: "Arquivo de Certificado Digital",
            add_digital_certificate_file:
              "Adicionar Arquivo de Certificado Digital",
            new_digital_certificate_file: "Novo Arquivo de Certificado Digital",
            search: "Pesquise por um arquivo de certificado digital",
            initial_date: "Data Inicial",
            end_date: "Data Final",
            password: "Senha",
            password_caption: "Senha gerada na criação do certificado digital",
            file: "Arquivo",
            confirm: {
              title: "Deletar arquivo de certificado digital?",
              description:
                "Isso vai permanentemente deletar o arquivo de certificado digital",
            },
            errors: {
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              password: "A senha é obrigatória",
              file: "O arquivo é obrigatório",
              date: "A data final deve ser maior que a data inicial",
            },
          },
          confirm: {
            title: "Deletar certificado digital?",
            description:
              "Isso vai permanentemente deletar o certificado digital",
          },
          errors: {
            name: "O nome é obrigatório",
            type_document: "O tipo de documento e obrigatorio",
            document: "O documento e obrigatorio",
            document_max_length: "O documento deve ter no maximo 18 caracteres",
            document_cpf_length: "O CPF deve ter 11 digitos",
            document_cnpj_length: "O CNPJ deve ter 14 digitos",
          },
        },
        provinces: {
          provinces: "Estados",
          province: "Estado",
          search_province: "Procure por um estado",
          add_province: "Adicionar estado",
          new_province: "Novo estado",
          name: "Nome",
          code: "Código",
          enable: "Habilitar",
          country: "País",
          confirm: {
            title: "Deletar estado?",
            description: "Isso vai permanentemente deletar o estado",
          },
          errors: {
            code: "O código é obrigatório",
            name: "O nome é obrigatório",
            company_group: "O grupo empresarial é obrigatório",
            country: "O país é obrigatório",
          },
        },
        banks: {
          banks: "Bancos",
          bank: "Banco",
          search_bank: "Procure por um banco",
          add_bank: "Adicionar banco",
          new_bank: "Novo banco",
          name: "Nome",
          short_name: "Nome curto",
          ispb_code: "Código ISPB",
          bacen_code: "Código Bacen",
          ibge_city_code: "Código IBGE da Cidade",
          confirm: {
            title: "Deletar banco?",
            description: "Isso vai permanentemente deletar o banco",
          },
          errors: {
            name: "O nome é obrigatório",
            ispb_code: "O código ISPB é obrigatório",
          },
        },
        totemDevice: {
          totem_devices: "Dispositivos Totem",
          totem_device: "Dispositivo Totem",
          new_totem_device: "Novo Dispositivo Totem",
          add_totem_device: "Adicionar Dispositivo Totem",
          search: "Pesquise por um dispositivo totem",
          name: "Nome",
          code: "Codigo",
          observation: "Observação",
          device_password: "Senha do Dispositivo",
          token_4uBus: "Token 4uBus",
          integration_queues: "Filas de Integração",
          site_app: "Site ou App",
          change_password: "Alterar Senha",
          enable: "Habilitar",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar o dispositivo totem?",
            description: "Isso vai permanentemente deletar o dispositivo totem",
          },
          errors: {
            name: "O nome é obrigatório",
            device_password: "A senha é obrigatória",
            token_4uBus: "O token 4uBus é obrigatório",
            integration_queues: "A fila de integração é obrigatória",
            site_app: "o Site ou App é obrigatório",
          },
        },
        totem: {
          totems: "Totens",
          totem: "Totem",
          new_totem: "Novo Totem",
          add_totem: "Adicionar totem",
          search: "Pesquise por um totem",
          name: "Nome",
          type: "Tipo",
          status: "Status",
          domains: "Domínios",
          domain: "Domínio",
          domain_type: "Tipo de domínio",
          add_domain: "Adicionar domínio",
          front_config: "JSON de configuração do tema",
          my_totems: "Meus Totens",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar o totem?",
            description: "Isso vai permanentemente deletar o totem",
          },
          errors: {
            name: "O nome é obrigatório",
            type: "O tipo é obrigatório",
            status_type: "O status é obrigatório",
            domain_type: "O tipo de domínio é obrigatório",
            front_config: "O JSON de configuração do tema é obrigatório",
            description: "A descrição é obrigatória",
            file: "O arquivo é obrigatório",
            domain: "O domínio é obrigatório",
            domains: "Ao menos um domínio é obrigatório",
          },
        },
        applications: {
          applications: "Aplicações",
          application: "Aplicação",
          new_application: "Nova aplicação",
          add_application: "Adicionar aplicação",
          search: "Pesquise por uma aplicação",
          name: "Nome",
          type: "Tipo",
          app_link: "Informe o link do app na loja",
          status: "Status",
          domains: "Domínios",
          domain: "Domínio",
          domain_type: "Tipo de domínio",
          add_domain: "Adicionar domínio",
          front_config: "JSON de configuração do tema",
          chat_ticket_service: "Serviço de Tickets do '4uChat'",
          full_screen_mode: "Modo tela cheia",
          chat_profile: "Perfil do 4uChat",
          chat_title: "Título",
          chat_subtitle: "Subtítulo",
          chat_bot_name: "Nome do Bot",
          chat_width: "Largura do chat (px)",
          chat_height: "Altura do chat (px)",
          chat_primary_color: "Cor primária",
          chat_secondary_color: "Cor secundária",
          chat_logo: "Logo do 4uChat",
          chat_bot_avatar: "Avatar do Bot",
          chat_file_empty: "Nenhum arquivo",
          chat_file_select: "Selecionar",
          chat_file_change: "Trocar",
          chat_file_invalid:
            "Arquivo inválido: use .jpg, .jpeg, .png ou .webp de até 2 MB",
          chat_file_error: "Não foi possível enviar o arquivo",
          chat_preview_message: "Olá! Como posso ajudar?",
          chat_preview_hint:
            "Pré-visualização meramente ilustrativa: faixa superior do chat (logo, título e subtítulo) e mensagem do bot.",
          chat_embed_code: "Código para o seu site",
          chat_embed_code_hint:
            "Cole este código antes do fechamento da tag </body> do site. O endereço do script muda conforme o ambiente.",
          chat_embed_copy: "Copiar código",
          chat_embed_update_hint:
            "Perfil do 4uChat alterado: depois de salvar, atualize o código no site para aplicar as configurações.",
          confirm: {
            title: "Deletar a aplicação?",
            description: "Isso vai permanentemente deletar a aplicação",
          },
          errors: {
            name: "O nome é obrigatório",
            type: "O tipo é obrigatório",
            status_type: "O status é obrigatório",
            domain_type: "O tipo de domínio é obrigatório",
            front_config: "O JSON de configuração do tema é obrigatório",
            description: "A descrição é obrigatória",
            file: "O arquivo é obrigatório",
            domain: "O domínio é obrigatório",
            domains: "Ao menos um domínio é obrigatório",
            chat_width: "A largura do chat deve estar entre 320 e 800 px",
            chat_height: "A altura do chat deve estar entre 360 e 900 px",
            chat_color: "A cor deve ser hexadecimal (#RGB ou #RRGGBB)",
          },
        },
        banners: {
          banners: "Banners",
          banner: "Banner",
          new_banner: "Novo banner",
          search: "Pesquise por um banner",
          add_banner: "Adicionar banner",
          name: "Nome",
          title: "Título",
          alternative_text: "Texto alternativo",
          display_order: "Ordem de exibição",
          language: "Idioma",
          site_apps: "Sites ou Apps",
          banner_locals: "Locais onde o banner será exibido",
          active: "Ativo",
          inactive: "Inativo",
          enable: "Habilitar",
          status: "Status",
          media_file: "Arquivo de mídia",
          media_file_mobile: "Arquivo de mídia mobile",
          application: "Aplicação",
          banner_local: "Local de exibição do banner",
          targetingLink: "Link de redirecionamento",
          confirm: {
            title: "Deletar o banner?",
            description: "Isso vai permanentemente deletar o banner",
          },
          errors: {
            name: "O nome é obrigatório",
            title: "O título é obrigatório",
            alternative_text: "O texto alternativo é obrigatório",
            display_order: "A ordem de exibição é obrigatória",
            language: "O idioma é obrigatório",
            site_apps: "Ao menos um site ou app é obrigatório",
            banner_locals: "Ao menos um local é obrigatório",
            file: "O arquivo é obrigatório",
            targetingLink: "O link é inválido",
            display_order_negative:
              "A ordem de exibição não pode ser menor que 0",
          },
          recommendedSize:
            "Dimensões recomendadas para Desktop {{desktopWidth}}x{{desktopHeight}} pixels. Dimensões recomendas para Aplicativo/Mobile {{appWidth}}x{{appHeight}} pixels.",
          freeSize: "Tamanho livre",
        },
        faq: {
          faqs: "Áreas do FAQ",
          faq: "Área do FAQ",
          new_faq: "Nova área do FAQ",
          add_faq: "Adicionar área do FAQ",
          search: "Pesquise por uma área do FAQ",
          question_answer: "Perguntas e respostas",
          active: "Ativo",
          inactive: "Inativo",
          status: "Status",
          name: "Nome",
          enable: "Habilitar",
          whatsapp_phone_number: "Número de telefone do Whatsapp",
          language: "Idioma",
          mail: "E-mail",
          site_app: "Sites ou Apps",
          questions_answers: "Perguntas e Respostas",
          display_order: "Ordem de exibição",
          confirm: {
            title: "Deletar o FAQ?",
            description: "Isso vai permanentemente deletar o FAQ",
          },
          errors: {
            name: "O nome é obrigatório",
            site_app: "Ao menos um site ou app é obrigatório",
            phone_email:
              "O número de telefone do Whatsapp ou o e-mail deve ser informado",
            mail: "Informe um e-mail válido",
            language: "O idioma é obrigatório",
            display_order: "A ordem de exibição é obrigatória",
          },
        },
        questionsAnswers: {
          questions_answers: "Perguntas e Respostas",
          question_answer: "Pergunta e Resposta",
          search: "Pesquise por uma pergunta e resposta",
          add_questions_answers: "Adicione uma pergunta e resposta",
          new_question_answer: "Nova pergunta e resposta",
          display_order: "Ordem de exibição",
          question: "Pergunta",
          answer: "Resposta",
          enable: "Habilitar",
          name: "Nome",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          was_useful_count: "Contagem do 'Foi útil'",
          confirm: {
            title: "Deletar a pergunta e resposta",
            description:
              "Isso vai permanentemente deletar a pergunta e resposta",
          },
          errors: {
            display_order: "A ordem de exibição é obrigatória",
            question: "A pergunta é obrigatória",
            answer: "A resposta é obrigatória",
          },
        },
        news: {
          all_news: "Notícias",
          news: "Notícia",
          search: "Pesquise por uma notícia",
          add_news: "Adicionar notícia",
          new_news: "Nova notícia",
        },
        notifications: {
          notifications: "Notificações",
          notification: "Notificação",
          add_notification: "Adicionar notificação",
          new_notification: "Nova notificação",
          search: "Pesquise por uma notificação",
          type: "Tipo de notificação",
          status: "Status da notificação",
          start_date: "Data Inicial",
          end_date: "Data Final",
          title: "Título",
          content: "Conteúdo",
          site_app: "Sites ou Apps",
          language: "Idioma",
          language_tooltip: "Ver idioma",
          contents: "Conteúdos do lote de notificação",
          add_new_content: "Adicionar conteúdo",
          filters: "Filtros do lote de notificação",
          add_new_filter: "Adicionar filtro",
          minimum_age: "Idade mínima",
          maximum_age: "Idade máxima",
          payer: "Pagador",
          holder: "Titular",
          both: "Ambos",
          is_payer: "É pagador",
          is_not_payer: "Não é pagador",
          is_holder: "É titular",
          is_not_holder: "Não é titular",
          profiles: "Perfis",
          gender: "Gênero",
          users: "Usuários",
          published_status: "Status da publicação",
          published: "Publicado",
          not_published: "Não publicado",
          start_publish: "Início da publicação",
          finish_publish: "Fim da publicação",
          registered: "Cadastrado",
          generating: "Gerando",
          generated: "Gerado",
          canceled: "Cancelado",
          error: "Erro ao gerar",
          push_notification: "Gerar PushNotification",
          enable: "Ativar",
          rule_codes: "Códigos de regras",
          rule_codes_helper: "Insira códigos de regras separados por vírgula",
          date_start_rule: "Data de início da regra",
          content_info: "Você pode adicionar as variáveis: {{variables}}",
          active_status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          cleanFilters: {
            title: "Deseja realmente alterar o tipo de notificação?",
            description:
              "Ao alterar o tipo de notificação, todos os filtros serão removidos",
            confirm: "Sim, alterar",
            cancel: "Cancelar",
          },
          confirm: {
            title: "Deletar a Notificação?",
            description: "Isso vai permanentemente deletar a notificação",
          },
          errors: {
            type: "O tipo de notificação é obrigatório",
            site_app: "Ao menos um site ou app é obrigatório",
            contents: "Ao menos um conteúdo é obrigatório",
            language: "O idioma é obrigatório",
            title: "O título é obrigatório",
            content: "O conteúdo é obrigatório",
            notification_batch_filter:
              "Se os campos 'Pagador' e 'Titular' tiverem o valor 'Ambos', ao menos um dos campos abaixo é obrigatório",
            variables:
              "Uma variável que não existe na lista foi adicionada a um dos conteúdos",
            rule_codes: "Os códigos de regras são obrigatórios",
            date_start_rule: "A data de início da regra é obrigatória",
          },
        },
        notifiedUsers: {
          notified_users: "Usuários Notificados",
          search: "Pesquise por um usuário",
          user: "Usuário",
          read_date: "Data de leitura",
          acceptance_date: "Data de aceitação",
          acceptance_data: "Dados da aceitação",
        },
        extensions: {
          extensions: "Extensões",
          search_name: "Pesquise por um nome",
          extension: "Extensão",
          new_extension: "Nova extensão",
          presentation_order: "Ordem de apresentação",
          software: "Software",
          name: "Nome",
          title: "Título",
          description: "Descrição",
          tags: "Tags",
          files: "Arquivos",
          file: "Arquivo",
          media_files: "Arquivos de mídia",
          add_media_file: "Adicionar arquivo",
          media_type_code: "Tipo de mídia",
          extension_dependencies: "Possui dependência das extensões",
          extension_targets: "Disponível para os tipos de aplicação",
          enable: "Habilitar",
          is_required_setup: "Requer setup para instalação",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          actions: {
            default_settings: "Configurações padrão",
            price_rules: "Regras de preço",
          },
          defaultSettings: {
            default_settings: "Configurações padrão para: {{extension}}",
            default_setting: "Configuração padrão",
            identifier: "Identificador",
            property: "Propriedade",
            value: "Valor",
            description: "Descrição",
            search_identifier: "Pesquise por um identificador",
            add_default_setting: "Adicionar configuração padrão",
            new_default_setting: "Nova configuração padrão",
            is_public: "A configuração padrão da extensão é pública",
            errors: {
              identifier: "O identificador é obrigatório",
              value: "O valor é obrigatório",
              property: "A propriedade é obrigatória",
              description: "A descrição é obrigatória",
            },
            confirm: {
              title: "Deletar configuração padrão?",
              description:
                "Isso vai permanentemente deletar a configuração padrão",
            },
          },
          priceRules: {
            price_rules: "Regras de Preço para: {{extension}}",
            price_rule: "Regra de Preço",
            search_type: "Pesquise por um tipo",
            edit_price_rule: "Editar regra de preço",
            add_price_rule: "Adicionar Regra de Preço",
            type: "Tipo",
            initial_date: "Início vigência",
            end_date: "Fim vigênica",
            value: "Valor",
            errors: {
              type: "O tipo é obrigatório",
              initial_date: "O início vigência é obrigatório",
              end_date: "O fim vigência é obrigatório",
              value: "O valor é obrigatório",
            },
            confirm: {
              title: "Deletar regra de preço?",
              description: "Isso vai permanentemente deletar a regra de preço",
            },
          },
          errors: {
            display_order: "A ordem de apresentação é obrigatória",
            software: "O software é obrigatório",
            name: "O nome é obrigatório",
            title: "O título é obrigatório",
            tags: "Ao menos uma tag é obrigatória",
            file: "O Arquivo é obrigatório",
            file_type:
              "Apenas .jpg, .jpeg, .png and .webp são formatos suportados",
            file_size: "O tamanho máximo permitido é de 5MB",
            extension_targets: "Ao menos uma aplicação é obrigatória",
          },
        },
        cardsTemplates: {
          cards_templates: "Modelos de Carteirinhas",
          card_template: "Modelo de Carteirinha",
          search: "Pesquise por um modelo",
          new_card_template: "Novo Modelo de Carteirinha",
          add_card_template: "Adicionar Modelo de Carteirinha",
          initial_date: "Início vigência",
          end_date: "Fim vigência",
          health_plan: "Plano de saúde",
          enable: "Habilitar",
          establishment_param_type:
            "Tipo de parâmetro do estabelecimento para a frente",
          establishment_param_type_back:
            "Tipo de parâmetro do estabelecimento para o verso",
          confirm: {
            title: "Deletar modelo de carteirinha?",
            description:
              "Isso vai permanentemente deletar o modelo de carteirinha",
          },
          errors: {
            initial_date: "O início vigência é obrigatória",
            end_date: "O fim vigência é obrigatório",
            health_plan: "O nome do plano é obrigatório",
            establishment_param_type:
              "O tipo de parâmetro do estabelecimento para a frente é obrigatório",
            establishment_param_type_back:
              "O tipo de parâmetro do estabelecimento para o verso é obrigatório",
          },
        },
        companyGroups: {
          company_groups: "Grupos Empresariais",
          company_group: "Grupo Empresarial",
          new_company_group: "Novo grupo empresarial",
          search_company_groups: "Procure por grupo empresarial",
          add_company_group: "Adicionar grupo empresarial",
          name: "Nome",
          code: "Código",
          is_main: "Principal",
          enable: "Habilitar",
          filter_restriction_type: "Tipo de Restrição de Filtro",
          confirm: {
            title: "Deletar grupo empresarial?",
            description: "Isso vai permanentemente deletar o grupo empresarial",
          },
          errors: {
            name: "O nome é obrigatório",
            code: "O código é obrigatório",
            filter_restriction_type:
              "O tipo de restrição de filtro é obrigatório",
          },
        },
        paramDefaultEstablishment: {
          param_default_establishment: "Parâmetros padrão do estabelecimento",
          param_default: "Parâmetro padrão do estabelecimento",
          new_param_default: "Novo parâmetro padrão do estabelecimento",
          search_param: "Pesquise por um parâmetro",
          add_param: "Adicionar parâmetro padrão",
          establishment_param_type: "Tipo de parâmetro do estabelecimento",
          value: "Valor",
          description: "Descrição",
          confirm: {
            title: "Deletar parâmetro padrão do estabelecimento?",
            description:
              "Isso vai permanentemente deletar o parâmetro padrão do estabelecimento",
          },
          errors: {
            param_type: "O tipo de parâmetro do estabelecimento é obrigatório",
            value: "O valor é obrigatório",
            description: "A descrição é obrigatória",
          },
        },
        holidays: {
          holidays: "Feriados",
          holiday: "Feriado",
          new_holiday: "Novo feriado",
          search_holiday: "Pesquise por um feriado",
          add_holiday: "Adicionar feriado",
          name: "Nome",
          description: "Descrição",
          holiday_type: "Tipo de feriado",
          date: "Data",
          import_holidays: "Importar feriados nacionais",
          filter: "Filtro",
          confirm: {
            title: "Deletar feriado?",
            description: "Isso vai permanentemente deletar o feriado",
          },
          errors: {
            name: "O nome é obrigatório",
            description: "A descrição é obrigatória",
            holiday_type: "O tipo de feriado é obrigatório",
            date: "A data é obrigatória",
          },
        },
        individualValidation: {
          individual_validations: "Validação Cadastro PF",
          individual_validation: "Validação de Cadastro PF",
          search: "Pesquise por um cadastro",
          individual: "Pessoa Física",
          name: "Nome",
          document: "CPF",
          status: "Status",
          all: "Todos",
          approved: "Aprovado",
          disapproved: "Reprovado",
          pending: "Pendente de Aprovação",
          created: "Data de criação",
          photos_sent: "Fotos Enviadas",
          approve_registrations: "Aprovação de Cadastros",
          not_found: "Ops, cadastro não encontrado!",
          no_registrations:
            "Não há mais cadastros a serem validados, por favor, tente novamente mais tarde",
          birth_date: "Data de Nascimento",
          email: "E-mail",
          whatsapp_number: "Número do WhatsApp",
          approved_by: "Aprovado por",
          approved_at: "Aprovado em",
          disapproved_by: "Reprovado por",
          disapproved_at: "Reprovado em",
          copy: "Copiar",
          copied_successfully: "Copiado com sucesso",
          actions: {
            approved: "Cadastro aprovado com sucesso!",
            disapproved: "Cadastro reprovado com sucesso!",
            disapprove_modal: {
              title: "Deseja realmente reprovar o cadastro?",
              description: "Isso irá permanentemente reprovar o cadastro.",
              cancel: "Cancelar",
              confirm: "Sim, reprovar",
            },
            disapprove: "Reprovar",
            approve: "Aprovar",
          },
          photo_item: {
            person: "Pessoa",
            front_doc: "Documento Frente",
            back_doc: "Documento Verso",
            person_doc: "Pessoa com o Documento",
            error: "Ops, ocorreu um erro ao carregar a foto!",
          },
        },
      },
      additionalSettings: {
        additionalSettings: "Configurações adicionais",
        search: "Pesquise por uma configuração",
      },
      extensionsStore: {
        title: "Explore o máximo potencial do seu plano",
        subtitle:
          "Confira as extensões disponíveis para o seu plano e obtenha uma solução ainda mais completa para o seu negócio.",
        no_data: "Nenhuma extensão encontrada!",
        no_data_install:
          "Verifique as suas extensões já instaladas. Não há novas extensões para exibir.",
        no_data_installed:
          "Verifique as disponíveis na loja. Não há extensões instaladas para exibir.",
        installed_successfully: "Extensão instalada com sucesso",
      },
      noAccess: {
        message:
          "Ops! Parece que você não possui permissão para acessar essa página!",
        button: "Voltar para o início",
      },
      user_menu: {
        preferences: "Preferências",
        theme: "Tema",
        theme_description: "Alternar entre o tema claro e escuro",
        language: "Idioma",
        language_description: "Selecione o idioma do sistema",
        establishment: "Estabelecimento",
        establishment_description:
          "Definir estabelecimento padrão ao logar no sistema",
        notifications: "Ativar notificações sonoras e do navegador",
        notifications_description:
          "Receba um alerta sonoro e uma notificação do navegador",
        notifications_blocked:
          "As notificações estão bloqueadas nas configurações do navegador",
      },
      settings: {
        settings: "Configurações",
        general: "Gerais",
        cache: "Cache",
        "4uBus": {
          configs: {
            configs: "Configurações gerais",
            config: "Configuração geral",
            new_config: "Nova configuração geral",
            search: "Pesquise por uma configuração geral",
            add_config: "Adicionar configuração geral",
            host_4ubus: "Host do 4uBus",
            host_aws: "Host da AWS",
            host_postgres_api: "Host da API Postgres",
            establishment: "Estabelecimento",
            confirm: {
              title: "Deletar configuração geral?",
              description:
                "Isso vai permanentemente deletar a configuração geral",
            },
            errors: {
              host_4ubus: "O host do 4uBus é obrigatório",
              host_aws: "O host do AWS é obrigatório",
              host_4ubus_https:
                "O host do 4uBus precisa começar com 'http://' ou 'https://'",
              host_aws_https:
                "O host da AWS precisa começar com 'http://' ou 'https://'",
              host_postgres_api_https:
                "O host da API Postgres precisa começar com 'http://' ou 'https://'",
            },
          },
          ipm: {
            generalSettings: {
              general_settings: "Configurações gerais IPM",
              general_setting: "Configuração geral IPM",
              new_general_setting: "Nova configuração geral IPM",
              search: "Pesquise por uma configuração geral",
              add_general_setting: "Adicionar configuração geral",
              host: "Host",
              hostAuth: "Host autorização",
              establishment: "Estabelecimento",
              ipm_user: "Usuário IPM",
              ipm_password: "Senha IPM",
              token_4ubus: "Token do 4uBus",
              token_copy: "Copiar token",
              token_copied: "Token do 4uBus copiado com sucesso",
              itens_per_batch: "Itens por lote",
              total_batches: "Total de lotes",
              ipm_version: "Versão da IPM",
              heart_beat_time_minutes:
                "Tempo de verificação de lote em minutos",
              establishment_codes:
                "Código dos estabelecimentos de envio (separados por vírgula)",
              confirm: {
                title: "Deletar configuração geral?",
                description:
                  "Isso vai permanentemente deletar a configuração geral",
              },
              errors: {
                host: "O host é obrigatório",
                ipm_user: "O usuário IPM é obrigatório",
                ipm_password: "A senha IPM é obrigatória",
                token_4ubus: "O token do 4uBus é obrigatório",
                host_https:
                  "O host precisa começar com 'http://' ou 'https://'",
                itens_per_batch: "Os itens por lote são obrigatórios",
                total_batches: "O total de lotes é obrigatório",
                heart_beat_time_minutes:
                  "O tempo de verificação de lote em minutos é obrigatório",
                establishment_codes:
                  "Código dos estabelecimentos de envio é obrigatório",
                ipm_version: "A versão da IPM é obrigatória",
              },
            },
          },
          zScan: {
            examSendRule: {
              exam_send_rules: "Regras de envio de exames",
              exam_send_rule: "Regra de envio de exames",
              add_exam_send_rule: "Adicionar regra de envio de exames",
              new_exam_send_rule: "Nova regra de envio de exames",
              target_machine: "Máquina de destino",
              proc_classification_integration_id:
                "Id de Classificação do Procedimento",
              initial_date: "Data de início",
              end_date: "Data de fim",
              enable: "Ativar",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              errors: {
                target_machine: "A máquina de destino é obrigatória",
                proc_classification_integration_id:
                  "O id de classificação do procedimento é obrigatório",
                initial_date: "A data de início é obrigatória",
                end_date: "A data de fim é obrigatória",
                initial_date_bigger:
                  "A data de início não pode ser maior que a de fim",
              },
              confirm: {
                title: "Deletar regra de envio de exames?",
                description:
                  "Isso vai permanentemente deletar a regra de envio de exames",
              },
            },
          },
          externalExamPrescription: {
            rules: {
              rules: "Regras de Geração de Prescrição",
              rule: "Regra de Geração de Prescrição",
              new_rule: "Nova regra de geração de prescrição",
              add_rule: "Adicionar regra de geração de prescrição",
              search: "Pesquise por uma regra de geração de prescrição",
              medical_procedure_type_code:
                "Código do Tipo de Procedimento Médico",
              sector_code: "Código do Setor",
              exec_physician_code: "Código do Médico Executor",
              patient_insurance_code: "Código do Convênio do Paciente",
              initial_date: "Data de Início",
              end_date: "Data de Fim",
              is_exception: "É Exceção",
              yes: "Sim",
              no: "Não",
              if: "Se",
              then: "Então",
              exception: "Exceção (Não gera prescrição)",
              errors: {
                initial_date: "A data de início é obrigatória",
                end_date: "A data de fim é obrigatória",
                initial_date_bigger:
                  "A data de início não pode ser maior que a de fim",
                medical_procedure_type_code:
                  "O código do tipo de procedimento é obrigatório",
                sector_code: "O código do setor é obrigatório",
                execPhysicianCode: "O código do médico executor é obrigatório",
                max_medical_procedure_type_code:
                  "O código do tipo de procedimento médico não pode ter mais de 3 caracteres",
                max_sector_code:
                  "O código do setor não pode ter mais de 5 caracteres",
                max_exec_physician_code:
                  "O código do médico executor não pode ter mais de 10 caracteres",
                max_patient_insurance_code:
                  "O código do convênio do paciente não pode ter mais de 5 caracteres",
              },
              confirm: {
                title: "Deletar regra de geração de prescrição?",
                description:
                  "Isso vai permanentemente deletar a regra de geração de prescrição",
              },
            },
          },
        },
        crm: {
          ticketAutoFinishRules: {
            ticket_auto_finish_rules: "Regras de Finalização de Ticket(Card)",
            ticket_auto_finish_rule: "Regra de Finalização de Ticket(Card)",
            add_ticket_auto_finish_rule:
              "Adicionar regra de finalização de ticket(card)",
            new_ticket_auto_finish_rule:
              "Nova regra de finalização de ticket(card)",
            search: "Pesquise por uma regra de finalização de ticket(card)",
            message: "Mensagem",
            minutes: "Minutos",
            initial_date: "Data de início",
            end_date: "Data de fim",
            finish_type: "Tipo de Finalização",
            finish_by_time: "Por Tempo",
            finish_end_of_day: "Ao Fim do Dia",
            finish_not_selected: "Não Selecionado",
            enable: "Ativo",
            active: "Sim",
            inactive: "Não",
            finish_rule: "Finalizar",
            finish: "Finalizado",
            end_of_day: "Finalizar ao fim do dia (00:00)",
            finish_indifferent_person:
              "Finalizar indiferente da pessoa da interação",
            ticket_type: "Tipo de ticket(card)",
            ticket_channel: "Quadro",
            ticket_channel_step: "Lista do quadro",
            ticket_workspace: "Área de trabalho",
            move_finished_to: "Mover finalizado para",
            ticket_channel_step_transfer: "Mover finalizado para lista",
            message_helper:
              "A variável {{protocolNumber}} será substituída pelo número do protocolo atribuído ao ticket(card)",
            confirm: {
              title: "Deletar regra de finalização de ticket(card)?",
              description:
                "Isso vai permanentemente deletar a regra de finalização de ticket(card)",
            },
            errors: {
              minutes: "Os minutos são obrigatórios",
              max_minutes: "O valor não pode ser maior que 1440",
              ticket_type: "O tipo de ticket(card) é obrigatório",
              ticket_channel: "O quadro é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              end_date_less: "A data de fim não pode ser menor que a de início",
              message: "A mensagem é obrigatória",
              ticket_workspace: "A área de trabalho é obrigatória",
              ticket_channel_step: "A lista do quadro é obrigatória",
            },
          },
          ticketAutoTransferRules: {
            ticket_auto_transfer_rules:
              "Regras de Transferência de Ticket(Card)",
            ticket_auto_transfer_rule: "Regra de Transferência de Ticket(Card)",
            add_ticket_auto_transfer_rule:
              "Adicionar regra de transferência de ticket(card)",
            new_ticket_auto_transfer_rule:
              "Nova regra de transferência de ticket(card)",
            search: "Pesquise por uma regra de transferência de ticket(card)",
            message: "Mensagem",
            minutes: "Minutos",
            initial_date: "Data de início",
            end_date: "Data de fim",
            transfer: "Transferir",
            transfer_type: "Tipo de Transferência",
            transfer_by_time: "Por Tempo",
            transfer_end_of_day: "Ao Fim do Dia",
            transfer_not_selected: "Não Selecionado",
            enable: "Ativo",
            active: "Sim",
            inactive: "Não",
            transfer_indifferent_person:
              "Transferir  indiferente da pessoa da interação",
            end_of_day: "Transferir ao fim do dia (00:00)",
            transfer_to: "Transferir para",
            transfering: "Transferindo",
            ticket_type: "Tipo de ticket(card)",
            ticket_channel: "Quadro",
            ticket_channel_step: "Lista do quadro",
            ticket_channel_transfer: "Transferir para o quadro",
            ticket_channel_step_transfer: "Transferir para lista",
            ticket_workspace: "Área de trabalho",
            ticket_service: "Serviço de ticket(card)",
            ticket_service_area: "Área de atendimento",
            ticket_auto_transfer_rule_hour_atend:
              "Tipo de horário de atendimento",
            message_helper:
              "A variável {{protocolNumber}} será substituída pelo número do protocolo atribuído ao ticket(card)",
            confirm: {
              title: "Deletar regra de transferência de ticket(card)?",
              description:
                "Isso vai permanentemente deletar a regra de transferência de ticket(card)",
            },
            errors: {
              minutes: "Os minutos são obrigatórios",
              max_minutes: "O valor não pode ser maior que 1440",
              ticket_type: "O tipo de ticket(card) é obrigatório",
              ticket_channel: "O quadro é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              end_date_less: "A data de fim não pode ser menor que a de início",
              message: "A mensagem é obrigatória",
              ticket_workspace: "A área de trabalho é obrigatória",
              ticket_channel_step: "A lista do quadro é obrigatória",
              ticket_channel_step_transfer:
                "A lista do quadro para transferência é obrigatória",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              ticket_auto_transfer_rule_hour_atend:
                "O tipo de horário de atendimento é obrigatório",
            },
          },
          sendLimitMonths: {
            send_limits_months:
              "Limites de Disparo Mensal (Orçamento da Empresa)",
            send_limit_months:
              "Limite de Disparo Mensal (Orçamento da Empresa)",
            search: "Pesquise por um limite de disparo mensal",
            add_send_limit_months: "Adicionar limite de disparo mensal",
            new_send_limit_months: "Novo limite de disparo mensal",
            active: "Ativo",
            enabled: "Sim",
            disabled: "Não",
            enable: "Habilitar",
            name: "Nome",
            ticket_service: "Serviço de ticket(card)",
            start_date: "Data de início",
            end_date: "Data de fim",
            quantity: "Quantidade",
            alert_percent_limit: "Percentual de alerta",
            alert_mail: "E-mails de alerta (use ; para separar os e-mails)",
            description: "Descrição",
            confirm: {
              title: "Deletar limite de disparo mensal?",
              description:
                "Isso vai permanentemente deletar o limite de disparo mensal",
            },
            errors: {
              name: "O nome é obrigatório",
              ticket_service: "Informe o serviço de ticket",
              start_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              end_date_less: "A data de fim não pode ser menor que a de início",
              value_limit: "A quantidade limite é obrigatória",
              alert_mail: "Informe ao menos um e-mail",
              alert_percent_limit:
                "O percentual de alerta deve ser entre 0 e 100",
            },
          },
          sendLimitDiaries: {
            send_limits_diaries:
              "Limites de Disparo Diário (Orçamento da Empresa)",
            send_limit_diaries:
              "Limite de Disparo Diário (Orçamento da Empresa)",
            search: "Pesquise por um limite de disparo diário",
            add_send_limit_diaries: "Adicionar limite de disparo diário",
            new_send_limit_diaries: "Novo limite de disparo diário",
            active: "Ativo",
            enabled: "Sim",
            disabled: "Não",
            enable: "Habilitar",
            name: "Nome",
            ticket_service: "Serviço de ticket(card)",
            start_date: "Data de início",
            end_date: "Data de fim",
            automation: "Automação (Opcional)",
            quantity: "Quantidade",
            alert_mail: "E-mails de alerta (use ; para separar os e-mails)",
            description: "Descrição",
            confirm: {
              title: "Deletar limite de disparo diário?",
              description:
                "Isso vai permanentemente deletar o limite de disparo diário",
            },
            errors: {
              name: "O nome é obrigatório",
              ticket_service: "Informe o serviço de ticket",
              start_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              end_date_less: "A data de fim não pode ser menor que a de início",
              value_limit: "A quantidade limite é obrigatória",
              alert_mail: "Informe ao menos um e-mail",
            },
          },
          protocolsDefault: {
            protocols_default: "Protocolos de Orientações Padrão",
            protocol_default: "Protocolo de Orientações Padrão",
            new_protocol_default: "Novo protocolo de orientações padrão",
            add_protocol_default: "Adicionar protocolo de orientações padrão",
            ticket_automation: "Automações",
            button_type: "Tipo de Botão",
            add: "Adicionar Botão",
            button_title: "Botões",
            label: "Label",
            value: "Valor",
            link: "Link",
            counter_hint: "Quantidade atual / máximo permitido",
            search: "Pesquise por um protocolo de orientações padrão",
            title: "Título",
            message: "Mensagem",
            restriction_type: "Tipo de restrição",
            category: "Categoria",
            workspace: "Área de trabalho",
            workspaces: "Áreas de trabalho",
            restriction_type_board: "Quadro",
            channel: "Canal",
            channels: "Canais",
            file: "Arquivo",
            description: "Descrição",
            media_files: "Arquivos de mídia",
            add_media_file: "Adicionar arquivo",
            enable: "Ativar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            buttons_no_integligence_warning:
              "Esses botões não tem nenhuma inteligência, nem ação automática por parte da plataforma 4uHub. Sendo de total responsabilidade e risco do usuário.",
            confirm: {
              title: "Deletar o protocolo de orientações padrão?",
              description:
                "Isso vai permanentemente deletar o protocolo de orientações padrão",
            },
            errors: {
              title: "O título é obrigatório",
              message: "A mensagem é obrigatória",
              restriction_type: "O tipo de restrição é obrigatório",
              category: "A categoria é obrigatória",
              workspaces: "Ao menos uma área de trabalho é obrigatória",
              channels: "Ao menos um canal é obrigatório",
              description: "A descrição é obrigatória",
              file: "O arquivo é obrigatório",
              media_files: "Ao menos um arquivo de mídia é obrigatório",
              value: "O valor é obrigatório",
              label: "O label é obrigatório",
              min_description: "A descrição é obrigatória",
              max_description:
                "A descrição não pode ter mais de 1000 caracteres",
              button_link_required:
                "O botão deve conter um link válido (http ou https).",
            },
          },
          ticketDefaultDocCategories: {
            ticket_default_doc_categories:
              "Categorias de Protocolos de Orientações Padrão",
            ticket_default_doc_category:
              "Categoria de Protocolo de Orientações Padrão",
            new_ticket_default_doc_category:
              "Nova categoria de protocolo de orientações padrão",
            add_ticket_default_doc_category:
              "Adicionar categoria de protocolo de orientações padrão",
            search:
              "Pesquise por uma categoria de protocolo de orientações padrão",
            code: "Código",
            name: "Nome",
            confirm: {
              title: "Deletar categoria de protocolo de orientações padrão?",
              description:
                "Isso vai permanentemente deletar a categoria de protocolo de orientações padrão",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          events: {
            events: "Eventos",
            event: "Evento",
            new_event: "Novo evento",
            add_event: "Adicionar evento",
            search: "Pesquise por um evento",
            name: "Nome",
            event_type: "Tipo de evento",
            code: "Código",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            manage_event_types: "Gerenciar tipos de evento",
            ticket_automations: "Automações",
            confirm: {
              title: "Deletar evento?",
              description: "Isso vai permanentemente deletar o evento",
            },
            errors: {
              name: "O nome é obrigatório",
              event_type: "O tipo de evento é obrigatório",
              code: "O código é obrigatório",
            },
          },
          eventTypes: {
            event_types: "Tipos de Evento",
            event_type: "Tipo de Evento",
            new_event_type: "Novo tipo de evento",
            add_event_type: "Adicionar tipo de evento",
            search: "Pesquise por um tipo de evento",
            name: "Nome",
            enable: "Habilitar",
            code: "Código",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar tipo de evento?",
              description: "Isso vai permanentemente deletar o tipo de evento",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          externalProcessType: {
            external_process_types: "Tipos de Processos Externos",
            external_process_type: "Tipo de Processo Externo",
            add_external_process_type: "Adicionar tipo de processo externo",
            new_external_process_type: "Novo tipo de processo externo",
            search: "Pesquise por um tipo de processo externo",
            name: "Nome",
            confirm: {
              title: "Deletar o tipo de processo externo?",
              description:
                "Isso vai permanentemente deletar o tipo de processo externo",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          ticketAutoInactivityRules: {
            ticket_auto_inactivity_rules:
              "Regras de Inatividade de Ticket(Card)",
            ticket_auto_inactivity_rule: "Regra de Inatividade de Ticket(Card)",
            add_ticket_auto_inactivity_rule:
              "Adicionar regra de inatividade de ticket(card)",
            new_ticket_auto_inactivity_rule:
              "Nova regra de inatividade de ticket(card)",
            search: "Pesquise por uma regra de inatividade de ticket(card)",
            ticket_channel: "Quadro",
            ticket_channel_step: "Lista do quadro",
            minutes: "Minutos",
            initial_date: "Data de início",
            end_date: "Data de fim",
            ticket_type: "Tipo de ticket(card)",
            ticket_workspace: "Área de trabalho",
            message: "Mensagem",
            confirm: {
              title: "Deletar regra de inatividade de ticket(card)?",
              description:
                "Isso vai permanentemente deletar o regra de inatividade de ticket(card)",
            },
            errors: {
              minutes: "Valor mínimo obrigatório de 5 minutos",
              max_minutes: "O valor não pode ser maior que 1440",
              ticket_type: "O tipo de ticket(card) é obrigatório",
              ticket_channel: "O quadro é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              end_date_less: "A data de fim não pode ser menor que a de início",
              ticket_workspace: "A área de trabalho é obrigatória",
            },
          },
        },
        preventMedicine: {
          workGroupTypes: {
            work_group_types: "Tipos de Grupo de Trabalho",
            work_group_type: "Tipo de Grupo de Trabalho",
            new_work_group_type: "Novo tipo de grupo de trabalho",
            add_work_group_type: "Adicionar tipo de grupo de trabalho",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            languages: "Idiomas",
            language: "Idioma",
            add_language: "Adicionar idioma",
            name: "Nome",
            description: "Descrição",
            search: "Pesquise por um grupo de trabalho",
            confirm: {
              title: "Deletar tipo de grupo de trabalho?",
              description:
                "Isso vai permanentemente deletar o tipo de grupo de trabalho",
            },
            errors: {
              name: "O nome é obrigatório",
              language: "O idioma é obrigatório",
            },
          },
          healthProgramTypes: {
            health_program_types: "Tipos de Programas de Saúde",
            health_program_type: "Tipo de Programa de Saúde",
            new_health_program_type: "Novo tipo de programa de saúde",
            add_health_program_type: "Adicionar Tipo de Programa de Saúde",
            search: "Pesquise por um tipo de programa de saúde",
            name: "Nome",
            language: "Idioma",
            description: "Descrição",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            characters: "caracteres",
            add_language: "Adicionar idioma",
            confirm: {
              title: "Deletar tipo de programa de saúde?",
              description:
                "Isso vai permanentemente deletar o tipo de programa de saúde",
            },
            errors: {
              name: "O nome é obrigatório",
              description: "A descrição não pode ter mais de 500 caracteres",
            },
          },
        },
        generalSettings: {
          healthChecks: {
            health_checks: "Health Checks de Microsserviços 4uHub",
            health_check: "Health Check de Microsserviços 4uHub",
            new_health_check: "Novo health check de microsserviços 4uHub",
            add_health_check: "Adicionar Health Check de Microsserviços 4uHub",
            search: "Pesquise por um health check de microsserviços 4uHub",
            name: "Nome",
            uri: "URI",
            establishment: "Estabelecimento",
            payload: "Payload de falha",
            restored_payload: "Payload de restauração",
            webhook_url: "URL do Webhook",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar health check de microsserviços 4uHub?",
              description:
                "Isso vai permanentemente deletar o health check de microsserviços 4uHub",
            },
            errors: {
              name: "O nome é obrigatório",
              uri: "O URI é obrigatório",
              payload: "O payload de falha é obrigatório",
              restored_payload: "O payload de restauração é obrigatório",
              webhook_url: "A URL do Webhook é obrigatória",
              webhook_url_http:
                "A URL do Webhook precisa começar com 'http://' ou 'https://'",
              establishment: "O estabelecimento é obrigatório",
            },
          },
        },
        schedule: {
          scheduleCheckIn: {
            schedule_check_in: "Check In",
            add_schedule_check_in: "Adicionar check in",
            new_schedule_check_in: "Novo check in",
            meters_approximation: "Aproximação em metros",
            time: "Tempo em minutos",
            meters: "m.",
            min: "min.",
            latitude: "Latitude",
            longitude: "Longitude",
            help_time:
              "Informe o tempo em minutos antes da consulta, que será permitido realizar o check in de um agendamento",
            help_meters:
              "Informe a aproximação em metros antes da consulta, que será permitido realizar o check in de um agendamento",
            confirm: {
              title: "Deletar check in?",
              description: "Isso vai permanentemente deletar o check in",
            },
            errors: {
              meters_approximation: "A aproximação em metros é obrigatória",
              time: "O tempo em minutos é obrigatório",
              latitude: "A latitude é obrigatória",
              longitude: "A longitude é obrigatória",
            },
          },
          scheduleFilterUser: {
            schedule_filter_user: "Filtro de Agenda do Usuário",
            add_schedule_filter_user: "Adicionar filtro de agenda do usuário",
            new_schedule_filter_user: "Novo filtro de agenda do usuário",
            user: "Usuário",
            scheduleFilterUserCalendars: "Agendas",
            confirm: {
              title: "Deletar filtro de agenda do usuário?",
              description:
                "Isso vai permanentemente deletar o filtro de agenda do usuário",
            },
            errors: {
              user: "O usuário é obrigatório",
              scheduleFilterUserCalendars: "As agendas são obrigatórias",
            },
          },
          scheduleConfirmation: {
            schedule_confirmation: "Confirmação de Agenda",
            add_schedule_confirmation: "Adicionar confirmação de agenda",
            new_schedule_confirmation: "Nova confirmação de agenda",
            time: "Tempo em minutos",
            min: "min.",
            help: "Informe o tempo em minutos antes da consulta, que será permitido realizar a confirmação de um agendamento",
            confirm: {
              title: "Deletar confirmação de agenda?",
              description:
                "Isso vai permanentemente deletar a confirmação de agenda",
            },
            errors: {
              time: "O tempo em minutos é obrigatório",
            },
          },
          tasySchedMenu: {
            menu_scheduling_portal_app: "Menu Agendamento Portal e APP",
            add_menu_scheduling_portal_app:
              "Adicionar Menu de Agendamento Portal e APP",
            new_menu_scheduling_portal_app:
              "Novo Menu de Agendamento Portal e APP",
            name: "Nome",
            custom_message: "Mensagem personalizada",
            display_order: "Ordem de Exibição",
            ticket_automation_received_rule: "Regra de Automação Recebida",
            search: "Pesquise por um Menu de Agendamento Portal e APP",
            confirm: {
              title: "Deletar Menu de Agendamento Portal e APP?",
              description:
                "Isso vai permanentemente deletar o Menu de Agendamento Portal e APP",
            },
            errors: {
              name: "O nome é obrigatório",
              display_order: "A ordem de exibição é obrigatória",
              rule_or_custom_message:
                "Informe uma regra de automação recebida ou uma mensagem personalizada",
              custom_message_with_rule:
                "A mensagem personalizada só pode ser preenchida quando não houver regra de recebimento selecionada",
              ticket_automation_received_rule:
                "A regra de automação recebida é obrigatória",
            },
          },
        },
        system: {
          executeSql: {
            execute_sql: "Executar SQL",
            execute_successfully: "SQL executado com sucesso",
            clean: "Limpar",
            execute: "Executar",
            errors: {
              sql: "O código SQL é obrigatório",
            },
          },
        },
        siteApp: {
          siteAppCheckIn: {
            site_app_check_in: "Check In da Triagem PA Digital",
            add_site_app_check_in: "Adicionar check in",
            new_site_app_check_in: "Novo check in",
            meters_approximation: "Aproximação em metros",
            patient_encounter_physician_code:
              "Código do médico do atendimento do paciente",
            sector_accommodation_type: "Tipo de acomodação do setor",
            patient_encounter_origin_code:
              "Código de origem do atendimento do paciente",
            patient_encounter_type_code:
              "Código de origem do tipo de atendimento",
            time: "Tempo em minutos",
            meters: "m.",
            min: "min.",
            latitude: "Latitude",
            longitude: "Longitude",
            help_time:
              "Informe o tempo em minutos antes da consulta, que será permitido realizar o check in de um agendamento",
            help_meters:
              "Informe a aproximação em metros antes da consulta, que será permitido realizar o check in de um agendamento",
            standard_service_sector_code: "Código Setor Atendimento Padrão",
            standard_service_unit: "Unidade atendimento padrão",
            insurance_allow_checkin: "Convênios permitidos",
            confirm: {
              title: "Deletar check in?",
              description: "Isso vai permanentemente deletar o check in",
            },
            errors: {
              meters_approximation: "A aproximação em metros é obrigatória",
              time: "O tempo em minutos é obrigatório",
              latitude: "A latitude é obrigatória",
              longitude: "A longitude é obrigatória",
              standard_service_sector_code:
                "O código setor atendimento padrão é obrigatório",
              standard_service_unit:
                "A unidade atendimento padrão é obrigatório",
              patient_encounter_origin_code:
                "O código de origem do atendimento é obrigatório",
              sector_accommodation_type:
                "O tipo de acomodação do setor é obrigatório",
              patient_encounter_physician_code:
                "O código do médico do atendimento é obrigatório",
              patient_encounter_type_code:
                "O código de origem do tipo de atendimento é obrigatório",
            },
          },
          siteAppConfirmation: {
            site_app_confirmation: "Confirmação de Agenda",
            add_site_app_confirmation: "Adicionar confirmação de agenda",
            new_site_app_confirmation: "Nova confirmação de agenda",
            time: "Tempo em minutos",
            min: "min.",
            help: "Informe o tempo em minutos antes da consulta, que será permitido realizar a confirmação de um agendamento",
            confirm: {
              title: "Deletar confirmação de agenda?",
              description:
                "Isso vai permanentemente deletar a confirmação de agenda",
            },
            errors: {
              time: "O tempo em minutos é obrigatório",
            },
          },
        },
        quickAnswer: {
          quick_answers: "Mensagens Rápidas",
          quick_answer: "Mensagem Rápida",
          new_quick_answer: "Nova mensagem rápida",
          search: "Pesquise por uma mensagem rápida",
          add: "Adicionar mensagem rápida",
          title: "Título",
          shortcut: "Atalho",
          message: "Mensagem",
          inactive_quick_answer: "Inativar",
          share_type: "Tipo de compartilhamento",
          user: "Usuário",
          ticket_workspace: "Área de trabalho",
          ticket_channel: "Quadro",
          inactive: {
            title: "Inativar a mensagem rápida?",
            description: "Isso vai permanentemente inativar a mensagem rápida.",
            cancel: "Cancelar",
            confirm: "Sim, inativar",
            success: "Mensagem rápida inativada com sucesso",
          },
          errors: {
            title: "O título é obrigatório",
            message: "A mensagem é obrigatória",
            shortcut: "O atalho é obrigatório",
            share_type: "O tipo de compartilhamento é obrigatório",
            user: "O usuário é obrigatório",
            ticket_workspace: "A área de trabalho é obrigatória",
            ticket_channel: "O quadro é obrigatório",
          },
        },
      },
      extensionSettings: {
        extension_settings:
          "Configurações da extensão para '{{extension}}' em '{{siteApp}}'",
        add_extension_config: "Adicionar configuração à extensão",
        extension_config: "Configuração da extensão",
        new_extension_config: "Nova configuração da extensão",
        search_config: "Pesquise por uma configuração",
        identifier: "Identificador",
        property: "Propriedade",
        public: "Público",
        true: "Sim",
        false: "Não",
        value: "Valor",
        description: "Descrição",
        is_public: "A configuração da extensão é pública",
        is_public_info:
          "Aqui tratamos questões relacionadas a segurança da aplicação. Se uma configuração é pública, significa que conseguimos acessá-la sem autenticação. Dados considerados sigilosos, como um token, nunca devem ser marcados como públicos",
        save_in_establishment:
          "Salvar configurações para todos os sites e apps do estabelecimento",
        confirm: {
          title: "Deletar configuração da extensão?",
          description:
            "Isso vai permanentemente deletar configuração da extensão",
        },
        switchEnableDisableConfig: {
          enabled: "Ativado",
          disabled: "Desativado",
        },
        enableDisableConfig: {
          enable: "Ativar",
          disable: "Desativar",
        },
        errors: {
          identifier: "O identificador é obrigatório",
          property: "A propriedade é obrigatória",
          value: "O valor é obrigatório",
          description: "A descrição é obrigatória",
        },
      },
      jobs: {
        title: "Você foi redirecionado para o painel de Jobs",
        subtitle: "Para acessar novamente clique no botão abaixo",
        button: "Acessar",
      },
      "4uHcp": {
        hcp: {
          healthPrograms: {
            enable: "Habilitar",
            active: "Ativo",
            inactive: "Inativo",
            health_programs: "Programas de Saúde",
            health_program: "Programa de Saúde",
            new_health_program: "Novo programa de saúde",
            search: "Pesquise por um programa de saúde",
            add_health_program: "Adicionar programa de saúde",
            languages: "Idiomas",
            health_program_type: "Tipo de programa de saúde",
            health_program_work_groups: "Grupos de trabalho",
            health_program_content_rules: "Regras de conteúdo",
            add_health_program_content_rule: "Adicionar regra de conteúdo",
            applications: "Aplicações",
            work_groups: "Grupos de trabalho",
            add_language: "Adicionar idioma",
            name: "Nome",
            language: "Idioma",
            description: "Descrição",
            participants: "Participantes",
            imports: "Importações",
            fundraising: "Captações",
            confirm: {
              title: "Deletar programa de saúde?",
              description:
                "Isso vai permanentemente deletar o programa de saúde",
            },
            errors: {
              health_program_type: "O tipo de programa de saúde é obrigatório",
              site_apps: "Ao menos uma aplicação é obrigatória",
              languages: "Ao menos um idioma é obrigatório",
              language: "O idioma é obrigatório",
              name: "O nome é obrigatório",
            },
          },
          healthProgramsContentRules: {
            health_programs_content_rules:
              "Regras de Conteúdo dos Programas de Saúde",
            health_program_content_rule:
              "Regra de Conteúdo do Programa de Saúde",
            new_health_program_content_rule:
              "Nova regra de conteúdo do programa de saúde",
            search: "Pesquise por uma regra de conteúdo do programa de saúde",
            add_health_program_content_rule:
              "Adicionar regra de conteúdo do programa de saúde",
            content_view_type_hcp: "Tipo de Visualização do Conteúdo",
            name: "Nome",
            health_program: "Programa de saúde",
            initial_date: "Data de início",
            end_date: "Data de fim",
            contents: "Conteúdos da regra",
            confirm: {
              title: "Deletar regra de conteúdo do programa de saúde?",
              description:
                "Isso vai permanentemente deletar a regra de conteúdo do programa de saúde",
            },
            errors: {
              name: "O nome é obrigatório",
              health_program: "O programa de saúde é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              initial_date_greater:
                "A data de de fim não pode ser menor que a de início",
              content_view_type_hcp: "O tipo de visualização do conteúdo",
            },
          },
          rulesContents: {
            rules_contents: "Conteúdos da Regra",
            rule_content: "Conteúdo da Regra",
            new_rule_content: "Novo conteúdo da regra",
            search: "Pesquise por um conteúdo da regra",
            add_rule_content: "Adicionar conteúdo da regra",
            title: "Título",
            publication_date: "Data de publicação",
            content_status: "Status do conteúdo",
            published: "Publicado",
            not_published: "Não publicado",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar conteúdo da regra?",
              description:
                "Isso vai permanentemente deletar o conteúdo da regra",
            },
          },
          workGroups: {
            work_groups: "Grupos de Trabalho",
            work_group: "Grupo de Trabalho",
            new_work_group: "Novo grupo de trabalho",
            add_work_group: "Adicionar grupo de trabalho",
            search: "Pesquise por um grupo de trabalho",
            name: "Nome",
            languages: "Idiomas",
            add_language: "Adicionar idioma",
            language: "Idioma",
            description: "Descrição",
            work_group_type: "Tipo de grupo de trabalho",
            work_group_members: "Membros do grupo de trabalho",
            confirm: {
              title: "Deletar grupo de trabalho?",
              description:
                "Isso vai permanentemente deletar o grupo de trabalho",
            },
            errors: {
              work_group_type: "O tipo de grupo de trabalho é obrigatório",
              languages: "Ao menos um idioma é obrigatório",
              name: "O nome é obrigatório",
              language: "O idioma é obrigatório",
            },
          },
          participants: {
            participants: "Participantes",
            participant: "Participante",
            new_participant: "Novo participante",
            add_participant: "Adicionar participante",
            search: "Pesquise por um participante",
            name: "Nome",
            document: "CPF",
            status: "Status",
            history: "Histórico",
            active: "Ativo",
            formerMember: "Ex-Membro",
            membersHistory: {
              title: "Histórico",
              initialDate: "Data de entrada",
              endDate: "Data de saída",
              noEndDate: "Sem data de fim",
            },
            confirm: {
              title: "Deletar participante?",
              description: "Isso vai permanentemente deletar o participante",
            },
          },
          fundraising: {
            fundraising: "Captações",
            healthProgram: "Programa de saúde",
            captation: "Captação",
            new_captation: "Nova captação",
            add: "Adicionar Captação",
            search: "Pesquise por uma captação",
            name: "Nome",
            individual: "Pessoa física",
            document: "CPF",
            health_program: "Programa de saúde",
            captation_type: "Tipo de captação",
            captation_status: "Status da captação",
            approve_captation: "Aprovar captação",
            approved_successfully: "Captação aprovada com sucesso",
            disapprove_captation: "Desaprovar captação",
            disapproved_successfully: "Captação desaprovada com sucesso",
            denial_reason: "Motivo (opcional)",
            cancel: "Cancelar",
            disapprove: "Desaprovar",
            confirm: {
              title: "Deletar Captação?",
              description: "Isso vai permanentemente deletar a captação",
            },
            errors: {
              individual: "A pessoa física é obrigatória",
              health_program_type: "O tipo de programa de saúde é obrigatório",
              captation_status: "O status da captação é obrigatório",
            },
          },
          healthProgramImports: {
            imports: "Importações",
            healthProgram: "Programa de saúde",
            import: "Importação",
            add_import: "Adicionar importação",
            new_import: "Nova importação",
            search: "Pesquise por uma importação",
            file_name: "Nome do arquivo",
            import_person_name: "Nome do importador",
            origin_of_demand: "Origem da demanda",
            error_message: "Mensagem de erro",
            status: "Status",
            download_template: "Baixar modelo",
            health_program: "Programa de saúde",
            errors: {
              file: "O arquivo é obrigatório",
              import_person_name: "O nome do importador é obrigatório",
              health_program: "O programa de saúde é obrigatório",
            },
          },
        },
      },
      "4uBus": {
        register: {
          accessTokens: {
            access_tokens: "Tokens Externos",
            access_token: "Token externo",
            new_access_token: "Novo token externo",
            add_access_token: "Adicionar token externo",
            search: "Pesquise por um token externo",
            name: "Nome",
            code: "Código",
            privileges: "Privilégios",
            token_public: "Token público",
            copied_token: "Token público copiado com sucesso",
            copy: "Copiar token público",
            created: "Data de criação",
            individual: "Pessoa física",
            legal_entity: "Pessoa jurídica",
            software: "Software",
            justification: "Justificativa",
            description: "Descrição",
            is_integration: "Token de integração",
            restriction_rule_profiles: "Perfis de regras de restrição",
            extension: "Extensão",
            profiles: "Perfis",
            no_extensions_found:
              "Não é possível cadastrar Token de Acesso, pois não possui nenhuma extensão de endpoints de Barramento Instalada.",
            confirm: {
              title: "Deletar token externo?",
              description: "Isso vai permanentemente deletar o token externo",
            },
            errors: {
              name: "O nome é obrigatório",
              privileges: "Ao menos um privilégio é obrigatório",
            },
          },
          profileTasyBus: {
            profile_tasy_bus: "Perfil Externo",
            search: "Pesquise por um perfil externo",
            add_profile_tasy_bus: "Adicionar perfil externo",
            new_profile_tasy_bus: "Novo perfil externo",
            name: "Nome",
            extension: "Extensão",
            is_global: "Perfil Global",
            enable: "Habilitar",
            users: "Usuários",
            global: "Sim",
            not_global: "Não",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar perfil externo?",
              description:
                "Isso vai permanentemente deletar o perfil externo, todas as regras de restrição vinculadas a esse perfil externo serão excluídas e todos os usuários vinculados serão desvinculados",
            },
            errors: {
              name: "O nome é obrigatório",
              extension: "A extensão é obrigatória",
            },
          },
          iProcesse: {
            i_processes: "Processos",
            i_processe: "Processo",
            new_i_processe: "Novo processo",
            add_i_processe: "Adicionar processo",
            search: "Pesquise por um processo",
            processe_name: "Nome do Processo",
            description: "Descrição",
            code: "Código",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            confirm: {
              title: "Deletar processo?",
              description: "Isso vai permanentemente deletar o processo",
            },
            errors: {
              processe_name: "O nome do processo é obrigatório",
            },
          },
          iService: {
            certillion: {
              name: "Certillion",
              is_certillion_cloud: "Utilizar Certillion Cloud",
              authorize_local: "Autorizar localmente",
              base_url: "URL Base",
              base_url_proxy: "URL Base do Proxy",
              client_id: "ID do Cliente (Client ID)",
              client_secret: "Segredo do Cliente (Client Secret)",
              pscs_accounts_path: "Caminho de Contas PSC",
              token_path: "Caminho de Token",
              has_token_path: "Caminho de Verificação de Token",
              upload_file_path: "Caminho de Upload de Arquivo",
              signature_path: "Caminho de Assinatura",
              signature_standard_options: "Opções Padrão de Assinatura (JSON)",
              signature_position_landscape:
                "Posicionamento da Assinatura Modo Paisagem",
              signature_position_portrait:
                "Posicionamento da Assinatura Modo Retrato",
              signature_horizontal_x: "Posição X",
              signature_horizontal_y: "Posição Y",
              signature_vertical_x: "Posição X",
              signature_vertical_y: "Posição Y",
              errors: {
                company_digital_certificate: "Certificado Digital da Empresa",
                method_type: "Tipo de Método",
                cpf: "CPF",
                url: "URL inválida",
                required_field: "Campo obrigatório",
                invalid_json: "JSON inválido",
                name: "Nome",
                i_service_type: "Tipo de iService",
              },
            },
            i_services: "Serviços",
            i_service: "Serviço",
            new_i_service: "Novo serviço",
            add_i_service: "Adicionar serviço",
            search: "Pesquise por um serviço",
            name: "Nome do Serviço",
            description: "Descrição",
            configs: "Configurações",
            company_digital_certificate: "Certificado Digital",
            u_bus_user: "Usuário do 4uBus",
            i_service_type: "Tipo de Serviço",
            method_type: "Tipo de Método",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            u_bus_user_external: "4uBus Externo",
            bus_internal_token: "Token do 4uBus",
            host: "Host da API",
            si_pni: "SI-PNI",
            ger_acesso: "GerAcesso - TeletexSul",
            plug_notas: "PlugNotas",
            shift_lis: "Shift LIS",
            protheus: "Protheus",
            sgu: "SGU",
            configuration_under_development:
              "As configurações deste tipo de serviço ainda estão em desenvolvimento. Em breve esta seção estará disponível para configuração.",
            select_options: "Selecione as Opções",
            selected_options: "Opções Selecionadas",
            digital_certificate: "Certificado Digital",
            auth_url: "URL de Autenticação",
            base_url: "URL Base",
            cpf: "CPF",
            token: "Token",
            default_provider_document: "CNPJ Prestador Default",
            define: "Definir",
            cancel: "Cancelar",
            selected_service: "Serviço selecionado",
            clear_options: "Apagar Opções",
            confirm_delete_title: "Apagar Opções",
            confirm_delete_message:
              "Tem certeza que quer apagar as opções informadas?",
            confirm_clear: "Confirmar",
            service: "Serviço",
            i_service_type_error: "Selecione um serviço",
            confirm: {
              title: "Deletar serviço?",
              description: "Isso vai permanentemente deletar o serviço",
            },
            errors: {
              name: "O nome do serviço é obrigatório",
              url: "Digite um link válido (http ou https)",
              company_digital_certificate:
                "O certificado digital é obrigatório",
              bus_internal_token: "O token interno do 4uBus é obrigatório",
              cpf: "O CPF é obrigatório",
              method_type: "O tipo de método é obrigatório",
              token: "O token é obrigatório",
              host: "O Host da API é obrigatório",
              required_field: "Campo obrigatório",
              invalid_json: "JSON inválido",
            },
          },
          accessTokens4uhub: {
            access_tokens: "Tokens do 4uHub",
            access_token: "Token do 4uHub",
            new_access_token: "Novo token do 4uHub",
            add_access_token: "Adicionar token do 4uHub",
            search: "Pesquise por um token do 4uHub",
            name: "Nome",
            code: "Código",
            privileges: "Privilégios",
            token_public: "Token público",
            copied_token: "Token público copiado com sucesso",
            copy: "Copiar token público",
            created: "Data de criação",
            individual: "Pessoa física",
            legal_entity: "Pessoa jurídica",
            software: "Software",
            justification: "Justificativa",
            description: "Descrição",
            is_integration: "Token de integração",
            restriction_rule_profiles: "Perfis de regras de restrição",
            extension: "Extensão",
            profiles: "Perfis",
            no_extensions_found:
              "Não é possível cadastrar Token do 4uhub, pois não possui nenhuma extensão de endpoints de Barramento Instalada.",
            confirm: {
              title: "Deletar token do 4uhub?",
              description: "Isso vai permanentemente deletar o token do 4uhub",
            },
            errors: {
              name: "O nome é obrigatório",
              privileges: "Ao menos um privilégio é obrigatório",
            },
          },
          profile4uhub: {
            profile_tasy_bus: "Perfil - Barramento 4uhub",
            search: "Pesquise por um perfil- Barramento 4uhub",
            add_profile_tasy_bus: "Adicionar perfil - barramento do 4uhub",
            new_profile_tasy_bus: "Novo perfil - barramento do 4uhub",
            name: "Nome",
            extension: "Extensão",
            is_global: "Perfil Global",
            enable: "Habilitar",
            users: "Usuários",
            global: "Sim",
            not_global: "Não",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar perfil - barramento 4uhub?",
              description:
                "Isso vai permanentemente deletar o perfil - barramento 4uhub, todas as regras de restrição vinculadas a esse perfil - barramento 4uhub serão excluídas e todos os usuários vinculados serão desvinculados",
            },
            errors: {
              name: "O nome é obrigatório",
              extension: "A extensão é obrigatória",
            },
          },
          restrictionRules: {
            restriction_rules: "Regras de Restrição",
            restriction_rule: "Regra de Restrição",
            search: "Pesquise por uma regra de restrição",
            add_restriction_rule: "Adicionar regra de restrição",
            new_restriction_rule: "Nova regra de restrição",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            restriction_rule_type: "Tipo de regra de restrição",
            action_type: "Tipo de ação",
            value: "Valor",
            description: "Descrição",
            confirm: {
              title: "Deletar regra de restrição?",
              description:
                "Isso vai permanentemente deletar a regra de restrição",
            },
            errors: {
              restriction_rule_type:
                "O tipo de regra de restrição é obrigatório",
              action_type: "O tipo de ação é obrigatório",
              value: "O valor é obrigatório",
              description: "A descrição é obrigatória",
            },
          },
        },
        relationships: {
          defaultRelationships: {
            relationship: "Relacionamento",
            ipm_tasy_relationship: "Relacionamento IPM x Tasy",
            new_relationship: "Novo relacionamento",
            search: "Pesquise por um relacionamento",
            add_relationship: "Adicionar relacionamento",
            relationship_type: "Tipo de relacionamento",
            direction_type: "Tipo de direcionamento",
            origin_name: "Nome de origem",
            origin_value: "Valor de origem",
            destiny_name: "Nome do destino",
            destiny_value: "Valor do destino",
            enable: "Ativo",
            default: "Padrão",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            is_default: "Sim",
            is_not_default: "Não",
            confirm: {
              title: "Deletar relacionamento?",
              description: "Isso vai permanentemente deletar o relacionamento",
            },
            errors: {
              relationship_type: "O tipo de relacionamento é obrigatório",
              direction_type: "O tipo de direcionamento é obrigatório",
              origin_name: "O nome de origem é obrigatório",
              origin_value: "O valor de origem é obrigatório",
              destiny_name: "O nome do destino é obrigatório",
              destiny_value: "O valor do destino é obrigatório",
              u_bus_relationship_type: "O tipo de relacionamento é obrigatório",
            },
          },
          relationshipGroup: {
            relationship: "Relacionamento",
            add_relationship_group: "Adicionar grupo de relacionamento",
            new_relationship_group: "Novo grupo de relacionamento",
            search: "Pesquise por um grupo de relacionamento",
            name: "Nome",
            code: "Código",
            description: "Descrição",
            u_bus_automation: "Automação do 4uBus",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            created_successfully:
              "Grupo de relacionamento cadastrado com sucesso",
            relationship_group_item: "Item de Grupo de Relacionamento 4uBus",
            confirm: {
              title: "Deletar grupo de relacionamento?",
              description:
                "Isso vai permanentemente deletar o grupo de relacionamento",
            },
            errors: {
              name: "O nome é obrigatório",
              u_bus_automation: "A automação do 4uBus é obrigatória",
            },
          },
        },
        restrictions: {
          schedule: {
            schedule: "Agenda",
            add_schedule: "Adicionar agenda",
            search: "Pesquise por uma agenda",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            new_schedule: "Nova agenda",
            enable: "Habilitar",
            value: "Valor",
            restriction_rule_type: "Tipo de agenda de restrição",
            description: "Descrição",
            confirm: {
              title: "Deletar agenda?",
              description: "Isso vai permanentemente deletar a agenda",
            },
            errors: {
              value: "O valor é obrigatório",
              restriction_rule_type:
                "O tipo de regra de restrição é obrigatório",
              description: "A descrição é obrigatória",
            },
          },
        },
        logs: {
          logFileIntegration: {
            file_integration: "Log de Integração de Arquivos",
            status: "Status",
            robot: "Robôs",
            resolved: "Resolvido",
            start_date: "Data Inicial",
            end_date: "Data Final",
            today: "Hoje",
            yesterday: "Ontem",
            message_status: "Mensagem do status",
            created: "Data e Hora",
            view_logs: "Ver Arquivos",
            logs: "Arquivos",
            solved: "Marcar como Resolvido",
          },
          ipmXTasy: {
            ipmxtasy: "IPM - Receber - IPM x Tasy",
            status: "Status",
            message_status: "Mensagem do status",
            created: "Data de criação",
            tasy_individual_identifier: "Cd. pessoa",
            service_number_search: "Nr. atendimento",
            start_date: "Data Inicial",
            end_date: "Data Final",
            service_number: "Nr. atendimento (IPM)",
            service_number_tasy: "Nr. atendimento (Tasy)",
            lab_exam_quantity: "Qt Exame Lab",
            exam_nlab: "Exame NLab",
            medicines: "Medicamentos",
            allergy: "Alergia",
            has_evolution: "Possui evolução",
            evolution: "Sim",
            no_evolution: "Não",
            search: "Pesquisar por status",
            view_logs: "Ver logs",
            logs: "Logs",
          },
          logTasyImp: {
            status: "Status",
            message_status: "Mensagem do status",
            start_date: "Data Inicial",
            end_date: "Data Final",
            created: "Data de criação",
            qtyEmrLabExamResult: "Qtd de Exames Laboratoriais",
            qtyEmrNonLaboratoryTests: "Qtd de Exames Laboratoriais",
            qtyEvolution: "Qtd de Evoluções",
            qtyAllergy: "Qtd de Alergias",
            qtyMedicineInUse: "Qtd de Medicamentos",
            ipmtasy: "IPMxTasy",
            tasyipm: "TasyxIPM",
            TasyEncounterIntegrationId: "Nº Atendimento Tasy",
            TasyIndividualIntegrationId: "Cod. Pessoa Tasy",
            IpmEncounterIntegrationId: "Nº Atendimento IPM",
            IpmIndividualIntegrationId: "Cod. Pessoa IPM",
          },
          tasyXIpm: {
            tasyxipm: "IPM - Enviar - Tasy x IPM",
            status: "Status",
            message_status: "Mensagem do status",
            created: "Data de criação",
            individual_identifier: "Código da pessoa (Tasy)",
            service_number_search: "Número do atendimento",
            service_number: "Número do atendimento (Tasy)",
            search: "Pesquisar por status",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_logs: "Ver logs",
            logs: "Logs",
            allergies: "Alergias",
            occurrences: "Ocorrências",
            exams_lab: "Exames Lab",
            exams_n_lab: "Exames N Lab",
            medicines: "Medicamentos",
          },
          tasyCalendar: {
            title: "Agendamentos Tasy",
            type_code: "Código",
            created: "Criado em",
            identifier: "Identificador",
            calendar_identifier: "Identificador do agendamento",
            start_date: "Data Inicial",
            end_date: "Data Final",
            calendar_date: "Data do agendamento",
            status: "Status",
            individual_identifier: "Identificador do individuo",
            last_modified: "Última modificação",
          },
          monitoring: {
            title: "Monitoramento Servidor Barramento",
            subtitle: "Estatísticas do servidor On-Premise do Barramento",
          },
          syncPersons: {
            title: "Sync - Dados das pessoas",
            search_placeholder: "Pesquisar por nome ou CPF...",
            name: "Nome",
            cpf: "CPF",
            birth_date: "Data de nascimento",
            email: "Email",
            phone: "Telefone",
            cell_phone: "Celular",
            system: "Sistema",
            last_modified: "Última atualização",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_transactions: "Ver transações",
            transactions: "Transações",
            actions: "Ações",
            logs: "Logs",
            identifier: "Identificador",
            document: "Documento",
            status: "Status",
            message: "Mensagem",
            original_value: "Valor original",
            new_value: "Novo valor",
            retries: "Tentativas",
            created: "Data de criação",
            batch_id: "Lote",
            batch_queue_id: "Fila do lote",
            success: "Sucesso",
            error: "Erro",
            close: "Fechar",
            no_transactions: "Nenhuma transação encontrada.",
            no_actions: "Nenhuma ação encontrada.",
            no_logs: "Nenhum log encontrado.",
            tasy_identifier: "Identificador Tasy",
            view_all_data: "Ver todos os dados",
            details_title: "Todos os dados",
            details_error: "Não foi possível carregar os dados da pessoa.",
            section_identification: "Identificação",
            section_contact: "Contato",
            section_origin: "Origem e atualização",
            section_addresses: "Endereços",
            no_addresses: "Esta pessoa não tem endereços.",
            system_nrec: "Sistema de criação",
            last_modified_nrec: "Data de criação",
            address_type: "Tipo",
            address_street: "Logradouro",
            address_number: "Número",
            address_complement: "Complemento",
            address_neighborhood: "Bairro",
            address_city: "Município",
            address_state: "UF",
            address_zip: "CEP",
            address_type_unknown: "Tipo {{code}}",
            address_types: {
              1: "Residencial",
              2: "Comercial",
              3: "Do responsável",
              4: "Do pai",
              5: "Da mãe",
              6: "Do cônjuge",
              7: "Comercial 2",
              8: "Hospedagem",
              9: "Adicional",
              10: "Postal address",
              20: "Contato de emergência",
              30: "Exclusivo cooperado",
            },
          },
          nfeTotvs: {
            title: "Tasy > TOTVS - NFE",
            identifier: "Identificador",
            resync: "Forçar reenvio",
            totvsIdentifier: "Identificador do totvs",
            resetedSuccess: "Reenvio forçado com sucesso",
            invoice_identifier: "NFe",
            status_item: "Status",
            integration_situation: "Status Intergação",
            created: "Data de Criação",
            integrated_date: "Data de Integração",
            retries: "Tentativas",
            last_modified: "Última Modificação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            status: {
              pending: "Pendente",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            logs: "Logs",
            search_placeholder: "Pesquisar por NFe TOTVS...",
            details: {
              title: "Detalhes da NFe",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              summary: "Resumo do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              provider: "Fornecedor",
              cnpj: "CNPJ",
              invoice: "Nota",
              id: "ID",
              success: "Sucesso",
              error: "Erro",
            },
            integration_type: "Tipo de Integração",
            cancellation: "Cancelamento",
            integration: "Integração",
          },
          calendarControl: {
            title: "Consulta Horários Disponibilizados",
            identifier: "Identificador",
            created: "Data de criação",
            created_start: "Data inicial",
            created_end: "Data final",
            last_modified: "Última modificação",
            heart_beat_date: "Último heartbeat",
            document: "CPF",
            birth_date: "Data de nascimento",
            gender: "Sexo",
            individual_identifier: "Código da pessoa (Tasy)",
            insurance_code: "Convênio",
            insurance_category_code: "Categoria do convênio",
            procedure_code: "Procedimento",
            internal_procedure_code: "Procedimento interno",
            procedure_origin_code: "Origem do procedimento",
            valid_quantity: "Horários válidos",
            minimum_quantity: "Quantidade mínima",
            type_of_appointment: "Tipo de agenda",
            type_calendar: "Código do tipo",
            type_of_appointment_values: {
              CONSULTA: "Consulta",
              RETORNO: "Retorno",
              CHECKUP: "Check-up",
              EXAME: "Exame",
            },
            status: "Status da lista",
            status_values: {
              "LISTA EM CRIACAO": "Lista em criação",
              "LISTA CRIADA": "Lista criada",
              "LISTA FINALIZADA": "Lista finalizada",
            },
            json: "JSON",
            details: "Detalhes",
            additionalFilters: "Mais filtros",
            view_items: "Ver horários avaliados",
            view_json: "Ver JSON da requisição",
            view_details: "Ver detalhes",
            copy_json: "Copiar JSON",
            copy_details: "Copiar detalhes (JSON)",
            close: "Fechar",
            json_modal: {
              title: "JSON da requisição",
              empty: "Sem JSON registrado.",
            },
            details_modal: {
              title: "Demais campos da busca",
            },
            items: {
              title: "Detalhe da busca",
              calendar_identifier: "Agenda",
              slot_identifier: "Identificador do slot",
              calendar_date: "Data e horário",
              status: "Status",
              is_valid: "Válido",
              message: "Motivos",
            },
            item_status_values: {
              PENDENTE: "Pendente",
              PROCESSADO: "Processado",
            },
            is_valid_values: {
              S: "Sim",
              N: "Não",
            },
          },
          refund: {
            title: "Reembolsos",
            holder_document: "Documento do Titular",
            holder_bank_account_name: "Nome do Titular",
            protocol_integration_id: "Protocolo",
            attempt_count: "Tentativas",
            created: "Data de Criação",
            integrated_at: "Data de Integração",
            last_modified: "Última Modificação",
            status: "Status",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search_placeholder: "Pesquisar por Reembolsos...",
            view_details: "Ver detalhes",
            retry: "Tentar novamente",
            retry_success: "Reprocessamento solicitado com sucesso.",
            status_options: {
              pendente: "Pendente",
              processando: "Processando",
              processado: "Processado",
              erro: "Erro",
              erro_emailenviado: "Erro (e-mail enviado)",
              retentativa_manual: "Retentativa Manual",
            },
            details: {
              title: "Detalhes do Reembolso",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              message: "Mensagem",
              log_data: "Dados do Log",
              view_full_log: "Ver log completo",
              close: "Fechar",
              success: "Sucesso",
              error: "Erro",
              protocol_logs_title: "Logs do Protocolo",
              attachments_title: "Anexos",
              attachment_integrated: "Integrado",
              attachment_pending: "Pendente",
              attachment_attempts: "Tentativas",
              media_file_retry_success:
                "Reprocessamento do anexo solicitado com sucesso.",
            },
          },
          forubusVaccine: {
            title: "Vacinas 4uBus",
            identifier: "Identificador",
            immunization_identifier: "Identificador da imunização",
            resync: "Forçar reenvio",
            resetedSuccess: "Reenvio forçado com sucesso",
            individual_document: "Documento",
            vaccine_identifier: "Identificador da vacina",
            status_item: "Status",
            created: "Data de Criação",
            integrated_date: "Data de Integração",
            retries: "Tentativas",
            last_modified: "Última Modificação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            status: {
              pending: "Pendente",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            logs: "Logs",
            search_placeholder: "Pesquisar por Vacinas 4uBus...",
            details: {
              title: "Detalhes da Vacina",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              summary: "Resumo do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              provider: "Fornecedor",
              cnpj: "CNPJ",
              invoice: "Nota",
              id: "ID",
              success: "Sucesso",
              error: "Erro",
            },
            integration_type: "Tipo de Integração",
            cancellation: "Cancelamento",
            integration: "Integração",
          },
          invoiceServiceAgy: {
            title: "Invoice Service Agy",
            identifier: "Identificador",
            invoice_number: "Número da Nota Fiscal",
            rec_company_name: "Tomador",
            rec_company_document: "CNPJ do Tomador",
            status_item: "Status",
            created: "Data de Criação",
            integrated_date: "Data de Integração",
            retries: "Tentativas",
            last_modified: "Última Modificação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            resync: "Forçar reenvio",
            resetedSuccess: "Reenvio forçado com sucesso",
            status: {
              with_inconsistency: "Com Inconsistência",
              awaiting_send: "Aguardando Envio",
              sent: "Enviado",
              error: "Erro",
              success: "Sucesso",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            logs: "Logs",
            search_placeholder: "Pesquisar por Invoice Service Agy...",
            details: {
              title: "Detalhes do Invoice Service Agy",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
            },
          },
          patientEncounterExecuteRequest: {
            title:
              "Tasy OPS - Gerar Atendimento e Prescrição da OPS - Autorização (Execução Requisição)",
            request_identifier: "Identificador da Requisição",
            authorization_integration_id: "Autorização",
            procedure_integration_id: "Procedimento",
            individual_beneficiary_id: "ID do Beneficiário",
            individual_beneficiary_name: "Nome do Beneficiário",
            patient_encounter_number: "Nº do Atendimento",
            prescription_number: "Nº da Prescrição",
            status: "Status",
            status_values: {
              pending: "Pendente",
              processing: "Processando",
              success: "Sucesso",
              manual_review: "Revisão Manual",
            },
            retries: "Tentativas",
            created: "Data de Criação",
            created_start: "Data Inicial",
            created_end: "Data Final",
            additionalFilters: "Mais filtros",
            search: "Pesquisar",
            search_placeholder: "Pesquisar por Requisição...",
            view_details: "Ver detalhes",
            reprocess: "Reprocessar",
            reprocess_selected: "Reprocessar selecionados",
            reprocessedSuccess:
              "Registros enviados para reprocessamento com sucesso",
            details: {
              title: "Detalhes da Requisição",
              success: "Status",
              success_true: "Sucesso",
              success_false: "Falha",
              created: "Data",
              log_data: "Dados do Log",
              last_attempt_date: "Última Tentativa",
              payload: "Payload",
              history: "Histórico",
            },
          },
          patientEncounterPsTransferRequest: {
            title:
              "Tasy EMR - Gerar novo Atendimento no PS, a partir de inelegibilidade de atendimento do PA",
            original_patient_encounter_number: "Nº Atendimento Original",
            new_patient_encounter_number: "Nº Atendimento Novo (PA)",
            new_prescription_number: "Nº Prescrição Nova (PA)",
            individual_beneficiary_id: "ID do Beneficiário",
            individual_beneficiary_name: "Nome do Beneficiário",
            original_doctor_integration_id: "Médico Original",
            target_doctor_integration_id: "Médico do PS",
            transfer_confirmed_date: "Data da Transferência",
            status: "Status",
            status_values: {
              pending: "Pendente",
              processing: "Processando",
              success: "Sucesso",
              manual_review: "Revisão Manual",
            },
            retries: "Tentativas",
            created: "Data de Criação",
            created_start: "Data Inicial",
            created_end: "Data Final",
            additionalFilters: "Mais filtros",
            search: "Pesquisar",
            search_placeholder: "Pesquisar por Atendimento...",
            view_details: "Ver detalhes",
            reprocess: "Reprocessar",
            reprocess_selected: "Reprocessar selecionados",
            reprocessedSuccess:
              "Registros enviados para reprocessamento com sucesso",
            details: {
              title: "Detalhes da Transferência",
              success: "Status",
              success_true: "Sucesso",
              success_false: "Falha",
              created: "Data",
              log_data: "Dados do Log",
              last_attempt_date: "Última Tentativa",
              payload: "Payload",
              history: "Histórico",
            },
          },
          externalLogError: {
            title: "LogError",
            id: "ID",
            error_date: "Data do Erro",
            error_code: "Código do Erro",
            error_message: "Mensagem do Erro",
            source_class: "Classe de Origem",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            view_details: "Ver detalhes",
            search_placeholder: "Pesquisar por LogError...",
            details: {
              title: "Detalhes do Log de Erro",
              error_date: "Data do Erro",
              error_code: "Código do Erro",
              error_message: "Mensagem do Erro",
              command_text: "Comando SQL",
              bind_parameters: "Parâmetros",
              stack_trace: "Stack Trace",
              source_class: "Classe de Origem",
              copy: "Copiar conteúdo",
            },
          },
          gerAcessoVisitControlPacient: {
            title: "Acesso do Acompanhante do Paciente",
            total_time: "Tempo Total",
            order_by_slowest: "Mais demorados",
            order_by_slowest_info:
              "Ordena pelo tempo total (da liberação no Tasy até a entrega na API do GerAcesso), do maior para o menor.",
            identifier: "Identificador",
            patient_name: "Nome do Paciente",
            visitor_cpf: "CPF do Acompanhante",
            service_number: "Número do Atendimento",
            visit_date: "Data da Visita",
            visitor: "Acompanhante",
            exit_date: "Data de Saída",
            status_item: "Status",
            retries: "Tentativas",
            created: "Data de Criação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            status: {
              pending: "Pendente",
              sending: "Enviando",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            resync: "Forçar reenvio",
            resync_selected: "Reenviar selecionados",
            resetedSuccess: "Reenvio forçado com sucesso",
            bulk_resync_error:
              "Não foi possível forçar o reenvio de todos os registros selecionados",
            select_error_rows:
              "Selecione ao menos um registro com erro para reenviar",
            partialResyncWarning:
              "Alguns registros nao puderam ser reenviados.",
            resyncError: "Nao foi possivel reenviar os registros selecionados.",
            logs: "Logs",
            search_placeholder:
              "Pesquisar por Acesso do Acompanhante do Paciente...",
            details: {
              title: "Detalhes do Acesso",
              tasy_released: "Liberado no Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envio",
              total_time: "Tempo Total",
              tasy_to_capture_info:
                "Tempo entre a liberação no Tasy e a captura do registro pela nossa rotina.",
              capture_to_sent_info:
                "Tempo entre a captura do registro pela nossa rotina e a entrega dos dados na API do GerAcesso.",
              total_time_info:
                "Tempo total entre a liberação no Tasy e a entrega dos dados na API do GerAcesso.",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
            integration_type: "Tipo de Integração",
            cancellation: "Cancelamento",
            integration: "Integração",
          },
          gerAcessoVisitControlVisitor: {
            title: "Acesso do Visitante do Paciente",
            total_time: "Tempo Total",
            order_by_slowest: "Mais demorados",
            order_by_slowest_info:
              "Ordena pelo tempo total (da liberação no Tasy até a entrega na API do GerAcesso), do maior para o menor.",
            identifier: "Identificador",
            patient_name: "Nome do Paciente",
            visitor_cpf: "CPF do Visitante",
            service_number: "Numero do Atendimento",
            visit_date: "Data da Visita",
            visitor: "Visitante",
            exit_date: "Data de Saida",
            status_item: "Status",
            retries: "Tentativas",
            created: "Data de Criacao",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            status: {
              pending: "Pendente",
              sending: "Enviando",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            resync: "Forcar reenvio",
            resetedSuccess: "Reenvio forcado com sucesso",
            logs: "Logs",
            search_placeholder:
              "Pesquisar por Acesso do Visitante do Paciente...",
            details: {
              title: "Detalhes do Acesso",
              tasy_released: "Liberado no Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envio",
              total_time: "Tempo Total",
              tasy_to_capture_info:
                "Tempo entre a liberação no Tasy e a captura do registro pela nossa rotina.",
              capture_to_sent_info:
                "Tempo entre a captura do registro pela nossa rotina e a entrega dos dados na API do GerAcesso.",
              total_time_info:
                "Tempo total entre a liberação no Tasy e a entrega dos dados na API do GerAcesso.",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criacao",
              last_modified: "Ultima Modificacao",
              log_data: "Dados do Log",
              logs_table_title: "Logs de Integracao",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
            integration_type: "Tipo de Integracao",
            cancellation: "Cancelamento",
            integration: "Integracao",
          },
          gerAcessoVisitControlSector: {
            title: "Acesso do Visitante do Setor",
            total_time: "Tempo Total",
            order_by_slowest: "Mais demorados",
            order_by_slowest_info:
              "Ordena pelo tempo total (da liberação no Tasy até a entrega na API do GerAcesso), do maior para o menor.",
            sector: "Setor",
            identifier: "Identificador",
            patient_name: "Nome do Paciente",
            visitor_cpf: "CPF do Visitante",
            service_number: "Número do Atendimento",
            access_control_number: "Número de Controle de Acesso",
            visit_date: "Data da Visita",
            visitor: "Visitante",
            exit_date: "Data de Saída",
            status_item: "Status",
            retries: "Tentativas",
            created: "Data de Criação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            status: {
              pending: "Pendente",
              sending: "Enviando",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            resync: "Forçar reenvio",
            resync_selected: "Reenviar selecionados",
            resetedSuccess: "Reenvio forçado com sucesso",
            bulk_resync_error:
              "Não foi possível forçar o reenvio de todos os registros selecionados",
            select_error_rows:
              "Selecione ao menos um registro com erro para reenviar",
            logs: "Logs",
            search_placeholder: "Pesquisar por Acesso do Visitante do Setor...",
            details: {
              title: "Detalhes do Acesso",
              tasy_released: "Liberado no Tasy",
              tasy_to_capture: "Tasy → Captura",
              capture_to_sent: "Captura → Envio",
              total_time: "Tempo Total",
              tasy_to_capture_info:
                "Tempo entre a liberação no Tasy e a captura do registro pela nossa rotina.",
              capture_to_sent_info:
                "Tempo entre a captura do registro pela nossa rotina e a entrega dos dados na API do GerAcesso.",
              total_time_info:
                "Tempo total entre a liberação no Tasy e a entrega dos dados na API do GerAcesso.",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
            integration_type: "Tipo de Integração",
            cancellation: "Cancelamento",
            integration: "Integração",
          },
          invoiceLoweringTotvs: {
            title: "Tasy > TOTVS - Baixa Títulos",
            identifier: "Identificador",
            invoice_identifier: "Nota Fiscal",
            account_payable_identifier: "Conta a Pagar",
            due_date: "Data de Vencimento",
            lowering_identifier: "ID da Baixa",
            status_item: "Status",
            created: "Data de Criação",
            integrated_date: "Data de Integração",
            retries: "Tentativas",
            last_modified: "Última Modificação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            search: "Pesquisar",
            resync: "Forçar reenvio",
            resetedSuccess: "Reenvio forçado com sucesso",
            status: {
              pending: "Pendente",
              processing: "Processando",
              finished: "Finalizado",
              error: "Erro",
            },
            view_logs: "Ver logs",
            view_details: "Ver detalhes",
            logs: "Logs",
            search_placeholder: "Pesquisar por Baixa de Títulos TOTVS...",
            details: {
              title: "Detalhes da Baixa de Título",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              summary: "Resumo do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
              logs: "Logs",
              titles_totvs: "Títulos TOTVS",
              invoice_identifier: "Identificador da Nota",
              id_lan: "ID Lançamento",
              id_mov: "ID Movimento",
              cod_coligada: "Cod. Coligada",
              cod_filial: "Filial",
              due_date: "Data de Vencimento",
              totvs_data: "Dados TOTVS",
              view_totvs_data: "Ver dados TOTVS",
            },
            lowering_type: "Tipo de Baixa",
            reversal: "Estorno",
            normal: "Normal",
          },
          tasyToTasyNonLabFilters: {
            additional_filters: "Mais filtros",
            local_group: "Identificadores locais",
            external_group: "Identificadores externos",
          },
          tasyToTasyNonLabExamsAvailable: {
            title: "Tasy <> Tasy - Exames Não laboratoriais (Disponibilizados)",
            identifier: "Identificador",
            service_number: "Número do Atendimento",
            patient_cpf: "CPF do Paciente",
            status_item: "Status",
            prescription_number: "Número da Prescrição",
            procedure_prescription_number: "Número Prescrição Procedimento",
            external_prescription_number: "Número da Prescrição Externa",
            external_procedure_prescription_number:
              "Número Prescrição Procedimento Externo",
            external_service_number: "Número do Atendimento Externo",
            retries: "Tentativas",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_details: "Ver detalhes",
            status: {
              available: "Disponível",
              downloaded: "Download Completo",
              recognized: "Reconhecido",
              integrated: "Integrado",
              error: "Erro",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalhes do Resultado",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              status_message: "Mensagem",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
          },
          tasyToTasyNonLabExamsReceived: {
            title: "Tasy <> Tasy - Exames Não laboratoriais (Recebidos)",
            identifier: "Identificador",
            service_number: "Número do Atendimento",
            patient_cpf: "CPF do Paciente",
            status_item: "Status",
            prescription_number: "Número da Prescrição",
            procedure_prescription_number: "Número Prescrição Procedimento",
            external_prescription_number: "Número da Prescrição Externa",
            external_procedure_prescription_number:
              "Número Prescrição Procedimento Externo",
            external_service_number: "Número do Atendimento Externo",
            retries: "Tentativas",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_details: "Ver detalhes",
            status: {
              available: "Disponível",
              downloaded: "Download Completo",
              recognized: "Reconhecido",
              integrated: "Integrado",
              error: "Erro",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalhes do Resultado",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              status_message: "Mensagem",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
          },
          serviceReceived: {
            title: "Tasy - Receber Atendimentos",
            identifier: "Identificador",
            generated_service_number: "Número do Atendimento Gerado",
            establishment_code: "Código do Estabelecimento Externo",
            external_cpf: "CPF Externo",
            status_item: "Status",
            retries: "Tentativas",
            external_service_number: "Número do Atendimento Externo",
            external_person_code: "Código Pessoa Externo",
            linked_person_code: "Código Pessoa Gerado/Vinculado",
            external_person_name: "Nome Pessoa Externo",
            view_received_data: "Ver Dados Recebidos",
            view_details: "Ver detalhes",
            resync: "Forçar reenvio",
            resetedSuccess: "Reenvio forçado com sucesso",
            start_date: "Data Inicial",
            end_date: "Data Final",
            more_filters: "Mais Filtros",
            service_data: "Dados do Atendimento",
            patient_data: "Dados do Paciente / Vínculo",
            clean_filters: "Limpar filtros",
            cancel: "Cancelar",
            apply_filters: "Aplicar Filtros",
            encounter_date_entry: "Data do Atendimento",
            status: {
              received: "Recebido",
              integrated: "Integrado",
              pending: "Pendente",
              error: "Erro",
            },
            details: {
              title: "Detalhes do Atendimento",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
          },
          tasyToTasyResultsNonLabAvailable: {
            title:
              "Tasy <> Tasy - Resultados Exames Não laboratoriais (Disponibilizados)",
            identifier: "Identificador",
            service_number: "Número do Atendimento",
            patient_cpf: "CPF do Paciente",
            status_item: "Status",
            prescription_number: "Número da Prescrição",
            procedure_prescription_number: "Número Prescrição Procedimento",
            external_prescription_number: "Número da Prescrição Externa",
            external_procedure_prescription_number:
              "Número Prescrição Procedimento Externo",
            external_service_number: "Número do Atendimento Externo",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_details: "Ver detalhes",
            status: {
              available: "Disponível",
              downloaded: "Download Completo",
              recognized: "Reconhecido",
              integrated: "Integrado",
              error: "Erro",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalhes do Resultado",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              status_message: "Mensagem",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
          },
          tasyToTasyResultsNonLabReceived: {
            title:
              "Tasy <> Tasy - Resultados Exames Não laboratoriais (Recebidos)",
            identifier: "Identificador",
            service_number: "Número do Atendimento",
            patient_cpf: "CPF do Paciente",
            status_item: "Status",
            prescription_number: "Número da Prescrição",
            procedure_prescription_number: "Número Prescrição Procedimento",
            external_prescription_number: "Número da Prescrição Externa",
            external_procedure_prescription_number:
              "Número Prescrição Procedimento Externo",
            external_service_number: "Número do Atendimento Externo",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_details: "Ver detalhes",
            status: {
              available: "Disponível",
              downloaded: "Download Completo",
              recognized: "Reconhecido",
              integrated: "Integrado",
              error: "Erro",
              cancelled: "Cancelado",
            },
            details: {
              title: "Detalhes do Resultado",
              log_id: "ID do Log",
              status: "Status",
              created: "Data de Criação",
              last_modified: "Última Modificação",
              log_data: "Dados do Log",
              status_message: "Mensagem",
              logs_table_title: "Logs de Integração",
              close: "Fechar",
              view_full_log: "Ver Log Completo",
              success: "Sucesso",
              error: "Erro",
            },
          },
          syncTransaction: {
            title: "Sync - Dados das Transações",
            identifier: "Identificador",
            name: "Nome",
            cpf: "CPF",
            external_id: "ID Externo",
            status_item: "Status",
            start_date: "Data Inicial",
            end_date: "Data Final",
            view_action: "Ver Ação",
            actions: "Ações",
            last_modified: "Última atualização",
            original_value: "Valor original",
            new_value: "Novo valor",
            message: "Mensagem",
            retries: "Tentativas",
            created: "Data de criação",
            resend: "Forçar reenvio",
            resend_row: "Reenviar",
            resend_confirm_title: "Forçar reenvio",
            resend_confirm_description: "Reenviar {{quantity}} transação(ões) selecionada(s)? Só as que estiverem com status Erro voltam para a fila; as demais serão ignoradas.",
            resend_confirm_button: "Reenviar",
            resend_cancel: "Cancelar",
            resend_select_rows: "Selecione ao menos uma transação.",
            resend_result_title: "Resultado do reenvio",
            resend_result_summary: "{{restarted}} reenviada(s), {{ignored}} ignorada(s) por status e {{failed}} com erro.",
            resend_result_failed_title: "Transações com erro",
            resend_result_source_hint: "Se o erro vier do dado de origem (por exemplo, CPF inválido), a transação volta a falhar. Corrija o dado na origem.",
            resend_result_close: "Fechar",
            individual_last_modified: "Alteração na origem",
            origin_system: "Sistema de origem",
            logs: "Logs",
            no_transactions: "Nenhuma transação encontrada.",
            no_actions: "Nenhuma ação encontrada.",
            no_logs: "Nenhum log encontrado.",
            status: {
              error: "Erro",
              success: "Sucesso",
              in_process: "Em Processamento",
              pending: "Pendente",
              waiting_action_generation: "Aguardando Geração das Ações",
            },
          },
        },
        sync: {
          sync: "Sincronização",
          sync_all: "Sincronizar tudo",
          synced_all: "Sincronização realizada com sucesso",
        },
        uBusAutomationRobot: {
          suffixPrefix: "Sufixo/Prefixo",
          identificationPosition: "Posição forma identificação",
          exam_machine_files: "Integrações de Arquivos",
          add_exam_machine_files: "Adicionar Integração de Arquivos",
          name_table: "Nome",
          search: "Pesquise por uma integração de arquivos",
          description_table: "Descrição",
          path_table: "Caminho",
          file_integration: "Integração de Arquivos",
          new_file_integration: "Nova Integração de Arquivos",
          ubus_automation: "Tipo Integração de Arquivos",
          name: "Nome Mapeamento de Arquivos",
          machine_mode: "Modalidade Maquina Exames",
          internal_procedure_integration_id: "Código De Procedimento Interno",
          medical_certificate_content: "Mensagem do Laudo",
          physician_will_report: "Gera Laudo em Digitação",
          path: "Endereço do Monitoramento dos arquivos",
          description: "Descrição",
          exam_machine: "Marca/Modelo da Maquina de Exames",
          software: "Software",
          integration_attribute:
            "Forma de Identidicação do Destino nos arquivos",
          minutes: "Minutos de Execução",
          generate_pdf_with_images: "Agrupar Imagens e Gerar PDF",
          rotate_images: "Girar Imagens Individualmente",
          rotation_mode: "Definição Giro Imagens",
          insert_report_test_pdf: "Incluir Laudo PDF no Laudo Paciente",
          minutes_to_group_pdf: "Tempo de Agrupamento de imagens (em minutos)",
          insert_report_test_pdf_as_image:
            "Incluir o PDF no Anexo do Laudo Paciente",
          insert_image_as_attachment:
            "Incluir as imagens no Anexo do Laudo Paciente",
          make_copy_files_end_of_process:
            "Fazer uma cópia dos arquivos no final do processo",
          copy_files_path: "Caminho para salvar a cópia dos arquivos",
          copy_process: "Processo de cópia",
          rename_file_process: "Renomear arquivos",
          ubus_automation_execution: "Destino dos Arquivos",
          path_separator: "Separador",
          enable: "Habilitar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar Integração de Arquivos?",
            description:
              "Isso vai permanentemente deletar a Integração de Arquivos",
          },
          errors: {
            name: "O nome do mapeamento de arquivos é obrigatório",
            path: "O endereço do monitoramento dos arquivos é obrigatório",
            description: "A descrição é obrigatória",
            exam_machine: "A marca/modelo da máquina de exames é obrigatória",
            software: "O software é obrigatório",
            integration_attribute:
              "A forma de identificação do destino nos arquivos é obrigatória",
            minutes: "Os minutos de execução são obrigatórios",
            insert_report_test_pdf:
              "A opção de agrupar imagens e gerar PDF é obrigatória",
            minutes_to_group_pdf:
              "O tempo de agrupamento de imagens (em minutos) é obrigatório",
            uBusAutomationExecution: "O destino dos arquivos é obrigatório",
            uBusAutomation: "O tipo de integração de arquivos é obrigatório",
            examMachineModality:
              "A modalidade da máquina de exames é obrigatória",
            rotation_mode: "A definição giro imagens é obrigatória",
            external_procedure_integrationId:
              "O codigo de procedimento interno é obrigatório",
            internal_procedure_integration_id:
              "O código de procedimento interno é obrigatório",
            copy_files_path:
              "O caminho para salvar a cópia dos arquivos é obrigatório",
            copy_process: "O processo de cópia é obrigatório",
            suffixPrefix: "Suffixo/Prefixo deve ter no máximo 50 caracteres",
          },
        },
        robots: {
          list: {
            list: "Lista de Robôs",
            search: "Pesquise por um robô",
            name: "Nome",
            description: "Descrição",
            code: "Código",
            started: "Iniciou",
            last_success: "Último sucesso",
            last_error: "Último erro",
            last_error_message: "Mensagem do último erro",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            executions_robots: "Execuções do Robô",
            executions: {
              executions_robots: "Execuções do Robô",
              job_name: "Nome da Job",
              start_date: "Data de início",
              end_date: "Data de fim",
              execution_status: "Status da execução",
            },
          },
        },
        zscanExamSendRule: {
          exam_send_rules: "Regras de envio de exames",
          exam_send_rule: "Regra de envio de exames",
          add_exam_send_rule: "Adicionar regra de envio de exames",
          new_exam_send_rule: "Nova regra de envio de exames",
          target_machine: "Máquina de destino",
          proc_classification_integration_id:
            "Id de Classificação do Procedimento",
          initial_date: "Data de início",
          end_date: "Data de fim",
          enable: "Ativar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          errors: {
            target_machine: "A máquina de destino é obrigatória",
            proc_classification_integration_id:
              "O id de classificação do procedimento é obrigatório",
            initial_date: "A data de início é obrigatória",
            end_date: "A data de fim é obrigatória",
            initial_date_bigger:
              "A data de início não pode ser maior que a de fim",
          },
          confirm: {
            title: "Deletar regra de envio de exames?",
            description:
              "Isso vai permanentemente deletar a regra de envio de exames",
          },
        },
        integrationRule: {
          integration_rules: "Regras de Integração",
          integration_rule: "Regra de Integração",
          add_integration_rule: "Adicionar regra de integração",
          new_integration_rule: "Nova regra de integração",
          search: "Pesquise por uma regra de integração",
          automation: "Automação",
          name: "Nome",
          description: "Descrição",
          u_bus_automation: "Automação do 4uBus",
          i_processe: "Processo",
          start_date: "Data de início da vigência",
          end_date: "Data de fim da vigência",
          initial_date: "Data de corte",
          filters: "Filtros",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          enable: "Habilitar",
          created_successfully: "Regra de integração cadastrada com sucesso",
          integration_rule_relationship_group: "Grupos de Relacionamento",
          i_services: "Serviços",
          transfers: "Movimentos",
          parameters: "Parâmetros",
          rules: "Regras",
          suspension_reason_code: "Código de motivo de suspensão",
          batch_size: "Tamanho máximo do lote",
          max_workers: "Quantidade máxima de processos simultâneos",
          only_requestable_lab_exams:
            "Considerar apenas exames de laboratório solicitáveis",
          only_requestable_lab_exams_tooltip:
            "Quando ligado, a busca automática do procedimento interno ignora exames de laboratório marcados como não solicitáveis no Tasy (IE_SOLICITACAO diferente de 'S').",
          reports_tooltip:
            "Use {{NR_LAUDOS}} no texto para substituir pelos laudos liberados informados no e-mail.",
          email_copy_recipients_tooltip:
            "Neste campo podem ser adicionados e-mails que receberão uma cópia dos e-mails enviados. É possível adicionar vários e-mails separados por vírgula.",
          integrationRuleRelationshipGroup: {
            integration_rule_relationship_groups: "Grupos de Relacionamento",
            integration_rule_relationship_group: "Grupo de Relacionamento",
            add_integration_rule_relationship_group:
              "Adicionar grupo de relacionamento",
            new_integration_rule_relationship_group:
              "Novo grupo de relacionamento",
            search: "Pesquise por um grupo de relacionamento",

            priority: "Prioridade",
            u_bus_relationship_group: "Grupo de Relacionamento do 4uBus",
            confirm: {
              title: "Deletar grupo de relacionamento?",
              description:
                "Isso vai permanentemente deletar o grupo de relacionamento",
            },
            errors: {
              u_bus_relationship_group:
                "O grupo de relacionamento do 4uBus é obrigatório",
            },
          },
          integrationRuleIService: {
            integration_rule_i_services: "Serviços",
            integration_rule_i_service: "Serviço",
            add_integration_rule_i_service: "Adicionar serviço",
            new_integration_rule_i_service: "Novo serviço",
            search: "Pesquise por um serviço",
            integration_direction_type: "Tipo de Direção de Integração",
            i_service: "Serviço",
            grid_warning:
              'Nenhum registro será disponibilizado nesta integração enquanto não for criada uma regra no campo "Tipo de direção de integração" com o valor "Entrada de sistema terceiro". É com base nessa configuração que liberamos o acesso aos dados.',
            confirm: {
              title: "Deletar serviço?",
              description: "Isso vai permanentemente deletar o serviço",
            },
            errors: {
              integration_direction_type:
                "O tipo de direção de integração é obrigatório",
              i_service: "O serviço é obrigatório",
            },
          },
          integrationRuleMov: {
            integration_rule_movs: "Movimentos",
            integration_rule_mov: "Movimento",
            add_integration_rule_mov: "Adicionar Movimento",
            new_integration_rule_mov: "Novo Movimento",
            search: "Pesquise por um movimento",
            status: "Status",
            enable: "Habilitar",
            active: "Ativo",
            inactive: "Inativo",
            individual_external_id: "Identificador Externo do Paciente",
            individual_identifier_message_helper:
              "Os valores devem ser separados por vírgula",
            internal_proc_classification: "Classificação do Proc Interno",
            procedure_type: "Tipo do Procedimento",
            tasy_ops_if_label: "Se",
            tasy_ops_then_label: "Então",
            establishment_external_id: "Estabelecimento",
            provider_external_id: "Prestador",
            establishment_external_id_then: "Estabelecimento (Então)",
            patient_encounter_type_external_id_then:
              "Tipo de Atendimento (Então)",
            tiss_attendance_type_external_id_then:
              "Tipo de Atendimento Tiss (Então)",
            patient_encounter_origin_external_id_then:
              "Origem do Atendimento (Então)",
            patient_care_character_external_id_then:
              "Caráter do Atendimento (Então)",
            patient_care_classification_external_id_then:
              "Classificação do Atendimento (Então)",
            insurance_type_external_id_then: "Tipo de Convênio (Então)",
            insurance_external_id_then: "Convênio (Então)",
            insurance_category_external_id_then:
              "Categoria do Convênio (Então)",
            insurance_plan_external_id_then: "Plano do Convênio (Então)",
            sector_external_id_then: "Setor (Então)",
            sector_basic_unit_external_id_then:
              "Unidade Básica do Setor (Então)",
            sector_compl_unit_external_id_then:
              "Unidade Complementar do Setor (Então)",
            sector_accommodation_type_external_id_then:
              "Tipo de Acomodação (Então)",
            hvs_upa_ps_if_label: "Se",
            hvs_upa_ps_then_label: "Então",
            hvs_upa_ps_job1_label: "Job 1 · Buscar atendimentos elegíveis",
            hvs_upa_ps_job1_description:
              "Define quais atendimentos com alta entram na fila de transferência. Os filtros abaixo restringem a busca; o identificador do paciente limita a busca a uma única pessoa (útil em testes).",
            hvs_upa_ps_job2_phase1_label:
              "Job 2 · Fase 1 — Gerar novo atendimento e prescrição",
            hvs_upa_ps_job2_phase1_description:
              "Cria um novo atendimento com as características do atendimento atual (estabelecimento, tipo, origem, caráter, convênio e setor) e uma prescrição com os procedimentos abaixo. Serve para o médico original ser remunerado pela consulta inicial.",
            hvs_upa_ps_job2_phase2_label:
              "Job 2 · Fase 2 — Transferir o atendimento atual para o PS",
            hvs_upa_ps_job2_phase2_description:
              "Atualiza o atendimento atual com o setor, a unidade, o tipo de atendimento TISS e o médico abaixo. O médico vem da escala ou do último atendimento do dia; se nenhum for encontrado, usa o Médico Padrão.",
            insurance: "Convênio",
            sector: "Setor",
            verify_released_opinion: "Verifica se existe parecer liberado",
            procedure_area: "Área do Procedimento",
            procedure_specialty: "Especialidade do Procedimento",
            procedure_group: "Grupo do Procedimento",
            lab_exam_classification: "Classificação do Exame de Laboratório",
            plan_operation_type: "Tipo de Operação do Produto",
            plan_price_formation: "Formação do Preço do Produto",
            plan_filters_message_helper:
              "Os Movimentos da mesma regra devem ser excludentes: uma guia que atender a mais de um Movimento fica apenas com o primeiro processado.",
            internal_procedure: "Procedimento Interno",
            internal_procedure_then: "Procedimento Interno (Então)",
            doctor_obtain_mode: "Forma de obtenção do médico",
            doctor_obtain_mode_schedule: "Conforme escala",
            doctor_obtain_mode_last_encounter_of_day:
              "Médico do último atendimento do dia",
            schedule_then: "Escala (Então)",
            default_doctor_external_id_then: "Médico Padrão (Então)",
            confirm: {
              title: "Deletar Movimento?",
              description: "Isso vai permanentemente deletar o Movimento",
            },
            errors: {
              establishment_external_id: "O estabelecimento é obrigatório",
              provider_external_id: "O prestador é obrigatório",
              establishment_external_id_then:
                "O estabelecimento (então) é obrigatório",
              patient_encounter_type_external_id_then:
                "O tipo de atendimento (então) é obrigatório",
              patient_encounter_origin_external_id_then:
                "A origem do atendimento (então) é obrigatória",
              patient_care_character_external_id_then:
                "O caráter do atendimento (então) é obrigatório",
              patient_care_classification_external_id_then:
                "A classificação do atendimento (então) é obrigatória",
              insurance_external_id_then: "O convênio (então) é obrigatório",
              insurance_category_external_id_then:
                "A categoria do convênio (então) é obrigatória",
              sector_external_id_then: "O setor (então) é obrigatório",
              sector_basic_unit_external_id_then:
                "A unidade básica do setor (então) é obrigatória",
              sector_accommodation_type_external_id_then:
                "O tipo de acomodação (então) é obrigatório",
              tiss_attendance_type_external_id_then:
                "O tipo de atendimento Tiss (então) é obrigatório",
              sector_compl_unit_external_id_then:
                "A unidade complementar do setor (então) é obrigatória",
              u_bus_integration_rule_mov_internal_procedures_then:
                "O procedimento interno (então) é obrigatório",
              u_bus_integration_rule_mov_schedules_then:
                "A escala (então) é obrigatória",
            },
          },
          integrationRuleParam: {
            integration_rule_params: "Parâmetros",
            integration_rule_param: "Parâmetro",
            add_integration_rule_param: "Adicionar Parâmetro",
            new_integration_rule_param: "Novo Parâmetro",
            search: "Pesquise por um parâmetro",
            inclusion_rule_type: "Tipo de regra de inclusão",
            if: "Se",
            then: "Então",
            source_name: "Nome de origem",
            source_value: "Valor de origem",
            destination_name: "Nome no destino",
            destination_value: "Valor no destino",
            sector: "Setor",
            basic_unit: "Unid Básica",
            complementary_unit: "Unid Complementar",
            insurance: "Convênio",
            category: "Categoria",
            establishment: "Estabelecimento",
            procedure: "Procedimento",
            procedure_origin: "Origem Procedimento",
            internal_procedure: "Procedimento Interno",
            material: "Material",
            service_code: "Código do Serviço",
            service_origin: "Origem do Serviço",
            confirm: {
              title: "Deletar Parâmetro?",
              description: "Isso vai permanentemente deletar o Parâmetro",
            },
            errors: {
              inclusion_rule_type: "O tipo de regra de inclusão é obrigatório",
              required_field: "Campo obrigatório",
            },
          },
          integrationRuleField: {
            integration_rule_fields: "Regras",
            integration_rule_field: "Regra",
            add_integration_rule_field: "Adicionar regra",
            new_integration_rule_field: "Nova regra",
            search: "Pesquise por uma regra",
            automation_field: "Campo de automação",
            individual_external_id: "Identificador Externo do Paciente",
            softwares: "Softwares",
            if: "Se",
            then: "Então",
            confirm: {
              title: "Deletar regra?",
              description: "Isso vai permanentemente deletar a regra",
            },
            errors: {
              automation_field: "O campo de automação é obrigatório",
            },
          },
          confirm: {
            title: "Deletar regra de integração?",
            description:
              "Isso vai permanentemente deletar a regra de integração",
          },
          errors: {
            name: "O nome é obrigatório",
            start_date: "A data de início é obrigatória",
            end_date: "A data de fim é obrigatória",
            initial_date: "A data de corte é obrigatória",
            start_date_bigger:
              "A data de início não pode ser maior que a de fim",
            u_bus_automation: "A automação do 4uBus é obrigatória",
            i_processe: "O processo é obrigatório",
            suspension_reason_code:
              "O código de motivo de suspensão é obrigatório",
            batch_size_min: "O tamanho máximo do lote deve ser maior que zero",
            max_workers_min:
              "A quantidade máxima de processos deve ser maior que zero",
            max_workers_max:
              "A quantidade máxima de processos não pode ser maior que 5",
          },
        },
      },
      "4uSiteApp": {
        siteLoginContent: {
          site_login_content: "Conteúdo de Login",
          search: "Pesquise por um conteúdo de login",
          add_site_login_content: "Adicionar conteúdo",
          name: "Nome",
          presentation_order: "Ordem de Apresentação",
          enable: "Habilitar",
          link_url: "Url do link",
          link_label: "Rótulo do link",
          document: "Documento",
          language: "Idioma",
          language_tooltip: "Cadastrar um novo idioma",
          add_new_language: "Adicionar novo idioma",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Excluir o conteúdo de login?",
            description: "Isso vai excluir permanentemente o conteúdo de login",
          },
          errors: {
            name: "O nome é obrigatório",
            presentation_order: "A ordem de apresentação é obrigatória",
            document_text: "O conteúdo é obrigatório",
            language: "O idioma é obrigatório",
            languages: "Informe ao menos um idioma",
          },
        },
        applications: {
          myApplications: {
            my_applications: "Minhas aplicações",
            search: "Pesquise por uma aplicação",
            name: "Nome",
            type: "Tipo",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
          },
        },
        consultationsAndLogs: {
          beneficiarySituation: {
            title: "Situação do Beneficiário",
            document: "CPF",
            establishment_code: "Estabelecimento",
            person_code: "Código da pessoa",
            name: "Nome",
            insured_code: "Código do segurado",
            plan: "Plano",
            card_code: "Código da carteirinha",
            card_validity: "Validade Carteirinha",
            contract_status: "Situação Contrato",
            details: "Dados completos",
            birth_date: "Data de nascimento",
            accession_date: "Data de adesão",
            another_plan_qty: "Outros planos",
            locks: "Bloqueios",
            lock_code: "Código",
            description: "Descrição",
            unlock_date: "Desbloqueio",
            temporary_partial_coverage: "CPT",
            view_details: "Ver detalhes",
            search_placeholder: "Pesquisar beneficiários...",
            errors: {
              document_required: "O CPF é obrigatório",
            },
          },
        },
      },
      assessments: {
        questions: {
          questions: "Questões",
          question: "Questão",
          always_visible:
            "Deixar justificativa/cometário sempre visível para o respondente",
          new_question: "Nova questão",
          add_question: "Adicionar questão",
          search: "Pesquise por uma questão",
          question_evaluation_type: "Tipo de avaliação da questão",
          integration_id: "Id de integração",
          title: "Título",
          description: "Descrição",
          question_category: "Categoria da questão",
          created: "Data de criação",
          is_required: "Resposta Obrigatória",
          min_chars: "Minimo de Caracteres",
          required_justification: "Requer/obriga justificativa",
          required_justification_less_than: "Obrigar justificativa abaixo de",
          required_justification_options:
            "Obrigar justificativa para as alternativas abaixo (entre vírgulas)",
          required_justification_options_tooltip:
            "Obrigar justificativa para as alternativas abaixo com base no campo `Valor de referência` (valores separados por vírgula)",
          alternatives_integration_id_tooltip:
            "No Tasy, cadastre o Id de integração de cada alternativa com dois dígitos (01, 02, 03...), na mesma ordem das opções.",
          required_justification_min_chars: "Quantidade mínima de caracteres",
          required_justification_message: "Texto justificativa",
          guidance_text_position: "Apresentar texto para orientação:",
          guidance_text: "Texto para orientação:",
          category: {
            label: "Categoria",
            no_options_text: "Nenhuma categoria selecionada",
            options_button_label: "Buscar categoria",
            drawer_props: {
              title: "Selecionar categoria",
              search_placeholder: "Buscar categorias",
              create_button_label: "Criar categoria",
              apply_button_label: "Aplicar categoria",
              input_label: "Nome da categoria",
              delete_confirm: {
                title: "Deletar categoria",
                message:
                  "Isso irá excluir a categoria e todas as categorias relacionadas",
              },
            },
          },
          confirm: {
            title: "Deletar questão?",
            description: "Isso vai permanentemente deletar a questão",
          },
          errors: {
            integration_id: "O id de integração é obrigatório",
            title: "O título é obrigatório",
            description: "A descrição é obrigatória",
            question_evaluation_type:
              "O tipo de avaliação da questão é obrigatório",
            question_category: "A categoria da questão é obrigatória",
            required_justification_less_than:
              "O 'obrigar justificativa abaixo de' é obrigatório",
            required_justification_options:
              "Informe os valores de referência separados por vírgula",
            required_justification_min_chars:
              "A quantidade mínima de caracteres é obrigatória",
            required_justification_message:
              "O texto justificativa é obrigatório",
            min_chars: "A quantidade mínima de caracteres é obrigatória",
          },
        },
      },
      logs: {
        dateRange: {
          title: "Intervalo de Data",
          today: "Hoje",
          this_week: "Esta semana",
          this_month: "Este mês",
          last_month: "Mês anterior",
          last_30_days: "Últimos 30 dias",
          last_6_months: "Últimos 6 meses",
          select_period: "Selecionar período",
          filterBy: "Filtrar por",
        },
        healthChecks: {
          health_checks: "Health Checks",
          start_date: "Data Inicial",
          end_date: "Data Final",
          name: "Nome",
          data: "Dados",
          created: "Data de criação",
          search: "Pesquisar por um log do health checks",
        },
        logRegisterError: {
          errorMessage: "Mensagem de erro",
          document: "Documento",
          title: "Erros de Cadastro",
          start_date: "Data Inicial",
          end_date: "Data Final",
          created: "Data",
          confirm: {
            confirm: {
              title: "Deletar log de erro?",
              description: "Isso vai permanentemente deletar o log",
            },
          },
          placeholder: "Pesquise por algum CPF",
        },
      },
      evaluation: {
        forms: {
          forms: "Formulários",
          form: "Formulário",
          new_form: "Novo formulário",
          search: "Pesquise por um formulário",
          type_form: "Tipo de Formulário",
          answered_form: "Forma de iniciar o preenchimento das respostas",
          layout_form: "Forma de Apresentação",
          add_form: "Adicionar formulário",
          title: "Título",
          description: "Descrição",
          show_link_on_end: "Oferece link de avaliação para promotores do NPS",
          show_link_greater_than: "Nota minima",
          response_time_limit_hours: "Limitar o tempo de resposta em horas",
          show_link_link: "Link",
          show_link_description: "Texto de engajamento",
          show_link_button_label: "Label do botão",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          release_status: "Situação da liberação",
          awaiting_release: "Aguardando liberação",
          released: "Liberado",
          release_form: "Liberar Formulário",
          undo_release: "Desfazer Liberação",
          clone_form: "Clonar Formulário",
          cancel_action: "Cancelar",
          continue_action: "Continuar",
          release_requires_question:
            "O formulário precisa ter ao menos uma questão para ser liberado.",
          released_form_warning:
            "Este formulário foi liberado. Apenas o título e o status podem ser editados.",
          locked_question_warning:
            "Esta questão está vinculada a um formulário liberado e não pode ser editada ou excluída.",
          release_confirm: {
            title: "Liberar formulário?",
            description:
              "Ao liberar, o formulário e as questões vinculadas serão bloqueados para edição. Deseja continuar?",
          },
          clone_confirm: {
            title: "Clonar formulário?",
            description:
              "Será clonado o formulário e todas as questões vinculadas. Deseja continuar?",
          },
          enable: "Ativar",
          integration_id: "Código de integração",
          visual_description: "Descrição visual de apresentação:",
          extension: "Aplicação/Site/App",
          initial_date: "Início vigência",
          end_date: "Fim vigência",
          domains: {
            domains: "Domínios",
            tooltip:
              "Copiar link de compartilhamento do formulário para uso em templates",
            copied_successfully: "Link copiado com sucesso",
          },
          select_questions: {
            questions: "Questões",
            display_order: "Ordem",
            title: "Título",
            type: "Tipo",
            add_button: "Adicionar questões",
            modal_title: "Selecionar questões",
            modal_add_button: "Adicionar questões",
            modal_remove_button: "Remover questões",
            search: "Pesquise por uma questão",
          },
          confirm: {
            title: "Deletar formulário?",
            description: "Isso vai permanentemente deletar o formulário",
          },
          errors: {
            type: "O tipo é obrigatório",
            title: "O título é obrigatório",
            site_app_extension: "A aplicação/site/app é obrigatória",
            initial_date: "A data de início vigência é obrigatória",
            end_date: "A data de fim vigência é obrigatória",
            bigger_date:
              "A data de início vigência não pode ser maior que a data de fim vigência",
            description: "A descrição é obrigatória",
            questions: "Ao menos uma questão é obrigatória",
            order: "A ordem precisa ser maior ou igual a 1",
            duplicate_order: "Não é permitido ordens duplicadas",
            visual_description: "A descrição visual é obrigatória",
            response_time_limit_hours:
              "Informe um número inteiro maior que zero",
            show_link_greater_than: "A nota minima é obrigatória",
            show_link_link: "O link é obrigatório",
            show_link_description: "O texto de engajamento é obrigatório",
            show_link_button_label: "O label do botão é obrigatório",
            layoutForm: "A forma de apresentação é obrigatória",
            answeredForm:
              "A forma de iniciar o preenchimento das respostas é obrigatória",
            typeForm: "O tipo de formulário é obrigatório",
          },
        },
        logs: {
          id: "Id da pesquisa",
          title: "Logs de Integração",
          evaluationForm: "Formulário",
          ticket: "Ticket (card)",
          start_date: "Data Inicial",
          end_date: "Data Final",
          attempts: "Tentativas",
          shippingDate: "Data de envio",
          answerDate: "Data da resposta",
          encounterIntegrationId: "Numero do atendimento",
          errorMessage: "Mensagem de erro",
          copy: "Copiar",
          copied_successfully: "Link da pesquisa copiado com sucesso",
          ticketChannel: "Quadro",
          ticketMembers: "Membros do ticket",
          externalUrl: "Url externo",
        },
      },
      "4uSalesContract": {
        registers: {
          grantors: {
            active: "Ativo",
            inactive: "Inativo",
            name: "Nome",
            status: "Status",
            grantors: "Outorgantes",
            add_grantor: "Adicionar Outorgante",
            enabled: "Habilitar",
            establishments: "Estabelecimentos",
            new_grantor: "Novo Outorgante",
            legal_entity: "Pessoa Jurídica",
            search_grantors: "Pesquisar por Outorgante",
            confirm: {
              title: "Deletar outorgante?",
              description: "Isso vai permanentemente deletar o outorgante",
            },
            errors: {
              name: "O nome é obrigatório",
              establishment: "Ao menos um estabelecimento é obrigatório",
              legal_entity: "A Pessoa Jurídica é obrigatório",
            },
          },
          salesContractAttachments: {
            title: "Anexo",
            description: "Descrição",
            search: "Buscar Anexos",
            add: "Adicionar Anexo",
            title_form: "Título",
            approval_date: "Data de Aprovação",
            approve: "Aprovar",
            attachment_date: "Data do Anexo",
            new_attachment: "Novo Anexo",
            attachment_type: "Tipo de Anexo",
            confirm: {
              title: "Excluir Anexo?",
              description: "Isso excluirá permanentemente o Anexo",
            },
            errors: {
              title: "O Título é obrigatório",
              description: "A descrição é obrigatória",
              attachment_type: "O tipo do anexo é obrigatório",
              attachment_date: "A data do anexo é obrigatória",
              file: "O arquivo é obrigatório",
            },
          },
          salesContractHistories: {
            title: "Histórico",
            search: "Pesquisa Histórico",
            add: "Adicionar Histórico",
            contract_title: "Histórico",
            new_history: "Nova Histórico",
            titleForm: "Título",
            history: "Histórico",
            approval_date: "Data Aprovação",
            history_date: "Data Histórico",
            approve: "Aprovar",
            confirm: {
              title: "Deletar histórico?",
              description: "Isso vai permanentemente deletar o histórico",
            },
            errors: {
              title: "O título é obrigatório",
              history: "O histórico é obrigatório",
              historyDate: "A data do histórico é obrigatória",
            },
          },
          contractAttachmentType: {
            title: "Tipo de Anexo de Contrato",
            search: "Pesquisar por tipo de anexo de contrato",
            add: "Adicionar Tipo de Anexo de Contrato",
            new: "Novo Tipo de Anexo de Contrato",
            active: "Ativo",
            inactive: "Inativo",
            contract_type: "Tipo de Contrato",
            enabled: "Habilitar",
            name: "Nome",
            status: "Status",
            confirm: {
              title: "Deletar tipo de anexo de contrato?",
              description:
                "Isso vai permanentemente deletar o tipo de anexo de contrato",
            },
            errors: {
              name: "O nome é obrigatório",
              contract_type: "O tipo de contrato é obrigatório",
            },
          },
          contractTerminationReason: {
            title: "Motivo de Cancelamento Contrato",
            search: "Pesquisar por Motivo de Cancelamento Contrato",
            add: "Adicionar Motivo de Cancelamento Contrato",
            new: "Novo Motivo de Cancelamento Contrato",
            active: "Ativo",
            inactive: "Inativo",
            code: "Código",
            contract_type: "Tipo de Contrato",
            enabled: "Habilitar",
            name: "Nome",
            status: "Status",
            confirm: {
              title: "Deletar motivo de cancelamento contrato?",
              description:
                "Isso vai permanentemente deletar o motivo de cancelamento contrato",
            },
            errors: {
              name: "O nome é obrigatório",
              contract_type: "O tipo de contrato é obrigatório",
            },
          },
          contract_classifications: {
            name: "Nome",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enabled: "Habilitar",
            code: "Código",
            contract_type: "Tipo de Contrato",
            contract_classification: "Classificação de Contrato",
            search_contract_classification:
              "Pesquisar por Classificação de Contrato",
            add_contract_classification: "Adicionar Classificação de Contrato",
            new_contract_classification: "Nova Classificação de Contrato",
            confirm: {
              title: "Deletar classificação de contrato?",
              description:
                "Isso vai permanentemente deletar a classificação de contrato",
            },
            errors: {
              name: "O nome é obrigatório",
              contract_type: "O tipo de contrato é obrigatório",
            },
          },
          baseContracts: {
            title: "Clube de Vantagens e Benefícios",
            search: "Pesquisar por Clube de Vantagens e Benefícios",
            add: "Adicionar Clube de Vantagens e Benefícios",
            contratation_date: "Data da Contratação",
            termination_date: "Data da Finalização",
            situation_status: "Status da Situação",
            start_date: "Data Inicial",
            end_date: "Data Final",
            situation: "Situação",
            filter: "Para filtrar, é necessário informar as datas",
            contract_classification: "Classificação do Contrato",
            integration_code: "Código de Integração",
            name: "Nome",
            status: "Status",
            approved: "Aprovado",
            code: "Código",
            canceled: "Cancelado",
            pending: "Em Análise",
            terminated: "Rescindido",
            dateFutureFilter:
              "Data inicial ou data final maior que o dia de hoje",
            dateFilter: "Data inicial é maior que a data final",
            approve: "Aprovar",
            cancel: "Cancelar",
            terminate: "Rescindir",
            reactivation: "Reativar",
            contractualObject: {
              substipulant: "Subestipulante",
              product: "Produto",
            },
            salesContractRules: {
              sales_contract_hcp_inclusion_rule:
                "Programas de Saúde - Inclusão Automática",
            },
            confirm: {
              title: "Deletar o clube de vantagens e benefícios?",
              description:
                "Isso vai permanentemente deletar o clube de vantagens e benefícios",
            },
            advantagesAndBenefitsClub: {
              title: "Clube de Vantagens e Benefícios",
              advantages_and_benefits_club_contract:
                "Contratos de Clube de Vantagens e Benefícios",
              grantor: "Outorgante",
              new: "Novo Clube de Vantagens e Benefícios",
              contract_classification: "Classificação de Contrato",
              contract_number: "Número de contrato",
              integration_code: "Código de Integração",
              contract_title: "Título do Contrato",
              renewal_period: "Período Renovação (meses)",
              main_contract: "Contrato Principal",
              situation: "Situação",
              legal_entity: "Pessoa Jurídica",
              individual_person: "Pessoa Física",
              contratation_data: "Dados da Contratação",
              contract_type: "Tipo do Contrato",
              contratation_date: "Data da Contratação",
              termination_date: "Data da Finalização",
              approval_date: "Data da Aprovação",
              cancelation_date: "Data da Cancelamento",
              reactivation_date: "Data da Reativação",
              code: "Código",
              benefit_administrators: "Administradores do Benefício",
              additional_data:
                "Dados Adicionais para Clube de Vantagens e Benefícios",
              tabs: {
                sales_contract_rules: "Regras",
                contractual_object: "Objetos Contratuais",
                history: "Histórico",
                contract: "Contrato",
                payer: "Pagadores",
                attachment: "Anexos",
                beneficiary: "Beneficiário",
              },
              errors: {
                contract_date: "A Data de contratação é obrigatória",
                contract_type: "O Tipo de contrato é obrigatório",
                individual_person: "A pessoa física é obrigatória",
                legal_entity: "A pessoa jurídica é obrigatória",
                renew_months: "Perídio de Renovação é obrigatório",
                grantor: "O Outorgante é obrigatório",
                situation: "A situação é obrigatória",
                contract_classification:
                  "A Classificação de Contrato é obrigatória",
                contract_title: "O Título do contrato é obrigatório",
              },
            },
          },
          beneficiaryClassification: {
            title: "Classificação de Beneficiários",
            new: "Nova Classificação de Beneficiários",
            add: "Adicionar Classificação de Beneficiário",
            search: "Pesquisar por Classificação de Beneficiário",
            name: "Nome",
            code: "Código",
            status: "Status",
            enable: "Habilitar",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar classificação de beneficiário?",
              description:
                "Isso vai permanentemente deletar a classificação de beneficiário",
            },
            errors: {
              name: "O Nome é obrigatório",
            },
          },
          contractProductClassifications: {
            title: "Classificação de Produtos",
            contract_product_classification: "Classificação de Produto",
            search: "Pesquisar por uma Classificação de Produtos",
            name: "Nome",
            status: "Status",
            active: "Ativo",
            code: "Código",
            inactive: "Inativo",
            enabled: "Habilitar",
            add: "Adicionar Classificação de Produto",
            new: "Nova Classificação de Produto",
            contract_type: "Tipo de Contrato",
            confirm: {
              title: "Deletar classificação de produto?",
              description:
                "Isso vai permanentemente deletar a classificação de produto",
            },
            errors: {
              name: "O nome é obrigatório",
              contract_type: "O Tipo do contrato é obrigatório",
            },
          },
          channelClassifications: {
            title: "Classificações de Canal de Vendas",
            channel_classification: "Classificação de Canal de Vendas",
            search: "Pesquisar por Classificação de Canal de Vendas",
            add: "Adicionar Classificação de Canal de Vendas",
            new: "Nova Classificação de Canal de Vendas",
            name: "Nome",
            code: "Código",
            status: "Status",
            enable: "Habilitar",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar classificação de canal de vendas",
              description:
                "Isso vai permanentemente deletar a classificação de canal de vendas",
            },
            errors: {
              name: "O nome é obrigatório",
              status: "O Status é obrigatório",
            },
          },
          salesChannel: {
            title: "Canais de Vendas",
            sales_channel: "Canal de Vendas",
            search: "Pesquisar por Canal de Vendas",
            add: "Adicionar Canal de Vendas",
            new: "Novo Canal de Vendas",
            legal_entity: "Pessoa Jurídica",
            individual_person: "Pessoa Física",
            title_placeholder: "Título",
            name: "Nome",
            code: "Código",
            active: "Ativo",
            inactive: "Inativo",
            suspension: "Suspender",
            inactivation: "Inativar",
            reactivation: "Reativar",
            approve: "Aprovar",
            approved: "Aprovado",
            contract_type: "Tipo Contrato",
            enabled: "Habilitar",
            reactivation_date: "Data de Reativação",
            inactivation_date: "Data de Inativação",
            suspension_date: "Data de Suspensão",
            approval_date: "Data de Aprovação",
            situation: "Situação",
            classification: "Classificação",
            sales_channel_type: "Tipo de Canal de Vendas",
            tabs: {
              sales_channel: "Canal de Vendas",
              seller: "Vendedores",
            },
            confirm: {
              title: "Deletar canal de vendas?",
              description: "Isso vai permanentemente deletar o canal de vendas",
            },
            errors: {
              title: "O título é obrigatório",
              situation: "A situação é obrigatória",
              sales_channel_classification: "A classificação é obrigatória",
              sales_channel_type: "O canal de vendas é obrigatório",
              individual_person: "A pessoa física é obrigatória",
              legal_entity: "A pessoa jurídica é obrigatória",
            },
          },
          salesContractBeneficiary: {
            title: "Beneficiário",
            search: "Pesquisar por Beneficiário",
            add: "Adicionar Beneficiário",
            new: "Novo Beneficiário",
            individual_person: "Pessoa Física",
            code: "Código",
            integration_code: "Código de Integração",
            active: "Ativo",
            approve: "Aprovar",
            cancel: "Cancelar",
            reestablish: "Reestabelecer",
            rescind: "Rescindir",
            suspend: "Suspender",
            approved: "Aprovado",
            canceled: "Cancelado",
            under_analysis: "Em Análise",
            rescinded: "Rescindido",
            suspended: "Suspenso",
            beneficiary_card: "Cartão do Beneficiário",
            admission_date: "Data de Admissão",
            original_inclusion_date: "Data de Original de Inclusão",
            beneficiary_classification: "Classificação do Beneficiário",
            kinship_degree: "Grau de Parentesco",
            beneficiary_holder: "Beneficiário Titular",
            type_of_holder: "Tipo de Titularidade",
            sales_product: "Produto",
            sales_price_list: "Lista de Preço",
            sales_payer: "Pagador",
            substipulant: "Subestipulante",
            sales_channel: "Canal de Vendas",
            sales_seller: "Vendedor",
            approval_date: "Data de Aprovação",
            situation: "Situação",
            confirm: {
              title: "Deletar Beneficiário?",
              description: "Isso vai permanentemente deletar o Beneficiário",
            },
            errors: {
              situation: "A situação é obrigatória",
              individual_person: "A Pessoa Física é obrigatória",
              beneficiary_classification:
                " A classificação do beneficiário é obrigatória",
              sales_product: "O produto é obrigatório",
              sales_price_list: "A lista de preço é obrigatória",
              sales_channel: "O canal de vendas é obrigatório",
              sales_payer: "O pagador é obrigatório",
              sales_seller: "O vendedor é obrigatório",
            },
          },
          salesContractBeneficiaryCard: {
            title: "Cartão do Beneficiário",
            add: "Adicionar Cartão do Beneficiário",
            card_identifier: "Identificação do Cartão",
            initial_date: "Data Inicial",
            end_date: "Data Final",
            integration_code: "Código de Integração",
            confirm: {
              title: "Deletar Cartão do Beneficiário?",
              description:
                "Isso vai permanentemente deletar a Cartão do Beneficiário",
            },
            errors: {
              card_identifier: "A identificação do cartão é obrigatória",
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
            },
          },
          salesContractPayerFinantial: {
            title: "Financeiro do Pagador",
            search: "Buscar Financeiro do Pagador",
            add: "Adicionar Financeiro do Pagador",
            new: "Novo Financeiro do Pagador",
            mail: "E-mail",
            biling_method: "Método de Cobrança",
            monthly_payment_due_date: "Dia do Pagamento",
            initial_date: "Data Inicial",
            end_date: "Data Final",
            enable: "Habilitar",
            history: "Histórico",
            financial: "Financeiro",
            new_finantial: "Novo",
            phone: "Telefone",
            whatsapp_number: "Número do WhatsApp",
            observation: "Observação",
            confirm: {
              title: "Excluir Pagador?",
              description: "Isso excluirá permanentemente o Pagador",
            },
            errors: {
              biling_method: "O método de cobrança é obrigatório",
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              monthly_payment_due_date: "O dia do pagamento é obrigatória",
            },
          },
          salesContractPayer: {
            title: "Pagador",
            search: "Buscar Pagador",
            add: "Adicionar Pagador",
            new: "Novo Pagador",
            payer_finantial: "Financeiro do Pagador",
            legal_entity: "Pessoa Jurídica",
            individual_person: "Pessoa Física",
            payer: "Pagador",
            title_payer: "Título",
            address_type: "Tipo de Endereço",
            address: "Endereço",
            payerType: "Tipo",
            integration_code: "Código de Integração",
            code: "Código",
            active: "Ativo",
            inactive: "Inativo",
            suspension: "Suspender",
            inactivation: "Inativar",
            reactivation: "Reativar",
            approve: "Aprovar",
            reactivation_date: "Data de Reativação",
            inactivation_date: "Data de Inativação",
            suspension_date: "Data de Suspensão",
            approval_date: "Data de Aprovação",
            situation: "Situação",
            confirm: {
              title: "Excluir Pagador?",
              description: "Isso irá excluir permanentemente o Pagador",
            },
            errors: {
              situation: "A situação é obrigatória",
              individual_person: "A pessoa física é obrigatória",
              legal_entity: "A pessoa jurídica é obrigatória",
              address_type: "O tipo de endereço é obrigatório",
              payer_title: "O título é obrigatório",
              biling_method: "O método de cobrança é obrigatório",
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              date: "A data final deve ser maior que a data inicial",
              monthly_payment_due_date: "O dia do pagamento é obrigatória",
            },
          },
          salesContractSubStipulant: {
            title: "Subestipulante",
            search: "Pesquisar por Subestipulante",
            add: "Adicionar Subestipulante",
            new: "Novo Subestipulante",
            legal_entity: "Pessoa Jurídica",
            individual_person: "Pessoa Física",
            code: "Código",
            integration_code: "Código de Integração",
            active: "Ativo",
            inactive: "Inativo",
            suspension: "Suspender",
            inactivation: "Inativar",
            reactivation: "Reativar",
            approve: "Aprovar",
            reactivation_date: "Data de Reativação",
            inactivation_date: "Data de Inativação",
            suspension_date: "Data de Suspensão",
            approval_date: "Data de Aprovação",
            situation: "Situação",
            confirm: {
              title: "Deletar Subestipulante?",
              description: "Isso vai permanentemente deletar o Subestipulante",
            },
            errors: {
              situation: "A situação é obrigatória",
              individual_person: "A Pessoa Física é obrigatória",
              legal_entity: "A Pessoa Jurídica é obrigatória",
            },
          },
          salesContractProducts: {
            title: "Produto",
            add: "Adicionar Produto",
            new: "Novo Produto",
            code: "Code",
            name: "Nome",
            product: "Produto",
            price_list: "Lista de Preço",
            price_list_product: "Listas de Preço",
            confirm: {
              title: "Deletar Produto?",
              description: "Isso vai permanentemente deletar o Produto",
            },
            errors: {
              product: "O produto é obrigatório",
              price_list: "A lista de preço é obrigatória",
            },
          },
          salesContractPriceList: {
            title: "Listas de Preços",
            price_list: "Lista de Preço",
            search: "Pesquisar por uma lista de preços",
            add: "Adicionar Lista de Preços",
            name: "Nome",
            initial_date: "Data Inicial",
            end_date: "Data Final",
            approval_date: "Data Aprovação",
            approve: "Aprovar",
            code: "Código",
            new_price_list: "Nova Lista de Preços",
            add_new_item: "Adicionar Novo Item",
            degree_of_entitlement: "Grau de Titularidade",
            initial_age: "Idade Inicial",
            end_age: "Idade Final",
            items: "Itens",
            price: "Preço",
            confirm: {
              title: "Deletar Lista de Preços?",
              description: "Isso vai permanentemente deletar a Lista de Preços",
            },
            errors: {
              name: "O nome é obrigatório",
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              code: "O código é obrigatório",
              price: "O preço é obrigatório",
              date: "A data final deve ser maior que a data inicial",
              age: "A idade final deve ser maior que a idade inicial",
              degree_of_entitlement: "O grau de elegibilidade é obrigatório",
              sales_contract_price_list_items: "Ao menos um item é obrigatório",
            },
          },
          salesContractHcpInclusionRule: {
            title: "Programas de Saúde - Inclusão Automática",
            search: "Pesquisar por uma regra de Inclusão Automatica",
            add: "Adicionar Regra Inclusão Automatica",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            initial_date: "Data Inicial",
            health_program: "Programa de Saúde",
            end_date: "Data Final",
            confirm: {
              title: "Deletar Regra Inclusão Automatica?",
              description:
                "Isso vai permanentemente deletar a Regra Inclusão Automatica",
            },
            errors: {
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              date: "A data final deve ser maior que a data inicial",
              health_program: "O programa de saúde é obrigatório",
            },
          },
          salesSeller: {
            title: "Vendedor",
            title_seller: "Título do Vendedor",
            search: "Buscar Vendedor",
            add: "Adicionar Vendedor",
            new: "Novo Vendedor",
            individual: "Individual",
            active: "Ativo",
            inactive: "Inativo",
            suspension: "Suspender",
            inactivation: "Inativar",
            code: "Código",
            reactivation: "Reativar",
            approve: "Aprovar",
            approved: "Aprovado",
            suspended: "Suspenso",
            reactivation_date: "Data de Reativação",
            inactivation_date: "Data de Inativação",
            suspension_date: "Data de Suspensão",
            approval_date: "Data de Aprovação",
            situation: "Situação",
            confirm: {
              title: "Excluir vendedor?",
              description: "Isso excluirá permanentemente o vendedor",
            },
            errors: {
              title: "O título do vendedor é obrigatório",
              situation: "A situação é obrigatória",
              individual: "A pessoa física é obrigatória",
            },
          },
          contractProducts: {
            tabs: {
              products: "Produtos",
              price: "Preço",
              history: "Histórico",
              priceList: "Listas de Preços",
            },
            products: {
              title: "Produtos",
              product: "Produto",
              situation: "Situação",
              new_product: "Novo Produto",
              search: "Pesquisar por Produtos",
              add: "Adicionar Produto",
              contract_title: "Título do Contrato",
              name: "Nome",
              active: "Ativo",
              inactive: "Inativo",
              approved: "Aprovado",
              canceled: "Cancelado",
              suspended: "Suspenso",
              reactivation_date: "Data de Reativação",
              inactivation_date: "Data de Inativação",
              suspension_date: "Data de Suspensão",
              approval_date: "Data de Aprovação",
              cancelation_date: "Data de Cancelação",
              suspension: "Suspender",
              inactivation: "Inativar",
              reactivation: "Reativar",
              approve: "Aprovar",
              cancelation: "Cancelar",
              fantasy_name: "Nome Fantasia",
              sales_contract_type: "Tipo de Contrato",
              integration_code: "Código de Integração",
              sales_product_ctr_classification: "Classificação de Produto",
              sales_grantors: "Outorgantes",
              code: "Código",
              confirm: {
                title: "Deletar produto?",
                description: "Isso vai permanentemente deletar o produto",
              },
              errors: {
                name: "O nome é obrigatório",
                fantasy_name: "O nome fantasia é obrigatório",
                sales_grantors: "Ao menos um outorgante é obrigatório",
                sales_product_ctr_classification:
                  "A classificação de produto é obrigatória",
                sales_contract_type: "O tipo de contrato é obrigatório",
              },
            },
          },
          salesProductCtrPriceList: {
            title: "Listas de Preços",
            price_list: "Lista de Preço",
            search: "Pesquisar por uma lista de preços",
            add: "Adicionar Lista de Preços",
            name: "Nome",
            initial_date: "Data Inicial",
            end_date: "Data Final",
            approval_date: "Data Aprovação",
            approve: "Aprovar",
            code: "Código",
            new_price_list: "Nova Lista de Preços",
            add_new_item: "Adicionar Novo Item",
            degree_of_entitlement: "Grau de Titularidade",
            initial_age: "Idade Inicial",
            end_age: "Idade Final",
            items: "Itens",
            price: "Preço",
            confirm: {
              title: "Deletar Lista de Preços?",
              description: "Isso vai permanentemente deletar a Lista de Preços",
            },
            errors: {
              name: "O nome é obrigatório",
              initial_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              code: "O código é obrigatório",
              price: "O preço é obrigatório",
              degree_of_entitlement: "O grau de elegibilidade é obrigatório",
              date: "A data final deve ser maior que a data inicial",
              age: "A idade final deve ser maior que a idade inicial",
              sales_product_ctr_price_list_items:
                "Ao menos um item é obrigatório",
            },
          },
          salesProductCtrHistories: {
            title: "Histórico",
            search: "Pesquisa Histórico",
            add: "Adicionar Histórico",
            contract_title: "Histórico",
            new_history: "Novo Histórico",
            titleForm: "Título",
            history: "Histórico",
            approval_date: "Data Aprovação",
            history_date: "Data Histórico",
            approve: "Aprovar",
            confirm: {
              title: "Deletar histórico?",
              description: "Isso vai permanentemente deletar o histórico",
            },
            errors: {
              title: "O título é obrigatório",
              history: "O histórico é obrigatório",
              historyDate: "A data do histórico é obrigatória",
            },
          },
          beneficiaryTerminationReasons: {
            title: "Motivo de Termino Beneficiários",
            search: "Pesquisar por Motivo de Termino Beneficiário",
            add: "Adicionar Motivo de Termino Beneficiário",
            new: "Novo Motivo de Termino Beneficiário",
            name: "Nome",
            status: "Status",
            code: "Código",
            active: "Ativo",
            inactive: "Inativo",
            enabled: "Habilitar",
            confirm: {
              title: "Deletar motivo de término beneficiário?",
              description:
                "Isso vai permanentemente deletar o motivo de término beneficiário",
            },
            errors: {
              name: "O Nome é obrigatório",
            },
          },
          beneficiaryCancellationsReason: {
            title: "Motivo de Cancelamento Beneficiário",
            search: "Pesquisar por de Motivo de Cancelamento Beneficiário",
            add: "Adicionar Motivo de Cancelamento Beneficiário",
            new: "Novo Motivo de Cancelamento Beneficiário",
            name: "Nome",
            status: "Status",
            inactive: "Inativo",
            code: "Código",
            active: "Ativo",
            enable: "Habilitar",
            confirm: {
              title: "Deletar o motivo de cancelamento beneficiário?",
              description:
                "Isso vai permanentemente deletar o motivo de cancelamento beneficiário",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          beneficiarySuspensionsReason: {
            title: "Motivo de Suspensão Beneficiário",
            search: "Pesquisar por Motivo de Suspensão Beneficiário",
            add: "Adicionar Motivo de Suspensão Beneficiário",
            new: "Novo Motivo de Suspensão Beneficiário",
            enable: "Habilitar",
            name: "Nome",
            code: "Código",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar o motivo de suspensão beneficiário?",
              description:
                "Isso vai permanentemente deletar o motivo de suspensão beneficiário",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
        },
      },
      "4uDonation": {
        donors: {
          title: "Doadores",
          name: "Nome",
          search: "Pesquise por um doador",
          add: "Adicionar Doador",
          new: "Novo Doador",
          donor: "Doador",
          document: "Documento",
          new_donor: "Novo Doador",
          donor_code: "Código do Doador",
          whatsapp_contacts: "Contatos de WhatsApp",
          donor_integration_id: "ID de Integração do Doador",
          attendant_integration_id: "ID de Integração do Atendente",
          attendant: "Atendente",
          confirm: {
            title: "Deletar Doador?",
            description: "Isso vai permanentemente deletar o doador",
          },
          form: {
            name: "Nome",
            document: {
              cpf: "CPF",
              cnpj: "CNPJ",
            },
            entityType: "Entidade",
            individual_person: "Pessoa Física",
            legal_entity: "Pessoa Jurídica",
            birth_date: "Data de Nascimento",
            incorporation_date: "Data de Abertura",
            donor_type: "Entidade Doadora",
            gender: "Gênero",
            contacts: "Contatos",
            new_contact: "Novo Contato",
            addresses: "Endereços",
            new_address: "Novo Endereço",
            contact_type: "Tipo de Contato",
            ddi: "DDI",
            contact_number: "Número de Contato",
            integration_id: "Id de Integração",
            attendant: "Atendente",
            attendant_secondary: "Atendente Secundário",
            user_integration_type: "Tipo de Integração de Usuário",
            errors: {
              name: "O nome é obrigatório",
              document: "O documento é obrigatório",
              user_integration_type:
                "O tipo de integração de usuário é obrigatório",
              value: "Digite um número de telefone",
              zipCode: "Informe um CEP válido",
              addressDescription: "Informe a Rua",
              number: "Informe o número",
              addressTypeId: "Informe o tipo de endereço",
            },
          },
        },
      },
      "4uDlist": {
        listClassification: {
          title: "Classificações",
          list_classification: "Classificação de Lista",
          search: "Pesquisar por classificação de lista",
          add: "Adicionar Classificação de Lista",
          new: "Nova Classificação de Lista",
          name: "Nome",
          description: "Descrição",
          code: "Código",
          copy: "Copiar Código",
          copied: "Código copiado",
          enable: "Habilitar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar a classificação de lista?",
            description:
              "Isso vai permanentemente deletar a classificação de lista",
          },
          errors: {
            name: "O nome é obrigatório",
          },
        },
        listCategory: {
          title: "Categorias",
          list_category: "Categoria de Lista",
          search: "Pesquisar por categoria de lista",
          add: "Adicionar Categoria de Lista",
          new: "Nova Categoria de Lista",
          name: "Nome",
          description: "Descrição",
          enable: "Habilitar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar a categoria de lista?",
            description:
              "Isso vai permanentemente deletar a categoria de lista",
          },
          errors: {
            name: "O nome é obrigatório",
          },
        },
        listFiles: {
          title: "Importação de Listas",
          list_file: "Arquivo de Listas",
          search: "Pesquisar por arquivo de listas",
          add: "Adicionar Arquivo de Listas",
          new: "Novo Arquivo de Listas",
          purposes: "Finalidades",
          list_classification: "Classificação",
          import_origin: "Origem da Importação",
          import_api_status: "Status da API",
          define: "Mudar Status da API Para Definitivo",
          integration_type: "Sistema de origem do dado",
          download: "Baixar Modelo",
          model_file_name: "modelo_de_arquivos_de_listas",
          file: "Arquivo",
          file_caption: "Somente arquivo .xls ou .xlsx",
          name: "Nome",
          code: "Código",
          import_status: "Status de Importação",
          total: "Total",
          with_error: "Erro",
          with_alert: "Alerta",
          converted: "Convertidos",
          description: "Descrição",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          list_contacts: "Lista de Contatos",
          convertToList: {
            name: "Nome",
            description: "Descrição",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            convert_to_new_list: "Converter em nova Lista",
            add_to_existing_list: "Adicionar a lista existente",
            convert: "Converter",
            converted: "Lista convertida com sucesso!",
            search: "Pesquisar Lista",
            select_existing_list: "Selecionar Lista Existente",
            select_list: "Selecionar Lista",
            cancel: "Cancelar",
            createList: {
              title: "Lista",
              new: "Nova Lista",
              name: "Nome",
              description: "Descrição",
              list_categories: "Categorias de Lista",
              list_classifications: "Classificações de Lista",
              integration_type: "Tipo de Integração",
              enable: "Habilitar",
            },
          },
          errors: {
            purposes: "Ao menos uma finalidade é obrigatória",
            file: "O arquivo é obrigatório",
            list_classification: "A classificação é obrigatória",
          },
        },
        listImportAutomation: {
          title: "Automação Para Gerar Listas de Distribuição",
          list_import_automation: "Automação de Importação de Listas",
          search: "Pesquisar por automação de importações de listas",
          add: "Adicionar Automação de Importações de Listas",
          new: "Nova Automação de Importações de Listas",
          active: "Ativo",
          enabled: "Sim",
          disabled: "Não",
          enable: "Habilitar",
          name: "Nome",
          initial_date: "Data de início",
          end_date: "Data de fim",
          description: "Descrição",
          created_successfully:
            "Automação de Importação de Listas criada com sucesso",
          classifications: "Classificações",
          dlist_classifications: {
            search: "Pesquisar por classificação",
            add_classification: "Adicionar Classificação",
            list_classification: "Classificação",
            title: "Classificação",
            new: "Nova Classificação",
            confirm: {
              title: "Deletar a Classificação?",
              description: "Isso vai permanentemente deletar a Classificação",
            },
            errors: {
              list_classification: "A classificação é obrigatória",
            },
          },
          confirm: {
            title: "Deletar a automação de importações de listas?",
            description:
              "Isso vai permanentemente deletar a automação de importações de listas",
          },
          errors: {
            name: "O nome é obrigatório",
            initial_date: "A data de início é obrigatória",
            end_date: "A data de fim é obrigatória",
            end_date_less: "A data de fim não pode ser menor que a de início",
          },
        },
        list: {
          title: "Listas de Distribuição",
          list: "Controle de Lista",
          search: "Pesquisar por controle de lista",
          list_contacts: "Lista de Contatos",
          add: "Adicionar Controle de Lista",
          new: "Novo Controle de Lista",
          name: "Nome",
          integration_type: "Tipo de Integração",
          list_categories: "Categorias de Lista",
          list_classifications: "Classificações de Lista",
          created_date: "Data Criação",
          category: "Categoria",
          classification: "Classificação",
          description: "Descrição",
          enable: "Habilitar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar a campanha?",
            description: "Isso vai permanentemente deletar a campanha",
          },
          errors: {
            name: "O nome é obrigatório",
            name_max_length: "O nome deve ter no máximo 255 caracteres",
            type: "O tipo é obrigatório",
            list_categories: "Pelo menos uma categoria é obrigatória",
            list_classifications: "Pelo menos uma classificação é obrigatória",
            integration_type: "O tipo de integração é obrigatório",
          },
        },
        listContacts: {
          title: "Listagem de Contatos",
          name: "Nome",
          document: "Documento",
          mail: "E-mail",
          whatsapp_number: "WhatsApp",
          phone: "Número de Telefone",
          search: "Pesquisar por um contato",
          contact_detail: "Detalhes do Contato",
          modal: {
            title: "Detalhes do Contato",
            address_city_name: "Cidade",
            address_complement: "Complemento do Endereço",
            address_description: "Rua",
            address_neighborhood_name: "Bairro",
            address_number: "Número do Endereço",
            address_province_name: "Estado",
            address_zip_code: "CEP",
            attendant_integration_id: "Código Integração Atendente",
            beneficiary_integration_id: "Código Integração Beneficiário",
            code: "Código",
            date_of_birth: "Data de Nascimento",
            document: "Documento",
            donor: "Doador",
            enable: "Ativo",
            errors: "Erros",
            disable: "Inativo",
            event_date: "Data do Evento",
            event_number_control: "Controle de Número de Evento",
            facebook: "Facebook",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            list_import_batch: "Arquivo",
            list_import_contact_status: "Status",
            mail: "E-mail",
            name: "Nome",
            occurrence_date: "Data de Ocorrência",
            person_integration_id: "Código Integração Pessoa",
            phone: "Telefone",
            telegram_number: "Número do Telegram",
            trigger_date: "Data de Disparo",
            trigger_priority: "Prioridade de Gatilho",
            whats_app_number: "Número de WhatsApp",
            is_deleted: "Status",
            warnings: "Avisos",
            donor_integration_id: "Código Integração Doador",
            list: "Nome da Lista",
            main_message: "Mensagem Principal",
            subject: "Assunto",
            comment: "Comentário",
            alert: "Alerta",
            orientation: "Orientação",
          },
        },
        generationRule: {
          generation_rules: "Regras de Geração",
          generation_rule: "Regra de Geração",
          search: "Pesquisar por regras de geração",
          add_generation_rule: "Adicionar Regra de Geração",
          new_generation_rule: "Nova Regra de Geração",
          name: "Nome",
          data_origin: "Origem dos Dados",
          created_successfully: "Regra de geração criada com sucesso!",
          individual_title: "Pessoa Física",
          employee_title: "Empregado",
          doctor_title: "Médico",
          beneficiary_title: "Beneficiário",
          schedule_title: "Agendas",
          service_period_title: "Período de Atendimento",
          individual: {
            individuals: "Pessoas Física",
            individual: "Pessoa Física",
            search: "Pesquisar por pessoa física",
            add_individual: "Adicionar Pessoa Física",
            new_individual: "Nova Pessoa Física",
            sex: "Sexo",
            age: "Idade",
            confirm: {
              title: "Deletar a pessoa física?",
              description: "Isso vai permanentemente deletar pessoa física",
            },
            errors: {
              sex: "O sexo é obrigatório",
              age: "A idade é obrigatória",
            },
          },
          employee: {
            employees: "Empregados",
            employee: "Empregado",
            search: "Pesquisar por empregado",
            add_employee: "Adicionar Empregado",
            new_employee: "Nova Empregado",
            sector: "Setor",
            confirm: {
              title: "Deletar o empregado?",
              description: "Isso vai permanentemente deletar o empregado",
            },
            errors: {
              sector: "O setor é obrigatório",
            },
          },
          doctor: {
            doctors: "Médicos",
            doctor: "Médico",
            search: "Pesquisar por médico",
            add_doctor: "Adicionar Médico",
            new_doctor: "Nova Médico",
            sector: "Setor",
            confirm: {
              title: "Deletar o médico?",
              description: "Isso vai permanentemente deletar o médico",
            },
            errors: {
              sector: "O setor é obrigatório",
            },
          },
          beneficiary: {
            beneficiaries: "Beneficiários",
            beneficiary: "Beneficiário",
            search: "Pesquisar por beneficiário",
            add_beneficiary: "Adicionar Beneficiário",
            new_beneficiary: "Nova Beneficiário",
            ownership: "Titularidade",
            confirm: {
              title: "Deletar o beneficiário?",
              description: "Isso vai permanentemente deletar o beneficiário",
            },
          },
          schedule: {
            schedules: "Agendas",
            schedule: "Agenda",
            search: "Pesquisar por agenda",
            add_schedule: "Adicionar Agenda",
            new_schedule: "Nova Agenda",
            identifier: "Identificador",
            confirm: {
              title: "Deletar o agenda?",
              description: "Isso vai permanentemente deletar o agenda",
            },
            errors: {
              identifier: "O identificador é obrigatório",
            },
          },
          servicePeriod: {
            service_periods: "Períodos de Atendimento",
            service_period: "Período de Atendimento",
            search: "Pesquisar por período de atendimento",
            add_service_period: "Adicionar Período de Atendimento",
            new_service_period: "Nova Período de Atendimento",
            start_date: "Data de Início",
            end_date: "Data de Fim",
            service_types: "Tipos de Atendimento",
            confirm: {
              title: "Deletar o período de atendimento?",
              description:
                "Isso vai permanentemente deletar o período de atendimento",
            },
            errors: {
              start_date: "A data inicial é obrigatória",
              end_date: "A data final é obrigatória",
              service_type: "Selecione ao menos um tipo de atendimento",
            },
          },
          confirm: {
            title: "Deletar a regra de geração?",
            description: "Isso vai permanentemente deletar a regra de geração",
          },
          errors: {
            name: "O nome é obrigatório",
            data_origin: "A origem dos dados é obrigatória",
          },
        },
        listGeneration: {
          lists_generation: "Geração de Listas",
          list_generation: "Geração de Lista",
          search: "Pesquisar por gerar lista",
          add_list_generation: "Adicionar Geração de Lista",
          new_list_generation: "Nova Geração de Lista",
          generate_list: "Gerar Lista",
          generated_successfully: "Lista gerada com sucesso!",
          name: "Nome",
          generation_rule: "Regra de Geração",
          confirm: {
            title: "Deletar a geração de lista?",
            description: "Isso vai permanentemente deletar a geração de lista",
          },
          errors: {
            name: "O nome é obrigatório",
            generation_rule: "A regra de geração é obrigatória",
          },
        },
      },
      "4uMarCom": {
        campaigns: {
          title: "Cadastros de Campanhas",
          campaign: "Campanha",
          search: "Pesquisar por campanha",
          add: "Adicionar Campanha",
          new: "Nova Campanha",
          name: "Nome",
          description: "Descrição",
          type: "Tipo",
          enable: "Habilitar",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          confirm: {
            title: "Deletar a campanha?",
            description: "Isso vai permanentemente deletar a campanha",
          },
          errors: {
            name: "O nome é obrigatório",
            type: "O tipo é obrigatório",
          },
        },
        communicationPermissions: {
          title: "Permisão de Comunicação",
          communication_permissions: "Permisão de Comunicação",
          search: "Pesquisar por permisão de comunicação",
          name: "Nome",
          type: "Tipo",
          document: "Documento",
          birthOfDate: "Data de Nascimento",
        },
        automationRules: {
          title: "Regras de Automação",
          automation_rule: "Regras de Automação",
          search: "Pesquisar por regras de automação",
          add: "Adicionar Regra de Automação",
          new: "Nova Regra de Automação",
          created_by: "Criado por",
          name: "Nome",
          enable: "Habilitar",
          type: "Tipo",
          status: "Status",
          active: "Ativo",
          inactive: "Inativo",
          distribution_list: "Lista de Distribuição",
          classifications: "Classificações",
          categories: "Categorias",
          time_rule: "Regra de Tempo",
          send_service: "Serviço de Envio",
          messages: "Mensagens",
          marcom_type: "Tipo de MarCom",
          send_ype: "Tipo de Envio",
          campaign: "Campanha",
          confirm: {
            title: "Deletar a regras de automação?",
            description:
              "Isso vai permanentemente deletar a regra de automação",
          },
          errors: {
            name: "O nome é obrigatório",
            type: "O tipo é obrigatório",
            marcom_type: "O tipo de MarCom é obrigatório",
            send_type: "O tipo de envio é obrigatório",
            campaign: "A campanha é obrigatória",
          },
          ticketautomationRules: {
            automation_rules: "Regras de Automação",
            automation_rule: "Regra de Automação",
            new_automation_rule: "Nova regra de automação",
            search: "Pesquise por uma regra de automação",
            add_automation_rule: "Adicionar regra de automação",
            ticket_channels: "Quadros",
            ticket_channels_subtitle:
              "Caso não for informado nenhum quadro a regra estará disponível para todos os quadros",
            add_ticket_channels: "Quadros adicionados",
            automation_message_ticket_automation_template:
              "Template após Resposta",
            name: "Nome",
            automation: "Automação",
            created_by: "Criado por",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            event: "Evento",
            ticket_service: "Serviço de ticket(card)",
            action_after_24_hours: "Ação após 24 horas",
            select_action_after_24_hours: "Selecione a ação após 24 horas",
            restart_conversation: "Reinício de conversa",
            new_contact_attempt: "Nova tentativa",
            both: "Ambos",
            no_action: "Sem ação",
            initial_date: "Data de início",
            end_date: "Data de fim",
            whatsapp_template: "Template do WhatsApp",
            robot: "Robô",
            attendant: "Atendente",
            pendent: "Pendência de Envio",
            when_error: "Quando der algum erro ao disparar o template",
            when_blacklist: "Quando o contato estiver na blacklist",
            automation_message_ticket_defaul_doc: "Protocolo Padrão",
            automation_tasy_orientation: "Orientação Tasy",
            board: "Quadro",
            list: "Lista",
            time_rule: "Regra de tempo",
            automation_message: "Mensagem de automação",
            messages: "Mensagens",
            created_successfully: "Regra de automação criada com sucesso",
            confirm: {
              title: "Deletar regra de envio?",
              description: "Isso vai permanentemente deletar a regra de envio",
            },
            errors: {
              name: "O nome é obrigatório",
              ticket_automation: "A automação é obrigatória",
              ticket_event: "O evento é obrigatório",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              ticket_automation_template:
                "O template do WhatsApp é obrigatório",
              ticket_channel_step_robot: "A lista para o robô é obrigatória",
              ticket_channel_step_attendant:
                "A lista para o atendente é obrigatória",
              ticket_channel_step_pendent:
                "A lista para a pendência de envio é obrigatória",
              action_after_24_hours: "A ação após 24 horas é obrigatória",
              initial_date_bigger:
                "A data de início deve ser menor que a data de fim",
            },
          },
          marcom_categories: {
            title: "Categorias",
            new: "Nova Categoria",
            list_category: "Categoria",
            add_category: "Adicionar Categoria",
            search: "Pesquisar por categoria",
            confirm: {
              title: "Deletar a categoria?",
              description: "Isso vai permanentemente deletar a categoria",
            },
            errors: { list_category: "A categoria é obrigatória" },
          },
          marcom_classifications: {
            title: "Classificações",
            new: "Nova Classificação",
            list_classification: "Classificação",
            add_classification: "Adicionar Classificação",
            search: "Pesquisar por classificação",
            confirm: {
              title: "Deletar a classificação?",
              description: "Isso vai permanentemente deletar a classificação",
            },
            errors: {
              list_classification: "A classificação é obrigatória",
            },
          },
          marcom_distributionList: {
            title: "Lista de Distribuição",
            new: "Nova Lista de Distribuição",
            list: "Lista",
            add_List: "Adicionar Lista",
            search: "Pesquisar por lista",
            confirm: {
              title: "Deletar a lista?",
              description: "Isso vai permanentemente deletar a lista",
            },
            errors: { list: "A lista é obrigatória" },
          },
          marcom_message: {
            message: "Mensagem",
            new_message: "Nova Mensagem",
            name: "Nome",
            start_date: "Data de Início",
            end_date: "Data de Fim",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            search: "Pesquisar por mensagem",
            add_message: "Adicionar Mensagem",
            enable: "Ativar",
            exception: "Exceção",
            isMoveHumanAttendant: "Mover para atendente(membro) previsto",
            priority: "Prioridade",
            ticket_flow_pattern: "Padrão de fluxo do ticket",
            opened_with_flow_direction: "Aberto com direcionamento de fluxo",
            finished_from_start: "Finalizado desde o inicio do disparo",
            ticket_channel: "Quadro",
            ticket_channel_step: "Lista",
            ticket_automation_received_rule: "Regra de Recebimento",
            ticket_automation_received_rule_info:
              "Para o correto funcionamento recomenda-se a utilização de um template com os botões Sim/Não",
            move_ticket_when_not_identified:
              "Mover quando a resposta não for identificada",
            confirm: {
              title: "Deletar a mensagem?",
              description: "Isso vai permanentemente deletar a mensagem",
            },
            errors: {
              name: "O nome é obrigatório",
              start_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              ticket_channel: "O quadro é obrigatório",
              ticket_channel_step: "A lista é obrigatória",
              ticket_automation_received_rule:
                "A regra de recebimento é obrigatória",
              ticket_channel_when_not_identified: "O quadro é obrigatório",
              ticket_channel_step_when_not_identified: "A lista é obrigatória",
            },
          },
          marcom_timerule: {
            time_rule: "Regra de Tempo",
            new_time_rule: "Nova Regra de Tempo",
            time_classification: "Classificação de Tempo",
            type: "Tipo",
            value: "Valor",
            add_time_rule: "Adicionar Regra de Tempo",
            search: "Pesquisar por regra de tempo",
            confirm: {
              title: "Deletar a regra de tempo?",
              description: "Isso vai permanentemente deletar a regra de tempo",
            },
            errors: {
              time_classification: "A classificação de tempo é obrigatória",
              type: "O tipo é obrigatório",
              value: "O valor é obrigatório",
            },
          },
        },
      },
    },
    components: {
      usecopy: {
        copied_successfully: "Copiado com sucesso",
        copied_error: "Não foi possível copiar",
      },
      copyButton: {
        copy: "Copiar",
      },
      content: {
        contents: "Conteúdos",
        add_new_content: "Adicionar conteúdo",
        add_new_video: "Adicionar vídeo",
        content_type: "Tipo de notícia",
        content_status: "Status da notícia",
        enable: "Habilitar",
        reading_time: "Tempo de leitura",
        reading_time_info: "Tempo em minutos",
        site_app: "Aplicações",
        title: "Título",
        language: "Idioma",
        language_tooltip: "Ver idioma",
        summary: "Resumo",
        publication_date: "Data de publicação",
        content_tags: "Tags da notícia",
        is_published: "Publicar",
        status: "Status",
        published: "Publicada",
        link: "Link do vídeo",
        link_helper: "Adicione um link do youtube",
        display_order: "Ordem",
        not_published: "Não publicada",
        enabled: "Ativo",
        inactive: "Inativo",
        videos: "Vídeos",
        highlight_end: "Destaque encerrado em",
        highlight_start: "Destaque iniciado em",
        confirm: {
          title: "Deletar o conteúdo?",
          description: "Isso vai permanentemente deletar o conteúdo",
        },
        errors: {
          reading_time: "O tempo de leitura é obrigatório",
          site_apps: "Ao menos uma aplicação é obrigatório",
          language: "O idioma é obrigatório",
          title: "O título é obrigatório",
          tags: "Ao menos uma tag da notícia é obrigatória",
          summary: "O resumo é obrigatório",
          content: "O conteúdo é obrigatório",
          display_order: "A ordem de exibição é obrigatória",
          contents: "Ao menos um conteúdo é obrigatório",
          file: "O arquivo é obrigatório",
          link: "O link é inválido. Por favor adicione um link do Youtube",
          highlight_end: "A data de fim não pode ser maior que a de início",
        },
      },
      schedule: {
        selectAll: "Selecionar todos",
        seeMore: "Ver mais {{quantity}}",
        day: "Dia",
        week: "Semana",
        month: "Mês",
        today: "Hoje",
        newSchedule: {
          button: "Agendar",
          title: "Novo agendamento",
          date: "Data",
          required: "Campo obrigatório",
          hour: "Horário",
          professional: "Profissional",
          type: "Tipo de agendamento",
          duration: "Duração",
          confirm_contact_phone: "Confirme seu telefone de contato",
          main_whatsapp_number: "Esse é meu WhatsApp principal",
          phone_number: "Número de Telefone",
          insurance: {
            add: "Adicionar Convênio",
            edit: "Editar Convênio",
            validate: "Validade da carteirinha",
            code: "Número da carteirinha",
            number: {
              label: "Número da carteirinha (opcional)",
              error: "O número é obrigatório",
            },
            validity: {
              label: "Validade da carteirinha (opcional)",
              error: "A validade é obrigatória",
            },
            individual: {
              label: "Paciente",
              error: "O paciente é obrigatório",
            },
            insurance: {
              label: "Convênio",
              error: "O convênio é obrigatório",
            },
          },
        },
        menu: {
          source: {
            both: "Todos",
          },
          exams: "Exames",
          subtitle: {
            title: "Legenda",
            someFree: "Existem livres",
            full: "Todos ocupados",
            allFree: "Todos livres",
          },

          period: "Período",
          situation: "Situação",
          both: "Ambas",
          specialitys: "Especialidades",
          professionals: {
            label: "Profissionais",
            noOptionsText: "Nenhum profissional encontrado",
            loading: "Carregando...",
          },
        },
        schedulePopover: {
          copy: "Copiar identificador",
          copyCardNumber: "Copiar número da carteirinha",
          cancel: "Cancelar agendamento",
          insurance: "Convênio",
          confirm: "Confirmar cancelamento",
          cancelButton: "Cancelar",
          justification: {
            label: "Justificativa",
            placeholder: "Digite uma justificativa",
            error: "A justificativa é obrigatória",
          },
          reason: {
            label: "Razão",
            placeholder: "Selecione uma razão",
            error: "A razão é obrigatória",
          },
          cancelDescription:
            "Cancelar consulta de {{pacient}} com {{doctor}} em {{date}}",
        },
      },
      scheduleAssistant: {
        button: "Assistente de Agendamento",
        insurance: {
          title: "Meus Convênios",
          subtitle: "Gerencie os seus convênios e os do grupo familiar",
          add: "Adicionar",
          insuranceName: "Convênio",
          individual: "Indivíduo",
          cardNumber: "Número do cartão",
          cardValidity: "Validade",
          delete: {
            title: "Deletar convênio?",
            description: "Essa ação é permanente!",
            confirmationText: "Sim, deletar",
            cancellationText: "Cancelar",
          },
          addInsurance: {
            edit: "Editar convênio",
            add: "Adicionar convênio",
            buttonSave: "Salvar",
            buttonEdit: "Editar",
            number: {
              label: "Número da carteirinha (opcional)",
              error: "O número é obrigatório",
            },
            validity: {
              label: "Validade da carteirinha (opcional)",
              error: "A validade é obrigatória",
            },
            individual: {
              label: "Paciente",
              error: "O paciente é obrigatório",
            },
            insurance: {
              label: "Convênio",
              error: "O convênio é obrigatório",
            },
          },
        },
        newSchedule: {
          success: "Agendamento cadastrado com sucesso",
          sched: "Agendar",
          next: "Próximo",
          back: "Voltar",
          finish: "Finalizar",
          notAvaiableModal: {
            button: "Ok",
            description:
              "O horário escolhido não está mais disponível, por favor selecione outro horário.",
          },
          steps: {
            patient: {
              title: "Selecione o paciente",
              error: "O paciente é obrigatório",
            },
            insurance: {
              title: "Selecione o convênio",
              error: "O convênio é obrigatório",
            },
            search: {
              title: "Procure por uma agenda",
              specialityError: "A especialidade é obrigatória",
              periodError: "O período é obrigatório",
              examError: "O exame é obrigatório",
            },
            schedule: {
              title: "Selecione uma data e um horário",
              error: "O horário é obrigatório",
            },
            confirm: "Confirmar dados",
          },
          insurance: "Convênio",
          addInsurance: "Adicionar convênio",
          addFamilyGroup: "Adicionar familiar",
          search: {
            from: "A partir de",
            examGroup: "Exame",
            professional: "Profissional (opcional)",
            speciality: "Especialidade",
            type: "Tipo de agendamento",
            period: "Período",
          },
          schedule: {
            freeDays: "Dias com datas disponíveis",
          },
          confirm: {
            descriptionSite: "Profissional",
            patient: "Paciente",
            insurance: "Convênio",
            schedule: "Agendamento",
            confirm_contact_phone: "Confirme seu telefone de contato",
            main_whatsapp_number: "Esse é meu WhatsApp principal",
            phone_number: "Número de Telefone",
          },
        },
      },
      panel: {
        add_dashboard: "Adicionar Dashboard",
        select: "Selecione e ordene os componentes",
        helper_text: "O Dashboard deve ter ao menos um componente",
        no_data: "Sem dados",
        not_found: "Painel não encontrado",
        reviews: "avaliações",
        search_placeholder: "Pesquise por um nome",
        order: "Ordenação",
        name: "Nome",
        value: "Valor",
        attendant: "Atendente",
        xAxis: "Horas",
        ticketChannelName: "Quadro",
        count: "Quantidade",
        search: "Pesquisar por um componente",
        select_all: "Selecionar todos",
        select_components: "Selecione os componentes",
        next: "Avançar",
        average_asc: "Menor Nota",
        average_desc: "Maior Nota",
        view_comments: "Ver comentários",
        comments: "Comentários",
        filters: "Filtros:",
        filters_modal: {
          filters: "Filtros Aplicados",
          tooltip: "Ver filtros aplicados",
        },
        filter: {
          day: "Dia",
          week: "Semana",
          month: "Mês",
          year: "Ano",
        },
        no_dashboards:
          "Nenhum dashboard encontrado, adicione seu primeiro dashboard!",
        select_tooltip: "Selecionar e ordenar componentes",
        delete_dashboard: {
          delete: "Deletar dashboard",
          title: "Deletar dashboard {{ name }}",
          description:
            "Isso vai permanentemente deletar o seu dashboards e seus dados.",
          cancel: "Cancelar",
          confirm: "Sim, deletar",
        },
        helper: {
          title: "Informações sobre os dados dos Dashboards",
          first:
            "Os dados dos dashboards são atualizados automaticamente uma vez por dia, durante a madrugada, sempre considerando as informações até o dia anterior.",
          second:
            "<1>Diário:</1> exibe os dados de um único dia. As informações do dia atual ficam disponíveis a partir da madrugada seguinte.",
          third:
            "<1>Semanal:</1> considera a semana de segunda a domingo. A semana em andamento é atualizada diariamente com os dados até o dia anterior e fica completa na madrugada de segunda-feira.",
          fourth:
            "<1>Mensal:</1> o mês em andamento é atualizado diariamente com os dados até o dia anterior e fica completo na madrugada do dia 1º do mês seguinte.",
          fifth:
            "<1>Anual:</1> o ano em andamento é atualizado diariamente com os dados até o dia anterior e fica completo na madrugada de 1º de janeiro.",
          sixth:
            "<1>Novos dashboards e componentes:</1> ao adicionar um dashboard ou ativar um componente, o histórico de dados é processado em segundo plano e pode levar alguns minutos para ser exibido por completo.",
        },
        enable_component: {
          title: "Ativar componente",
          title_all: "Ativar todos os componentes",
          description:
            "Ao ativar este componente, todo o histórico de dados dele será processado em segundo plano. Isso pode levar alguns minutos até aparecer por completo no dashboard. Deseja continuar?",
          description_all:
            "Ao ativar os componentes, o histórico de dados de cada um será processado em segundo plano. Isso pode levar alguns minutos até aparecer por completo no dashboard. Deseja continuar?",
          cancel: "Cancelar",
          confirm: "Sim, ativar",
        },
      },
      selectBool: {
        true: "Verdadeiro",
        false: "Falso",
      },
      menu: {
        home: {
          home: "início",
          begin: "resumo",
          dashboard: "painel",
        },
        "4uSched": {
          calendar: {
            calendar: "Calendário",
            tasyCalendar: "Tasy - Consultas e Exames",
          },
        },
        myDashboards: {
          myDashboards: "Dashboards",
          dashboards: "KPIs Configuração",
          view: "Painéis de KPIs",
          executions: "Histórico execuções",
          generateConfig: "Configuração Dashboards",
        },
        reports: {
          reports: "Relatórios",
          crm: "CRM",
          internal: "Internos",
        },
        people: {
          people: "Pessoas",
          individuals: "pessoa física",
          legalEntities: "pessoa jurídica",
          individualValidations: "Validação Cadastro PF",
        },
        registers: {
          beneficiaries: "beneficiários",
          doctors: "médicos",
          userProfiles: "perfis de usuário",
          client: "cliente",
          templates: "modelos",
          integrations: "integrações",
          documents: "Termos e políticas",
          holidays: "Feriados",
        },
        admSystem: {
          admSystem: "Adm. Sistema",
          users: "usuários",
          establishmentParams: "Parâmetros Gerais",
          roles: "Perfil",
          establishments: "Estabelecimentos",
          aditionalSettings: {
            aditionalSettings: "Configurações adicionais",
            cardsTemplates: "Modelos de carteirinhas",
          },
          companygroups: "Grupos Empresariais",
          companies: "Empresas",
          companyDigitalCertificates: "Certificados Digitais",
        },
        globals: {
          globals: "Globais",
          languages: "idiomas",
          menus: "menus",
          generics: "genéricos",
          countries: "países",
          extensions: "extensões",
          cities: "cidades",
          neighborhoods: "bairros",
          provinces: "estados",
          banks: "bancos",
          jobs: "jobs",
          paramsDefaultEstablishment: "Parâmetros padrão do estabelecimento",
        },
        menu_secondary_item: {
          modal_title: "Em desenvolvimento",
          modal_content:
            "Ainda estamos trabalhando no desenvolvimento desta tela, em breve traremos novidades.",
        },
        secondary_menu: {
          suport: "Suporte",
          configs: "Configurações",
          extensions_store: "Loja de extensões",
        },
        applications: {
          applications: "Aplicações",
          register: "Cadastro",
        },
        "4uChatBot": {
          templates: {
            templates: "Templates",
            whatsapp: "WhatsApp",
            internal: "Interno CRM",
            general: "Gerais",
          },
          createAutomations: {
            createAutomations: "Automações",
            automationRules: "Regras de Envio",
            receivedAutomationRules: "Regras de Recebimento",
          },
          fluxos: {
            fluxos: "Fluxos",
            serviceWhatsapp: "Atendimento WhatsApp",
          },
          logs: {
            logs: "Logs",
            calendarControl: "Consulta Horários Disponibilizados",
            ticketsHistory: "Histórico Tickets",
            examSchedulingAttachmentLog:
              "Log Anexos dos Agendamentos de Exames",
          },
          registrationsAndRules: {
            registrationsAndRules: "Cadastros e Regras",
            ticketServiceArea: "Área de atendimento",
            ticketServiceDay: "Horário de atendimento",
            ticketServiceMessage: "Mensagens",
            blacklist: "Blacklist",
            ticketFinishReason: "Motivo de fechamento de ticket",
            ticketChannelMemberAvailabilityPauseReason: "Motivo de Pausa",
            banList: "BanList",
            appointmentarrivalrule: "Horário de chegada de agendas",
          },
        },
        "4uDonation": {
          donors: {
            donors: "Doadores",
            register: "Cadastrar Doadores",
          },
        },
        "4uTotem": {
          applications: {
            applications: "Aplicações",
            myTotens: "Meus totens",
          },
          register: {
            register: "Cadastro",
            totemDevices: "Dispositivos Totem",
          },
        },
        evaluation: {
          evaluation: "Avaliações",
          questions: "Questões",
          evaluationForms: "Formulários",
          evaluationLogs: "Logs de Integração",
          evaluationLogsTicket: "Logs Pesquisa Satisfação Ticket",
          activeServiceSearchSurvey:
            "Logs Pesquisa de Busca Ativa de Atendimento",
        },
        chatBot: {
          register: "Cadastro",
          ticket_service: "Serviços de tickets(cards)",
          service: "Atendimento",
          ticket_service_area: "Área de atendimento",
          ticket_protocol_rule: "Regras de geração de protocolo",
          ticket_service_day: "Horário de atendimento",
          ticket_service_message: "Mensagens",
        },
        logs: {
          logs: "Logs",
          healthcheck: "Health Checks",
          logRegisterError: "Erros de Cadastro",
        },
        settings: {
          system: {
            system: "Sistema",
            generalSettings: {
              generalSettings: "Configurações globais",
              correios: "Correios",
              centralBank: "Banco central",
              geolocalization: "Geolocalização",
              certillion: "Certillion",
            },
            cache: "Cache",
            paramsDefaultEstablishment: "Parâmetros padrão do estabelecimento",
            executeSql: "Executar SQL",
          },
          generalSettings: {
            generalSettings: "Configurações gerais",
            holidays: "Feriados",
            establishmentParams: "Parâmetros do estabelecimento",
            healthChecks: "Health Checks de Microsserviços 4uHub",
          },
          applications: {
            applications: "Aplicações",
            cardsTemplates: "Templates de carteirinha",
          },
          crm: {
            crm: "CRM",
            chatBot: {
              chatBot: "ChatBot",
              ticketServiceArea: "Áreas de atendimento",
              ticketServiceMessage: "Mensagens",
            },
            ticketProtocolRule: "Regras de geração de protocolo",
            ticketService: "Serviço de tickets(cards)",
            ticketAutoFinishRule: "Regras de finalização de ticket(card)",
            ticketAutoTransferRule: "Regras de transferência de ticket(card)",
            ticketDefaultDocs: "Protocolos de Orientações Padrão",
            ticketDefaultDocCategories:
              "Categorias de Protocolos de Orientações Padrão",
            events: "Eventos",
            externalProcessType: "Tipos de Processos Externos",
            quickAnswer: "Mensagens Rápidas",
            sendLimitMonths: "Limites de Disparo Mensal (Orçamento da Empresa)",
            sendLimitDiaries:
              "Limites de Disparo Diário (Permitido Pelo WhatsApp)",
            ticketAutoInactivityRule: "Regras de Inatividade de Ticket(card)",
          },
          chatBot: {
            chatBot: "ChatBot",
            ticketServiceArea: "Áreas de atendimento",
            ticketServiceMessage: "Mensagens",
            ticketServiceDay: "Horário de atendimento",
          },
          hcp: {
            hcp: "4uHcP",
            healthProgramTypes: "Tipos de programas de saúde",
            workGroupTypes: "Tipos de grupos de trabalho",
          },
          "4uBus": {
            "4uBus": "4uBus",
            ipm: {
              ipm: "IPM",
              generalSettings: "Configurações gerais",
            },
            globals: {
              globals: "Configurações gerais",
              sync: "Sincronização",
            },
            zscan: {
              zscan: "ZScan",
              examSendRule: "Regra de envio de exame",
            },
            externalExamPrescription: {
              externalExamPrescription:
                "Geração de Prescrição do Pedido de Exame Externo",
              rules: "Regras de Geração de Prescrição",
            },
          },
          "4uSched": {
            "4uSched": "4uSched",
            menuSchedulingPortalApp: "Menu Agendamento Portal e APP",
            tasyCalendar: {
              tasyCalendar: "Agenda Tasy",
              checkIn: "Check in",
              confirmation: "Confirmação de Agenda",
              scheduleFilterUser: "Agenda X Usuário 4uHub",
            },
          },
          "4uSiteApp": {
            "4uSiteApp": "4uSiteApp",
            digitalTriage: {
              digitalTriage: "Check in da Triagem PA Digital",
              checkIn: "Check in",
            },
          },
        },

        "4uSiteApp": {
          applications: {
            applications: "Aplicações",
            register: "Cadastro",
            myApplications: "Minhas aplicações",
          },
          communication: {
            communication: "Comunicação",
            banners: "Banners",
            notifications: "Notificações",
            news: "Notícias",
          },
          privacyAndSecurity: {
            privacyAndSecurity: "Segurança e Privacidade",
            termsAndPolicies: "Termos e políticas",
            loginContents: "Conteúdo de Login",
          },
          sac: {
            sac: "SAC e Ouvidoria",
            faq: "FAQ",
          },
          consultationsAndLogs: {
            consultationsAndLogs: "Consulta e Logs",
            beneficiarySituation: "Situação do beneficiário",
          },
        },
        "4uHcP": {
          structure: {
            structure: "Estrutura de programas",
            healthPrograms: "Programas de saúde",
            workGroups: "Grupos de Trabalho",
          },
          content: {
            content: "Conteúdo",
            contentRules: "Regras de Conteúdo",
          },
          captation: {
            captation: "Captação",
            captations: "Captações",
            imports: "Importações",
          },
        },
        "4ubus": {
          automations: {
            automations: "Automações",
            fileIntegration: "Integração de Arquivos",
            zscanExamSendRule: "Regras de Envio de Exames do ZScan",
            integrationRule: "Regras de Integração",
          },
          register: {
            register: "Cadastro",
            accessTokens: "Tokens Externos",
            profileTasy: "Perfil Externo",
            processes: "Processos",
            services: "Serviços",
            accessTokens4uHub: "Tokens do 4uHub",
            profile4uhub: "Perfil – Barramento 4uHub",
          },
          setRelationships: {
            setRelationships: "Relacionamentos",
            ipm: "IPM x TASY",
            "4uHub": "Tasy - Call Center",
            tasyReceivePatientEncounters: "Tasy - Receber Atendimentos",
            zscanEvo: "ZScan Evo",
            nfeTotvs: "Tasy > TOTVS - NFE",
            invoiceLoweringTotvs: "Tasy > TOTVS - Baixa Títulos",
            relationshipGroup: "Tasy > RNDS - Imunização SI-PNI",
            syncPhysicalPerson: "Sync Pessoa",
            tasyToTasy: "Tasy x Tasy",
            tasyOps: "Tasy OPS - (Execução Requisição)",
          },
          restriction: {
            restriction: "Restrições",
            rule: "Agenda",
          },
          logs: {
            logs: "Logs",
            ipmxtasyinternal: "IPM - Receber - IPM x Tasy (Interno)",
            logFileIntegration: "Integração de Arquivos",
            tasyxipminternal: "IPM - Enviar - Tasy x IPM (Interno)",
            tasyCalendar: "Agendas Tasy",
            ipmtasy: "IPM - Receber - IPM x Tasy",
            tasyipm: "IPM - Enviar - Tasy x IPM",
            monitoring: "Monitoramento OnPremise",
            examFilesLogIntegration: "Tasy - Log de integração de arquivos",
            accessDbObjectErrors: "Erro acesso objetos Tasy",
            meuNovoLog: "Meu Novo Log",
            externalLogError: "LogError",
            nfeTotvs: "Tasy > TOTVS - NFE",
            syncPersons: "Sync - Dados das pessoas",
            forubusVaccine: "Tasy > RNDS - Imunização SI-PNI",
            refund: "Reembolsos",
            invoiceServiceAgy: "Tasy > Invoice Service Agy",
            patientEncounterExecuteRequest:
              "Tasy OPS - Gerar Atendimento e Prescrição da OPS - Autorização (Execução Requisição)",
            patientEncounterPsTransferRequest:
              "Tasy EMR - Gerar novo Atendimento no PS, a partir de inelegibilidade de atendimento do PA",
            examManagementNotificationLog: "Email Notificações Laudos",
            gerAcessoVisitControlPacient:
              "Tasy GerAcesso - Envio de Controle de Acesso do Acompanhante do Paciente",
            gerAcessoVisitControlVisitor:
              "Tasy GerAcesso - Envio de Controle de Acesso do Visitante do Paciente",
            gerAcessoVisitControlSector:
              "Tasy GerAcesso - Envio de Controle de Acesso do Visitante do Setor",
            invoiceLoweringTotvs: "Tasy > TOTVS - Baixa Títulos",
            tasyToTasyNonLabExamsAvailable:
              "Tasy <> Tasy - Exames Não laboratoriais (Disponibilizados)",
            tasyToTasyNonLabExamsReceived:
              "Tasy <> Tasy - Exames Não laboratoriais (Recebidos)",
            serviceReceived: "Tasy - Receber Atendimentos",
            tasyToTasyResultsNonLabAvailable:
              "Tasy <> Tasy - Resultados Exames Não laboratoriais (Disponibilizados)",
            tasyToTasyResultsNonLabReceived:
              "Tasy <> Tasy - Resultados Exames Não laboratoriais (Recebidos)",
            syncTransaction: "Sync - Dados das Transações",
          },
          robots: {
            robots: "Robôs",
            list: "Lista",
          },
        },
        "4uSalesContract": {
          register: {
            register: "Cadastros",
            salesGrantors: "Outorgantes",
            salesContractAttachmentTypes: "Tipo de Anexo de Contrato",
            salesContractClassifications: "Classificação de Contrato",
            salesProductCtrClassifications: "Classificação de Produtos",
            salesChannelClassifications: "Classificações de Canal de Vendas",
            salesChannels: "Canais de Vendas",
            salesProductCtrs: "Produto",
            salesContractTerminationReason: "Motivo de Cancelamento Contrato",
            beneficiaryContractReasonOfTerminations:
              "Motivo de Termino Beneficiário",
            salesContractBeneficiaryClassifications:
              "Classificação de Beneficiário",
            beneficiaryContractReasonOfCancellations:
              "Motivo de Cancelamento Beneficiário",
            beneficiaryContractReasonOfSuspensions:
              "Motivo Suspensão Beneficiário",
          },
          salesContract: {
            salesContract: "Contratos",
            salesContractClubAbs: "Clube de Vantagens e Benefícios",
          },
        },
        "4uESign": {
          createAutomations: {
            createAutomations: "Automações",
            automationRules: "Regras de automação",
            emailSendRules: "Envio de e-mail",
            signatureGroups: "Grupos de Assinatura",
          },
          logs: {
            logs: "Logs",
            forubusSignatureLogs: "Logs de assinatura",
          },
        },
        "4uDlist": {
          register: {
            register: "Cadastros",
            classification: "Classificações",
            category: "Categorias",
          },
          imports: {
            imports: "Importações",
            listFiles: "Importação de Listas",
            listImportAutomation: "Automação Para Gerar Listas de Distribuição",
          },
          distributionList: {
            distributionList: "Listas de Distribuição",
            list: "Listas de Distribuição",
          },
          listGenerator: {
            listGenerator: "Gerador de Listas",
            generationRules: "Regras de Geração",
            generateList: "Geração de Listas",
          },
        },
        "4uMarCom": {
          campaigns: {
            campaigns: "Campanhas",
            campaignRegister: "Cadastro de Campanhas",
          },
          templates: {
            templates: "Templates",
            whatsapp: "WhatsApp",
          },
          automations: {
            automations: "Automações",
            automationRule: "Regras de Automação",
          },
          optInOptOut: {
            optInOptOut: "Opt-in / Opt-out",
            permissionCommunication: "Permissões de Comunicação",
            distributionList: {
              distributionList: "Listas de Distribuição",
              list: "Controles de Listas",
            },
          },
        },
      },
      logs_accordions: {
        user: "Usuário:",
        duration: "Duração:",
      },
      logs_table: {
        name: "Nome",
        original_value: "Dados originais",
        new_value: "Dados novos",
        button_see_more: "Ver mais",
      },
      logs_no_data: {
        message: "Dados não encontrados!",
      },
      roles: {
        title: "Perfil",
        name: "Nome",
        establishment: "Estabelecimento",
        search_name: "Procure por um nome",
        new_role: "Novo perfil",
        privileges_tab: "Privilégios",
        dashboards_tab: "Dashboards",
        reports_tab: "Relatórios",
        dashboard_panel: "Dashboard",
        dashboard_panels: "Dashboards",
        add_dashboard_panel: "Adicionar dashboard",
        search_dashboard_panel: "Buscar dashboard",
        report: "Relatório",
        reports: "Relatórios",
        add_report: "Adicionar relatório",
        search_report: "Buscar relatório",
        code: "Código",
        report_with_code: "#{{code}} - {{name}}",
        edit_link: "Editar",
        delete_link: "Remover",
        cancel: "Cancelar",
      },
      roles_basic_data: {
        name: "Nome",
        description: "Descrição",
      },
      roles_establishments: {
        title: "Estabelecimentos",
        add_establishments: "Adicionar novo estabelecimento",
        name: "O nome é obrigatório",
        label: "Estabelecimento(s) que poderão utilizar este perfil",
        establishmentsTypeId: "Selecione um estabelecimento",
        establishments_tooltip: "Ver estabelecimentos",
      },
      roles_privileges: {
        title: "Privilégios",
        add_privileges: "Adicionar novo privilégio",
      },
      forgetPasswordForm: {
        title: "Esqueceu a senha?",
        subtitle:
          "Insira seu CPF abaixo e enviaremos um código no seu e-mail para a recuperação de senha.",
        button: "Enviar",
        sending: "Enviando",
        login: "CPF",
        login_required: "O campo CPF é obrigatório!",
        notification_email_sent: "Email enviado com sucesso!",
        back_login: "Voltar para o login",
      },
      forgetPasswordModal: {
        title: "Instruções enviadas!",
        message:
          "Nós enviamos instruções de alteração da senha para o seu email, por favor cheque todas as caixas de entrada e a pasta de spam.",
        close: "Fechar",
      },
      resetPasswordForm: {
        title: "Nova senha",
        subtitle:
          "Digite  o código enviado para seu email. Se não encontrá-lo verifique a área de spam.",
        password: "Senha",
        confirm_password: "Confirmar senha",
        confirmation_code: "Código de confirmação",
        sending: "Enviando",
        send: "Enviar",
        new_password_required: "O campo senha é obrigatório.",
        confirm_new_password_required:
          "O campo de confirmar senha é obrigatório.",
        passwords_match: "As senhas não coincidem.",
        confirmation_code_required: "O código de confirmação é obrigatório",
        notification_password_success: "Senha alterada com sucesso!",
      },
      noRowsMessage: {
        no_permission: "Você não possui permissão para ver as informações",
        no_data: "Você não possui informações cadastradas",
      },
      onPremiseModal: {
        establishment: {
          establishment_on_premise: "Estabelecimento on premise",
          no_data: "Nenhum estabelecimento encontrado",
        },
        params: {
          params_on_premise: "Parâmetros on premise",
          no_data: "Nenhum parâmetro encontrado",
        },
        generics: {
          generics_on_premise: "Genéricos on premise",
          no_data: "Nenhum genérico encontrado",
        },
        health: {
          health_on_premise: "Planos de Saúde sincronizados",
          no_data: "Nenhum plano de saúde encontrado",
        },
        medicSpecialties: {
          no_data: "Nenhuma especialidade médica encontrada",
        },
        providerTypes: {
          no_data: "Nenhum tipo de prestador encontrado",
        },
        professionalCouncils: {
          no_data: "Nenhum conselho profissional encontrado",
        },
        medicalPracticeAreas: {
          no_data: "Nenhuma área de atuação médica encontrada",
        },
      },
      inputFileValidations: {
        invalid_type: "Tipo de arquivo não suportado",
        invalid_size:
          "Tamanho de arquivo não suportado. (Max {{maxFileSize}} MB)",
      },
      cardMenu: {
        button: "Ver mais",
      },
      extensionsStoreHeader: {
        title: "Loja de extensões",
        search: "Pesquisar por uma extensão ou tag",
        add_extensions: "Adicionar extensões",
        my_extensions: "Minhas extensões",
        back: "Voltar",
      },
      extensionsCard: {
        details: "Detalhes",
        install: "Instalar",
        request_install: "Solicitar instalação",
        requested: "Instalação solicitada",
        installing: "Instalando",
        installed: "Instalado",
        setup_requested: "Setup Solicitado",
        free: "Grátis",
        select: "Selecione um site",
        tooltip_install: "Instalação",
        tooltip_month: "Mensalidade",
        site_app: "Sites ou Apps",
        setup_cancel: "Solicitação de Setup Cancelada",
        cancel: "Cancelar Setup",
        errors: {
          site_app: "Selecione ao menos um site ou app para instalar",
        },
      },
      extensionsStoreDetail: {
        title: "Detalhes da extensão",
        free: "Grátis",
        installed: "Instalado",
        about: "Sobre a extensão",
        available_for: "Disponível para",
        install: "Instalar",
        request_install: "Solicitar instalação",
        requested: "Instalação solicitada",
        settings: "Configurar em",
        configure: "Configurar",
        tooltip_install: "Instalar",
        tooltip_uninstall: "Desinstalar",
        tooltip_settings: "Configurações",
        tooltip_month: "Mensalidade",
        tags: "Tags",
        dependencies: "Dependências",
      },
      extensionInstallPopper: {
        title: "Deseja realmente instalar a extensão?",
        request_title: "Deseja realmente solicitar a instalação da extensão?",
        cancel: "Cancelar",
        install: "Instalar",
        request: "Solicitar",
      },
      extensionUninstallPopper: {
        title: "Deseja realmente desinstalar a extensão?",
        cancel: "Cancelar",
        uninstall: "Desinstalar",
        uninstalling: "Desinstalando",
      },
      extensionSettings: {
        title: "Configurar extensão",
        identifier: "Identificador",
        property: "Propriedade",
        value: "Valor",
        description: "Descrição",
      },
      settingsCorreios: {
        url_token: "Token da URL",
        user_token: "Token do Usuário",
        access_token: "Token do Código de Acesso",
        post_card: "Cartão de Postagem",
      },
      settingsGeneral: {
        user_token: "correiosTokenUser",
        access_token: "correiosTokenAccessCode",
        post_card: "correiosTokenPostCard",
        correios_url: "URL dos Correios",
        correios_token_user: "correiosTokenUser",
        correios_authentication: "correiosAuthenticationUrl",
        correios_locations: "correiosLocationsUrl",
        correios_addresses: "correiosAddressesUrl",
        cep_cache_time: "cepCacheTime",
        correios_page_size: "correiosPageSize",
        bank_base: "bankBaseUrl",
        bank_cooperativas: "bankCooperativasUrl",
        bank_bancos: "bankBancosUrl",
        geolocation: "Geolocalização",
        api_geocoding_key: "apiGeocodingKey",
        save: "Salvar",
        saving: "Salvando",
        success: "Configurações gerais atualizadas com sucesso",
        errors: {
          user_token: "O correiosTokenUser é obrigatório",
          access_token: "O correiosTokenAccessCode é obrigatório",
          post_card: "O correiosTokenPostCard é obrigatório",
          correios_url: "A URL dos Correios é obrigatória",
          correios_token_user: "O correiosTokenUser é obrigatório",
          correios_authentication: "O correiosAuthenticationUrl é obrigatório",
          correios_locations: "O correiosLocationsUrl é obrigatório",
          correios_addresses: "O correiosAddressesUrl é obrigatório",
          cep_cache_time: "O cepCacheTime é obrigatório",
          bank_base: "O bankBaseUrl é obrigatório",
          bank_cooperativas: "O bankCooperativasUrl é obrigatório",
          bank_bancos: "O bankBancosUrl é obrigatório",
          correios_page_size: "O correiosPageSize é obrigatório",
          api_geocoding_key: "O apiGeocodingKey é obrigatório",
        },
      },
      certillionSettings: {
        title: "Configurações do Certillion",
        base_url: "URL base",
        client_secret: "Segredo do cliente",
        seconds_to_find_signed_files:
          "Segundos para encontrar arquivos assinados",
        token_path: "Caminho do token",
        upload_file_path: "Caminho do arquivo para upload",
        pscs_accounts_path: "Caminho das contas PSCs",
        client_id: "ID do cliente",
        default_minutes_signature_session:
          "Minutos padrão para a sessão de assinatura",
        authorize_path: "Caminho de autorização",
        signature_path: "Caminho da assinatura",
        client_token_path: "Caminho do token do cliente",
        save: "Salvar",
        saving: "Salvando",
        success: "Configuração atualizada",
        paths: "Paths",
        errors: {
          base_url: "URL base é obrigatória",
          client_secret: "Segredo do cliente é obrigatório",
          seconds_to_find_signed_files:
            "Segundos para encontrar arquivos assinados são obrigatórios",
          token_path: "Caminho do token é obrigatório",
          upload_file_path: "Caminho do arquivo para upload é obrigatório",
          pscs_accounts_path: "Caminho das contas PSCs é obrigatório",
          client_id: "ID do cliente é obrigatório",
          default_minutes_signature_session:
            "Minutos padrão para a sessão de assinatura são obrigatórios",
          authorize_path: "Caminho de autorização é obrigatório",
          signature_path: "Caminho da assinatura é obrigatório",
          client_token_path: "Caminho do token do cliente é obrigatório",
        },
      },
      settingsCache: {
        settingsCacheTotal: {
          clean_all_cache: "Limpeza de Cache Total (exceto Hangfire)",
          clean_all_description:
            "Faz a limpeza de todo o cache da plataforma com exceção dos que são gerenciados pelo HangFire, nosso gerenciador de jobs.",
          clean_all_button: "Limpar",
          clean_all_success: "Cache limpo com sucesso",
        },
        settingsCacheKey: {
          clean_key_cache: "Limpeza de Cache por Chave (aceita chave parcial)",
          clean_key_description:
            "Faz a limpez do cache de acordo com a chave informada. Aceita também informar uma chave parcial. Exemplo: Se for informado EF_ limpará todo o cache do Entity Framework da plataforma. Se for informado hangfire* limpará todo o cache relacionado ao nosso gerenciador de jobs.",
          clean_key: "Chave",
          clean_key_button: "Limpar",
          clean_key_success: "Cache da chave '{{key}}' limpo com sucesso",
          errors: {
            cache_key: "A chave é obrigatória",
          },
        },
        searchCacheKey: {
          search_cache_key: "Pesquisa de Cache por Chave",
          search_cache_description:
            "Faz a pesquisa do cache de acordo com a chave informada. Aceita também informar uma chave parcial. Exemplo: Se for informado *EF_* irá buscar todo o cache do Entity Framework da plataforma. Se for informado *HANGFIRE* irá buscar todo o cache relacionado ao nosso gerenciador de jobs.",
          search: "Pesquisar",
          search_key: "Chave",
          results: "Resultados de busca para a chave",
          no_data: "Nenhuma informação encontrada",
          errors: {
            cache_key: "A chave é obrigatória",
          },
        },
      },
      neighborhood: {
        neighborhood: "Bairro",
        other: "Não encontrei meu bairro e quero digitar um novo",
        cep: "Digite um CEP primeiro",
      },
      addressContent: {
        cep_first: "Digite um CEP primeiro",
      },
      appDomain: {
        domain: "Domínio",
        title: "Copiar domínio",
      },
      nationalHolidays: {
        import_holidays: "Importar feriados nacionais",
        select_all: "Selecionar todos",
      },
      cepInput: {
        zip_code: "CEP",
        helper_text: "Digite um CEP para pesquisar",
        city: "Cidade",
        province: "Estado",
      },
      daysOfWeek: {
        sunday: "Domingo",
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
      },
      notificationInformations: {
        status: "Status",
        is_published: "Status da publicação",
        start_publish: "Início da publicação",
        finish_publish: "Fim da publicação",
        published: "Publicado",
        not_published: "Não publicado",
      },
      notificationBatchActions: {
        generate: "Gerar lote",
        cancel: "Cancelar lote",
        batch_generated: "Lote gerado com sucesso",
        batch_canceled: "Lote cancelado com sucesso",
        cancel_popover_title:
          "Ao cancelar o lote não será mais possível gerar lotes para essa notificação.",
        users: "Usuários notificados",
      },
      searchResults: {
        no_data: "Nenhum resultado encontrado",
      },
      yearSelect: {
        label: "Filtrar por ano",
      },
      syncSection: {
        sync: "Sincronizar",
        view_data: "Visualizar dados integrados",
      },
      syncEstablishment: {
        title: "Estabelecimento",
        description:
          "Sincronizar os dados do Estabelecimento com o ambiente do 4uBus",
        synced: "Dados do Estabelecimento sincronizados com sucesso",
        modal_title: "Dados integrados do estabelecimento",
      },
      syncGeneric: {
        title: "Genérico",
        description: "Sincronizar os dados do Genérico com o ambiente do 4uBus",
        synced: "Dados do Genérico sincronizados com sucesso",
        modal_title: "Dados integrados do genérico",
      },
      syncUsers: {
        title: "Usuário",
        description: "Sincronizar os dados do Usuário com o ambiente do 4uBus",
        synced: "Dados do Usuário sincronizados com sucesso",
        modal_title: "Dados integrados do usuário",
      },
      syncPrivilege: {
        title: "Privilégio",
        description:
          "Sincronizar os dados do Privilégio com o ambiente do 4uBus",
        synced: "Dados do Privilégio sincronizados com sucesso",
        modal_title: "Dados integrados do privilégio",
      },
      syncEstablishmentParam: {
        title: "Parâmetro do estabelecimento",
        description:
          "Sincronizar os dados do Parâmetro do estabelecimento com o ambiente do 4uBus",
        synced:
          "Dados do Parâmetro do estabelecimento sincronizados com sucesso",
        modal_title: "Dados integrados do parâmetro do estabelecimento",
      },
      syncRelationshipType: {
        title: "Tipo de relacionamento",
        description:
          "Sincronizar os dados do Tipo de relacionamento com o ambiente do 4uBus",
        synced: "Dados do Tipo de relacionamento sincronizados com sucesso",
        modal_title: "Dados integrados do tipo de relacionamento",
      },
      syncRelationship: {
        title: "Relacionamento",
        description:
          "Sincronizar os dados do Relacionamento com o ambiente do 4uBus",
        synced: "Dados do Relacionamento sincronizados com sucesso",
        modal_title: "Dados integrados do relacionamento",
      },
      syncExtension: {
        title: "Extensão",
        description: "Sincronizar os dados da Extensão com o ambiente do 4uBus",
        synced: "Dados da Extensão sincronizados com sucesso",
        modal_title: "Dados integrados da extensão",
      },
      integratedData: {
        no_data: "Nenhum dado integrado encontrado",
      },
      filtersActions: {
        filter: "Filtrar",
        clean: "Limpar filtros",
        refresh: "Atualizar",
      },
      callToActionsButtons: {
        call_to_action: "Chamada para ação",
        change_buttons_order: "Trocar a ordem de agrupamento dos botões",
      },
      quickAnswerButtons: {
        quick_aswer: "Resposta rápida",
        change_buttons_order: "Trocar a ordem de agrupamento dos botões",
      },
      buttonSetting: {
        action_type: "Tipo de ação",
      },
      accessSiteAction: {
        static: "Estática",
        dynamic: "Dinâmica",
        text: "Texto do botão",
        url_type: "Tipo de URL",
        payload: "URL do site",
        url_placeholder: "https://www.exemplo.com",
        url_tooltip:
          "A adição de uma variável cria um link personalizado para o cliente ver as informações dele. Somente uma variável pode ser adicionada ao final de um URL.",
      },
      callAction: {
        text: "Texto do botão",
        country: "País",
        payload: "Telefone",
      },
      copyOfferCodeAction: {
        text: "Texto do botão",
        info: {
          title: "Adicionar amostra de código da oferta",
          subtitle:
            "Para nos ajudar a analisar seu modelo de mensagem, adicione um exemplo do código de oferta.",
        },
        payload: "Código da oferta",
      },
      selectWhatsButtons: {
        tooltip_limit:
          "Limite de botões atingido, para adicionar outro tipo de botão, exclua um botão primeiro",
        generate_automatically:
          "Os botões são determinados automaticamente de acordo com a automação selecionada",
        add_button: "Adicione um botão",
        quick_answer_buttons: "Botões de resposta rápida",
        call_to_action_buttons: "Botões de chamada para ação",
        help: "Se você adicionar mais de 3 botões, eles aparecerão em uma lista.",
        buttons_no_integligence_warning:
          "Esses botões não tem nenhuma inteligência, nem ação automática por parte da plataforma 4uHub. Sendo de total responsabilidade e risco do usuário.",
      },
      whatsButtonsOptions: {
        personalized: {
          name: "Personalizado",
        },
        access_site: {
          name: "Acessar o site",
          description: "2 botões no máximo",
        },
        call: {
          name: "Ligar",
          description: "1 botão no máximo",
        },
        call_whats: {
          name: "Ligar no WhatsApp",
          description: "1 botão no máximo",
        },
        copy_offer_code: {
          name: "Copiar código da oferta",
          description: "1 botão no máximo",
        },
      },
      customButton: {
        text: "Texto do botão",
      },
      addVariablesButton: {
        variables: "Variáveis",
        variable: "Variável",
        cancel: "Cancelar",
        add: "Adicionar",
        add_variables: "Adicionar variáveis",
      },
      variablesContainer: {
        title: "Exemplo de conteúdo do corpo",
        description:
          "Para nos ajudar a analisar seu modelo de mensagem, inclua um exemplo de cada variável no corpo do texto. Não use informações reais de clientes. A API de Nuvem hospedada pela Meta analisa modelos e parâmetros variáveis para proteger a segurança e a integridade dos nossos serviços.",
      },
      variableField: {
        label: "Insira conteúdo para ",
        character_limit: "Limite de caracteres",
        exceeded: "O conteúdo exede o limite de caracteres",
      },
      bodyInput: {
        error: "Todas as variáveis devem ser válidas",
      },
      timeRules: {
        time_rule: "Regra de Tempo",
        new_time_rule: "Nova regra de tempo",
        add_time_rule: "Adicionar regra de tempo",
        time_classification: "Classificação do Tempo",
        type: "Tipo",
        value: "Valor",
        search: "Pesquise por uma regra de tempo",
        confirm: {
          title: "Deletar regra de tempo?",
          description: "Isso vai permanentemente deletar a regra de tempo",
        },
        errors: {
          type: "O tipo é obrigatório",
          time_classification: "A classificação do tempo é obrigatória",
          value: "O valor é obrigatório",
        },
      },
      automationMessages: {
        automation_message: "Mensagem da Automação",
        new_automation_message: "Nova mensagem da automação",
        add_automation_message: "Adicionar mensagem da automação",
        search: "Pesquise por uma mensagem da automação",
        automation_message_type: "Tipo de mensagem da automação",
        message: "Mensagem",
        send_rule_message: "Enviar mensagem",
        yes: "Sim",
        no: "Não",
        confirm: {
          title: "Deletar mensagem da automação?",
          description:
            "Isso vai permanentemente deletar a mensagem da automação",
        },
        errors: {
          automation_message_type:
            "O tipo de mensagem da automação é obrigatório",
          message: "A mensagem é obrigatória",
        },
      },
      messages: {
        message: "Mensagem",
        new_message: "Nova mensagem",
        add_message: "Adicionar mensagem",
        search: "Pesquise por uma mensagem",
        name: "Nome",
        enable: "Habilitar",
        exception: "Exceção",
        send: "Enviar",
        preference: "Preferências",
        status: "Status",
        active: "Ativo",
        inactive: "Inativo",
        initial_date: "Data de início",
        end_date: "Data de fim",
        evaluation_form: "Formulário",
        rounded_schedules_date: "Arredondamento de Datas",
        arrival_time_rule: "Regra de Horário de Chegada",
        e_sign_rules: "Regras de Automação do 4ue-Sign",
        schedule_reminder_filter_type: "Restringir para",
        establishment: "Estabelecimento",
        schedule_records: "Agendas",
        schedule_classifications: "Classificações da agenda",
        active_service_search_survey_type: "Tipo de pesquisa de satisfação",
        evaluation_link_same_as_template:
          "O link de avaliação será o mesmo cadastrado no template.",
        schedule_types: "Tipo de agenda",
        schedule_health_insurances: "Convênio",
        actions: "Ações",
        move_ticket:
          "Mover ticket(card) se a pessoa responder diferente de SIM / OK / CONFIRMAR",
        move_ticket_cancel: "Mover ticket(card) se a pessoa responder CANCELAR",
        move_ticket_not_me:
          "Mover ticket(card) se a pessoa responder NÃO SOU EU",
        move_ticket_confirm:
          "Mover ticket(card) se a pessoa responder CONFIRMAR",
        move_ticket_attendant:
          "Mover ticket(card) se a pessoa responder FALAR COM ATENDENTE",
        if: "Se",
        then: "Então",
        qty_pacient_sent: "Quantidade de pacientes a enviar",
        priority: "Prioridade",
        origin: "Procedências",
        schedulingMethod: "Formas de agendamento",
        originMessageHelper: "Os valores devem ser separados por vírgula",
        schedulingMethodMessageHelper:
          "Os valores devem ser separados por vírgula",
        serviceClassification: "Classificação",
        serviceSector: "Setores",
        serviceType: "Tipo atendimento",
        serviceComplaint: "Queixa/motivo do atendimento",
        groupingIdentifier: "Grupo de agendamento",
        integrationType: "Tipo de integração",
        tasyAuthStatuses: "Autorização",
        tasyCalendarStatuses: "Status Agenda",
        surgeryTypes: "Tipo de Cirurgia",
        surgeryPortes: "Porte",
        surgeryCareCharacters: "Caráter",
        surgeryServiceSectors: "Setor de Atendimento da Cirurgia",
        surgeryHealthInsurances: "Convênio da Cirurgia",
        calendarHistoryType: "Código do Tipo do Histórico",
        cancellationReasonCode:
          "Código(s) de motivo de cancelamento da consulta",
        cancellationReasonHelpText:
          "Informe os códigos dos motivos separados por vírgula. Se cadastrar apenas um, ele será aplicado direto; se cadastrar mais de um, o usuário poderá escolher qual usar.",
        cancellationReasonDescription:
          "Descrição do motivo de cancelamento da consulta",
        cancellationReasonDescHelpText:
          "Informe uma descrição alternativa para o motivo selecionado.",
        examCancellationReasonCode:
          "Código(s) de motivo de cancelamento do exame",
        examCancellationReasonHelpText:
          "Informe os códigos dos motivos separados por vírgula. Se cadastrar apenas um, ele será aplicado direto; se cadastrar mais de um, o usuário poderá escolher qual usar.",
        examCancellationReasonDescription:
          "Descrição do motivo de cancelamento do exame",
        examCancellationReasonDescHelpText:
          "Informe uma descrição alternativa para o motivo selecionado.",
        surgeryCancellationReasonCode:
          "Código(s) do motivo de cancelamento da cirurgia",
        surgeryCancellationReasonHelpText:
          "Informe os códigos dos motivos separados por vírgula. Se cadastrar apenas um, ele será aplicado direto; se cadastrar mais de um, o usuário poderá escolher qual usar.",
        surgeryCancellationReasonDescription:
          "Descrição do motivo de cancelamento da cirurgia",
        surgeryCancellationReasonDescHelpText:
          "Informe uma descrição alternativa para o motivo selecionado.",
        qtyMessageSendingAttempts: "Tentativas de reenvio",
        missing_status: "Status da Agenda",
        internalProcedure: "Procedimento interno",
        individualIdentifier: "Identificador da pessoa física",
        indicationSequence: "Indicação do Atendimento (NR_SEQ_INDICACAO)",
        indicationSequenceHelper: "Os valores devem ser separados por vírgula",
        usePatientEncounterInfoPhone:
          "Enviar para o Telefone das Informações adicionais do Atendimento do Paciente",
        serviceClassificationMessageHelper:
          "Os valores devem ser separados por vírgula",
        serviceSectorMessageHelper:
          "Os valores devem ser separados por vírgula",
        serviceTypeMessageHelper: "Os valores devem ser separados por vírgula",
        serviceComplaintMessageHelper:
          "Os valores devem ser separados por vírgula",
        groupingIdentifierMessageHelper:
          "Os valores devem ser separados por vírgula",
        integrationTypeMessageHelper:
          "Os valores devem ser separados por vírgula",
        internalProcedureMessageHelper:
          "Os valores devem ser separados por vírgula",
        individualIdentifierMessageHelper:
          "Os valores devem ser separados por vírgula",
        sendToConfimed: "Enviar para confirmadas",
        confirmScheduleWithOk: "Ao dar OK, fazer a confirmação da agenda",
        noReplyActionsWarning:
          'Opções de ação indisponíveis, pois o template "{{template}}" não tem nenhuma opção de resposta configurada nos botões. O ticket será finalizado logo após o envio da mensagem.',
        warning:
          "Ao habilitar a exceção, ao menos um dos campos abaixo são obrigatórios.",
        confirm: {
          title: "Deletar mensagem?",
          description: "Isso vai permanentemente deletar a mensagem",
        },
        errors: {
          name: "O nome é obrigatório",
          evaluation_form: "O formulário é obrigatório",
          initial_date: "A data de início é obrigatória",
          end_date: "A data de fim é obrigatória",
          initial_date_bigger:
            "A data de início não pode ser maior que a data de fim",
          ticket_channel_when_not: "O quadro é obrigatório",
          ticket_channel_step_when_not: "A lista é obrigatória",
          active_service_search_survey_type:
            "O tipo de pesquisa de satisfação é obrigatório",
          ticket_channel_when_cancel: "O quadro é obrigatório",
          ticket_channel_step_when_cancel: "A lista é obrigatória",
          ticket_channel_when_not_me: "O quadro é obrigatório",
          calendarHistoryType: "O código do tipo do histórico é obrigatório",
          ticket_channel_step_when_not_me: "A lista é obrigatória",
          ticket_channel_when_confirm: "O quadro é obrigatório",
          ticket_channel_step_when_confirm: "A lista é obrigatória",
          ticket_channel_when_attendant: "O quadro é obrigatório",
          ticket_channel_step_when_attendant: "A lista é obrigatória",
          qty_pacient_sent: "A quantidade de pacientes a enviar é obrigatória",
          cancellationReasonCode: "O código é obrigatório",
          cancellationReasonDescription: "A descrição  é obrigatória",
          examCancellationReasonCode: "O código é obrigatório",
          examCancellationReasonDescription: "A descrição é obrigatória",
          surgeryCancellationReasonCode: "O código é obrigatório",
          surgeryCancellationReasonDescription: "A descrição é obrigatória",
        },
      },
      boardList: {
        board: "Quadro",
        list: "Lista",
      },
      ticketServiceAreaDays: {
        ticket_service_area_days: "Dias de atendimento",
        ticket_service_area_day: "Dia de atendimento",
        add_ticket_service_area_day: "Adicionar dia de atendimento",
        new_ticket_service_area_day: "Novo dia de atendimento",
        edit_ticket_service_area_day: "Editar dia de atendimento",
        day_of_week: "Dia da semana",
        initial_time: "Horário de início",
        end_time: "Horário de fim",
        enable: "Habilitar",
        search: "Pesquise por um dia de atendimento",
        confirm: {
          title: "Deletar dia de atendimento?",
          description: "Isso vai permanentemente deletar o dia de atendimento",
        },
        errors: {
          day_of_week: "O dia da semana é obrigatório",
          initial_time: "O horário de início é obrigatório",
          end_time: "O horário de fim é obrigatório",
          initial_time_bigger:
            "O horário de início não pode ser maior que o horário de fim",
        },
      },
      selectCategories: {
        label: "Selecionar categorias",
        no_options_text: "Nenhuma categoria selecionada",
        options_button_label: "Pesquisar categorias",
        drawer_props: {
          title: "Selecionar Categorias",
          create_button_label: "Criar nova categoria",
          input_label: "Nome da categoria",
          apply_button_label: "Selecionar categorias",
        },
      },
      viewModeSelect: {
        list: "Modo Lista",
        grid: "Modo Grid",
      },
    },
    private: {
      permission: "Ooops! Você não tem permissão!",
    },
    chatBot: {
      page: {
        register: {
          ticketService: {
            id: "Id do serviço",
            allowDistributionList: "Permitir listas de distribuição",
            ticket_service: "Serviço de tickets(cards)",
            new_ticket_service: "Novo serviço de tickets(cards)",
            ticket_channel_donor_work: "Quadro Doadores",
            name: "Nome",
            phoneNumber: "Telefone",
            qualityRating: "Classificação de qualidade",
            enable: "Habilitar",
            ticket_service_type: "Tipo de serviço de tickets(cards)",
            search: "Pesquise por um serviço de tickets(cards)",
            add_ticket_service: "Adicionar serviço de tickets(cards)",
            site_app_extensions: "Sites ou Apps",
            ticket_channel_initial: "Quadro inicial",
            show_message_disable_area:
              "Apresentar mensagem informando que algumas opções estão indisponíveis por estar fora do horário comercial e necessitar de um atendente presencial",
            config_title: "Configurações",
            show_badge_name_color:
              "Mostrar balão com nome do serviço no ticket(card)?",
            badge_background_name_color: "Selecione a cor de fundo do balão",
            badge_name_color: "Selecione a cor de texto do balão",
            whats_settings: "Configurações do Whatsapp",
            typebot_settings: "Configurações do TypeBot",
            external_chat_site_app:
              "Site / Aplicação para Chat Interno (4uChat)",
            full_screen_mode: "Modo Tela Cheia",
            send_protocol_number:
              "Enviar o Protocolo ao finalizar o ticket quando transferir para o chat interno (4uChat)",
            ticket_message_received_rvent: "Lista para mensagens",
            confirm: {
              title: "Deletar serviço de tickets(cards)?",
              description:
                "Isso vai permanentemente deletar o serviço de tickets(cards)",
            },
            copied_successfully: "Copiado com sucesso",
            errors: {
              name: "O nome é obrigatório",
              ticket_service_type:
                "O tipo de serviço de tickets(cards) é obrigatório",
              site_app_extensions: "Ao menos um site ou app é obrigatório",
              ticket_channel_initial: "O quadro inicial é obrigatório",
              badge_background_name_color:
                "A cor do fundo do balão é obrigatória",
              badge_name_color: "A cor do texto do balão é obrigatória",
            },
            sync_whats: "Sincronizar com Whatsapp",
            sync_whats_success: "Sincronizado com sucesso",
            sync_whats_error: "Ocorreu um erro na sincronização",
          },
          ticketServiceWhats: {
            ticket_service_whats: "Configuração do Whatsapp",
            new_ticket_service_whats: "Nova configuração do Whatsapp",
            business_phone_number:
              "Id do Número de Telefone do Whatsapp Business",
            business_account: "Id da Conta do Whatsapp Business",
            whatsapp_business: "Id do App Whatsapp Business",
            access_token: "Token de Acesso",
            webhook_link: "Link do Webhook",
            webhook_link_tooltip: "Copiar link",
            verify_token: "Token de Verificação",
            verify_token_tooltip: "Copiar token de verificação",
            webhook_updated: "Webhook atualizado com sucesso!",
            phone_number_registered:
              "Número de telefone registrado com sucesso!",
            register_succesfully:
              "Cadastro concluído! Seu número de telefone ID é {{phoneNumberId}} e a WABA ID é {{whatsAppBusinessAccountId}}.",
            sync_error:
              "Houve um erro ao sincronizar as informações, por favor revise na conta da Meta.",
            register_cancel: "O processo de conexão do WhatsApp foi cancelado.",
            register_error: "Ocorreu um erro no cadastro: {{error_message}}",
            button_update_webhook: "Atualizar webhook",
            button_register_phone_number: "Registrar número",
            button_business_profile: "Perfil Whatsapp Business",
            button_phone_profile: "Perfil Número",
            errors: {
              business_phone_number:
                "O id do número de telefone do Whatsapp Business é obrigatório",
              business_account:
                "O id da conta do Whatsapp Business é obirigatório",
              whatsapp_business: "O id do App Whatsapp Business é obrigatório",
              access_token: "O token de acesso é obrigatório",
              webhook_updated: "Houve um erro ao atualizar o wehook!",
              phone_number_registered:
                "Houve um erro ao registrar o número de telefone!",
            },
            whatsappProfilePath: {
              whatsappProfileModalTitle: "Perfil Empresarial do Whatsapp",
              description: "Descrição",
              about: "Sobre",
              email: "Email",
              websites: "Sites",
              address: "Endereço",
              websites_help_text: "Pressione enter para adicionas os sites",
              vertical: "Categoria",
              profile_picture: "Foto de perfil",
              profileUpdated:
                "Perfil empresarial do whatsapp atualizado com sucesso",
              select_file: "Selecione um arquivo",
              error: {
                profileUpdated:
                  "Ocorreu um erro ao atualizar o perfil empresarial do whatsapp",
              },
            },
            whatsappNamePath: {
              nameUpdated: "Novo nome de exibição enviado para análise",
              whatsappNameModalTitle: "Perfil do número de telefone",
              verifiedName: "Nome verificado",
              newDisplayName: "Novo nome de exibição",
              qualityRating: "Classificação de Qualidade",
              messagingLimitTier: "Limite de mensagens",
              waiting_update:
                "Aguarde a aprovação da última solitiação de alteração para alterar novamente!",
              error: {
                nameUpdated:
                  "Ocorreu um erro ao enviar o novo nome de exibição para análise",
              },
            },
          },
          ticketServiceTypebot: {
            ticket_service_typebot: "Configurações do TypeBot",
            new_ticket_service_typebot: "Nova configuração do TypeBot",
            typebot_viewer_host: "Visualizador do Host do TypeBot",
            errors: {
              viewer_host: "O visualizador do host do typeBot é obrigatório",
            },
          },
        },
        logs: {
          ticketHistories: {
            title: "Histórico Tickets",
            start_date: "Data inicial",
            end_date: "Data final",
            occurrence_type: "Tipo de Ocorrência",
            ticket_service: "Serviço de Ticket",
            search: "Pesquisar mensagem",
            created: "Data/Hora",
            message: "Mensagem",
            ticket_id: "Ticket",
            view_full_message: "Ver mensagem completa",
            full_message_title: "Mensagem completa",
            close: "Fechar",
            open_ticket: "Abrir ticket no CRM",
            retry: "Tentar novamente",
            errors: {
              period_required: "Informe um período antes de pesquisar os logs.",
              invalid_period:
                "A data inicial não pode ser maior que a data final.",
              start_date_required: "Data inicial é obrigatória",
              end_date_required: "Data final é obrigatória",
              invalid_date_range:
                "Data final deve ser maior ou igual à data inicial",
              occurrence_type_required: "Tipo de ocorrência é obrigatório",
              filters_load: "Não foi possível carregar os filtros da tela.",
              ticket_redirect: "Não foi possível abrir o ticket no CRM.",
            },
          },
          examSchedulingAttachmentLog: {
            title: "Log Anexos dos Agendamentos de Exames",
            date_start: "Data Inicial",
            date_end: "Data Final",
            status: "Status",
            sync: "Sincronizado",
            not_sync: "Não Sincronizado",
            identifier: "Identificador",
            ticket_id: "ID do Ticket",
            protocol_number: "Número do Protocolo",
            ticket_number: "Número do Ticket",
            integration_id: "ID de Integração",
            error_message: "Mensagem de Erro",
            retries: "Tentativas",
            force_retry: "Forçar Reenvio",
            reseted_success: "Reenvio forçado com sucesso",
          },
        },
        service: {
          ticketFinishReason: {
            ticket_finish_reasons: "Motivos de fechamento de tickets",
            ticket_finish_reason: "Motivo de fechamento de ticket",
            new_ticket_finish_reason: "Novo motivo de fechamento de ticket",
            add_ticket_finish_reason:
              "Adicionar motivo de fechamento de ticket",
            search: "Pesquise por um motivo de fechamento de ticket",
            name: "Nome",
            enable: "Habilitar",
            code: "Código",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            confirm: {
              title: "Deletar motivo de fechamento de ticket?",
              description:
                "Isso vai permanentemente deletar o motivo de fechamento do ticket",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          memberAvailabilityPauseReason: {
            member_availability_pause_reason: "Motivos de pausa de membros",
            member_availability_pause_reasons: "Motivo de pausa de membros",
            new_member_availability_pause_reason:
              "Novo motivo de pausa de membros",
            add_member_availability_pause_reason:
              "Adicionar motivo de pausa de membros",
            search: "Pesquise por um motivo de pausa de membros",
            name: "Nome",
            code: "Código",
            confirm: {
              title: "Deletar motivo de pausa de membros?",
              description:
                "Isso vai permanentemente deletar o motivo de pausa de membros",
            },
            errors: {
              name: "O nome é obrigatório",
            },
          },
          protocolGenerateRule: {
            protocol_generate_rules: "Regras de geração de protocolo",
            protocol_generate_rule: "Regra de geração de protocolo",
            new_protocol_generate_rule: "Nova regra de geração de protocolo",
            name: "Nome da regra",
            enable: "Habilitar",
            initial_date: "Início vigência",
            end_date: "Fim vigência",
            search: "Pesquise por uma regra de geração de protocolo",
            add_protocol_generate_rule:
              "Adicionar regra de geração de protocolo",
            protocol_rule_details: "Detalhes da regra de geração de protocolo",
            add_protocol_rule_details:
              "Adicionar detalhe da regra de geração de protocolo",
            order: "Ordem",
            field_type: "Tipo",
            fixed_code: "Valor fixo",
            mask: "Máscara",
            mask_information:
              "A máscara serve para formatar o valor do campo '{{type}}' no protocolo, nos casos em que o comprimento for menor que o limite aceito.",
            mask_no_information:
              "A máscara serve para formatar o valor do campo 'tipo' no protocolo, nos casos em que o comprimento for menor que o limite aceito.",
            confirm: {
              title: "Deletar regra de geração de protocolo?",
              description:
                "Isso vai permanentemente deletar a regra de geração de protocolo",
            },
            errors: {
              name: "O nome da regra é obrigatório",
              initial_date: "O início vigência é obrigatório",
              end_date: "O fim vigência é obrigatório",
              fixed_code: "O valor fixo é obrigatório",
              protocol_rule_details:
                "Ao menos um detalhe da regra de geração de protocolo é obrigatório",
            },
          },
          ticketServiceArea: {
            ticket_service_areas: "Áreas de atendimento",
            ticket_service_area: "Área de atendimento",
            search: "Pesquise por uma área de atendimento",
            add_ticket_service_area: "Adicionar área de atendimento",
            new_ticket_service_area: "Nova área de atendimento",
            ticket_service_area_parent: "Área de Atendimento Pai",
            ticket_default_doc: "Protocolo Padrão",
            ticket_event: "Disparar Evento",
            ticket_event_type: "Tipo de Evento",
            name: "Nome",
            code: "Código",
            enable: "Habilitar",
            identification: "Exige identificação",
            enable_all_the_time: "Atendimento 24/7",
            enable_special_time: "Horário especial de atendimento",
            display_order: "Ordem de Exibição",
            summary: "Resumo",
            ticket_services: "Serviço de Tickets(Cards)",
            ticket_channel: "Quadro para Transferir",
            ticket_channel_step: "Lista Para Transferir",
            service_type: "Tipo de Atendimento",
            show_outside_business_day:
              "Exibir Área Fora do Horário de Atendimento",
            message_outside_business_day:
              "Mensagem Exibida ao Usuário Fora do Horário de Atendimento",
            summary_outside_business_day:
              "Resumo Exibido ao Usuário Fora do Horário de Atendimento",
            ticket_automation_received_rule: "Regra de Recebimento",
            received_rule_caption:
              "Sempre que uma regra de recebimento for selecionada, a identificação do paciente será exigida.",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            yes: "Sim",
            no: "Não",
            actions: "Ações",
            time: "Horário",
            action_type: "Tipo de Ação",
            no_action: "Menu Sem Ação",
            trigger_event: "Disparar um Evento",
            default_protocol: "Enviar um Protocolo Padrão",
            channel_transfer: "Transferir para uma Lista/Quadro",
            received_rule: "Seguir Uma Regra de Recebimento",
            direct_to_internal_chat: "Direcionar para chat interno (4uChat)",
            external_chat_site_app:
              "Site / Aplicação para Chat Interno (4uChat)",
            full_screen_mode: "Modo Tela Cheia",
            send_protocol_number:
              "Enviar o Protocolo ao finalizar o ticket quando transferir para o chat interno (4uChat)",
            automatic_external_chat_alert:
              "Esse serviço de tickets tem um direcionamento automático ativado para o chat interno (4uChat) do Site \"{{siteAppName}}\"",
            enableModal: {
              disable: "Desabilitar área de atendimento?",
              enable: "Habilitar área de atendimento?",
              disable_message:
                "Ao desabilitar esta área de atendimento, todas as áreas de atendimento dependentes serão desabilitadas também.",
              enable_message:
                "Ao habilitar esta área de atendimento, todas as áreas de atendimento dependentes serão habilitadas também.",
              cancel_button: "Cancelar",
              confirm_button: "Confirmar",
            },
            confirm: {
              title: "Deletar área de atendimento?",
              description:
                "Isso vai permanentemente deletar a área de atendimento",
            },
            errors: {
              name: "O nome é obrigatório",
              display_order: "A ordem de exibição é obrigatória",
              code: "O código é obrigatório",
              action_selector: "Selecione um tipo de ação",
              ticket_services: "O serviço de tickets(cards) é obrigatório",
              summary: "O resumo é obrigatório",
              summary_characteres:
                "O resumo não pode ter mais que 72 caracteres",
              name_characteres: "O nome não pode ter mais de 24 caracteres",
              summary_outside_characteres:
                "O resumo não pode ter mais que 72 caracteres",
              message_outside_characteres:
                "O mensagem fora do dia de atendimento não pode ter mais que 500 caracteres",
              message_outside_business_day:
                "A mensagem fora do dia de atendimento é obrigatória",
              ticket_channel_step:
                "A lista é obrigatória quando um quadro está selecionado.",
            },
          },
          ticketServiceMessage: {
            ticket_service_messages: "Mensagens",
            ticket_service_message: "Mensagem",
            search: "Pesquise por uma mensagem",
            message: "Mensagem",
            message_type: "Tipo de mensagem",
            ticket_service: "Serviço de ticket(card)",
            target: "Target",
            add_message: "Nova Mensagem",
            errors: {
              message: "A mensagem é obrigatória",
              message_type: "O tipo da mensagem é obrigatório",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              target: "O target é obrigatório",
            },
          },
          serviceDay: {
            service_days: "Horários de atendimento",
            service_day: "Horário de atendimento",
            new_service_day: "Novo horário de atendimento",
            search: "Pesquise por um horário de atendimento",
            add_service_day: "Adicionar horário de atendimento",
            day_of_week: "Dia da semana",
            start_time: "Horário de início",
            end_time: "Horário de encerramento",
            ticket_service: "Serviço de ticket(card)",
            enable: "Habilitar",
            confirm: {
              title: "Deletar horário de atendimento?",
              description:
                "Isso vai permanentemente deletar o horário de atendimento",
            },
            errors: {
              day_of_week: "O dia da semana é obrigatório",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              start_time: "O horário de início é obrigatório",
              end_time: "O horário de encerramento é obrigatório",
            },
          },
          blacklist: {
            blacklist_registrations: "Cadastros Blacklist",
            blacklist_registration: "Cadastro Blacklist",
            name: "Nome",
            active: "Ativo",
            inactive: "Inativo",
            status: "Status",
            phone_number: "Telefone",
            creation_date: "Data Blacklist",
            search: "Pesquisar registro da blacklist",
            add_button: "Adicionar Registro à Blacklist",
            enable: "Habilitar",
            individual: "Pessoa Física",
            contact_number: "Número de Contato",
            ddi: "DDI",
            confirm: {
              title: "Deletar registro na blacklist?",
              description:
                "Isso vai permanentemente deletar o registro na blacklist",
            },
            errors: {
              phone_number_value: "Número de contato obrigatório",
              ddi: "DDI obrigatório",
              individual: "Selecione uma pessoa",
            },
          },
          banList: {
            ban_lists: "Listas de Telefones Banidos Por Serviço",
            ban_list: "Lista de Telefones Banidos Por Serviço",
            add_ban_list: "Adicionar Lista de Telefones Banidos Por Serviço",
            new_ban_list: "Nova Lista de Telefones Banidos Por Serviço",
            search: "Pesquise por uma lista de telefones banidos por serviço",
            phone_number: "Número do Telefone",
            phone_info:
              "Informe o número com DDI e DDD (somente números). Ex: 5547912345678",
            ticket_service: "Serviço de ticket(card)",
            type: "Tipo",
            observation: "Observação",
            created: "Data e hora",
            confirm: {
              title: "Deletar lista de telefones banidos por serviço?",
              description:
                "Isso vai permanentemente deletar a lista de telefones banidos por serviço",
            },
            errors: {
              phone_number: "O número do telefone é obrigatório",
              only_phone_numbers: "Informe apenas números",
              ticket_service: "O serviço de ticket(card) é obrigatório",
            },
          },
          appointmentArrivalRule: {
            appointment_arrivals: "Horários de chegada de agendas",
            appointment_arrival: "Horário de chegada de agenda",
            new_appointment_arrival: "Novo horário de chegada de agenda",
            add_appointment_arrival: "Adicionar horário de chegada de agenda",
            search: "Pesquise por um horário de chegada de agenda",
            name: "Nome",
            description: "Descrição",
            created_successfully:
              "Horário de chegada de agenda criado com sucesso",
            confirm: {
              title: "Deletar horário de chegada de agenda?",
              description:
                "Isso vai permanentemente deletar o horário de chegada de agenda",
            },
            errors: {
              name: "O nome é obrigatório",
            },
            appointment_arrival_config: "Horários de chegada",
            appointmentArrivalConfig: {
              appointment_arrival_configs: "Horários de chegada",
              appointment_arrival_config: "Horário de chegada",
              new_appointment_arrival_config: "Novo Horário de chegada",
              add_appointment_arrival_config: "Adicionar Horário de chegada",
              search: "Pesquise por um Horário de chegada",
              from: "De",
              to: "Até",
              arrival_time: "Horário de chegada",
              if: "Se",
              then: "Então",
              appointments: "Agendamentos:",
              arrival_time_description: "Informar o paciente para chegar às:",
              confirm: {
                title: "Deletar horário de chegada?",
                description:
                  "Isso vai permanentemente deletar o horário de chegada",
              },
              errors: {
                from: "A data de início é obrigatória",
                to: "A data de fim é obrigatória",
                arrival_time: "O horário de chegada é obrigatório",
              },
            },
          },
        },
        templates: {
          whatsapp_template: {
            category: "Categoria",
            whatsapp_templates: "Templates do Whatsapp",
            whatsapp_template: "Template do Whatsapp",
            new_whatsapp_template: "Novo template do Whatsapp",
            search: "Pesquise por um template do Whatsapp",
            dynamic: "Dinâmica",
            action_type: "Tipo de Ação",
            header_type: "Tipo de Cabeçalho",
            add_whatsapp_template: "Adicionar template do Whatsapp",
            name: "Nome",
            enable: "Habilitar",
            automation: "Automação",
            ticket_service: "Serviço de ticket(card)",
            no_ticket_service:
              "É necessário ter ao menos um serviço de ticket(card) cadastrado, para poder cadastrar um template do Whatsapp",
            template_meta_name: "Nome do template na Meta",
            automation_status: "Status da automação",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            internal_template: "Template Interno CRM",
            message_preview: "Preview da mensagem",
            preview_button: "Visualizar preview do template",
            optional: "Opcional",
            header: "Cabeçalho",
            header_sub:
              "Adicione um título ou escolha qual tipo de mídia você usará para esse cabeçalho.",
            file_sending_mode: "Modo de envio do Arquivo",
            send_contact_related_file:
              "Enviar sempre o arquivo vinculado ao contato da lista",
            send_contact_related_file_info:
              "Se esta opção estiver marcada, não enviaremos o arquivo acima. Enviaremos o arquivo que será enviado via API no momento de se criar o contato.",
            send_selected_file: "Enviar sempre o arquivo selecionado",
            send_selected_file_info:
              "Se esta opção estiver marcada, não enviaremos o arquivo acima. Enviaremos o arquivo que será anexado ao criar o ticket.",
            send_template_related_file:
              "Enviar sempre o arquivo vinculado a este template",
            send_template_related_file_info:
              "Se esta opção estiver marcada sempre enviaremos o mesmo arquivo, que é o arquivo vinculado neste template.",
            title: "Título",
            body: "Corpo",
            body_sub: "Insira o texto da sua mensagem.",
            body_placeholder: "Digite o corpo da sua mensagem...",
            footer: "Rodapé",
            footer_sub:
              "Adicione uma pequena linha de texto na parte inferior do seu modelo de mensagem.",
            buttons: "Botões",
            buttons_sub:
              "Crie botões para os clientes responderem à sua mensagem ou executarem alguma ação.",
            resend: "Reenviar",
            resend_success: "Template reenviado com sucesso",
            whatsappTemplateAutomation: {
              title: "Alterar automação?",
              description:
                "Alterar a automação fará com que todos os campos sejam limpos",
              cancel: "Cancelar",
              change: "Alterar",
            },
            confirm: {
              title: "Deletar Template do Whatsapp?",
              description:
                "Isso vai permanentemente deletar o Template do Whatsapp",
            },
            errors: {
              name: "O nome é obrigatório",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              ticket_automation: "A automação é obrigatória",
              body: "O corpo deve ter ao menos 1 caractere",
              body_max: "O corpo deve ter no máximo 1024 caracteres",
              body_invalid_variables: "Todas as variáveis devem ser válidas",
              body_max_550: "O corpo deve ter no máximo 550 caracteres",
              custom_button_text:
                "O texto do botão deve ter ao menos 1 caractere",
              media_file: "Ao menos um arquivo de mídia é obrigatório",
              custom_button_text_max:
                "O texto do botão deve ter no máximo 25 caracteres",
              url_type: "O tipo de URL é obrigatório",
              country: "O país é obrigatório",
              text: "O texto do botão deve ter ao menos 1 caractere",
              text_max: "O texto do botão deve ter no máximo 25 caracteres",
              payload: "Campo obrigatório",
              url_payload: "O botão deve conter um link válido (http ou https)",
              example: "O exemplo é obrigatório",
              whatsMetaCategory: "A categoria é obrigatória",
              action_type: "O tipo de ação é obrigatório",
              file_fixed: "Selecione um modo de envio do arquivo",
            },
          },
          templateGeneral: {
            title: "Template Geral",
            new: "Novo Template Geral",
            add: "Adicionar Template Geral",
            content_header: "Cabeçalho",
            content_footer: "Rodapé",
            template_general_type: "Tipo de Template Geral",
            status: "Status",
            name: "Nome",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Ativar",
            confirm: {
              title: "Deletar Template Geral?",
              description: "Isso vai permanentemente deletar o Template Geral",
            },
            errors: {
              name: "O nome é obrigatório",
              templateGeneralType: "O tipo de template geral é obrigatório",
            },
          },
          internalCrm: {
            internal_crm: "Interno CRM",
            new_variable: "Nova Variável",
            new_category: "Nova Categoria",
            new_template: "Novo Template",
            search_category: "Pesquise por uma categoria",
            search_variable: "Pesquise por uma variável",
            search_template: "Pesquise por um template",
            add_automation_rule: "Adicionar regra de automação",
            categories: "Categorias",
            variables: "Variáveis",
            character_limit: "Limite de caracteres",
            templates: "Templates",
            fields: "Campos",
            label: "Label",
            screen_order: "Sequencia Tela",
            is_required: "Obrigatório",
            add_new_item: "Adicionar novo campo",
            active: "Ativo",
            inactive: "Inativo",
            name: "Nome",
            status: "Status",
            category: "Categoria",
            data_type: "Tipo de dado",
            enable: "Ativar",
            code: "Código",
            confirm: {
              title_variable: "Excluir variável?",
              description_variable:
                "Isso irá excluir permanentemente a variável",
              title_category: "Excluir categoria?",
              description_category:
                "Isso irá excluir permanentemente a categoria",
              title_template: "Excluir template?",
              description_template:
                "Isso irá excluir permanentemente o template",
            },
            errors: {
              name: "O nome é obrigatório",
              label: "O label é obrigatório",
              screen_order: "A Sequencia de Tela é obrigatória",
              categories: "A categoria é obrigatória",
              data_type: "O tipo de dado é obrigatório",
              variable: "A variável é obrigatória",
              fields: "Ao menos um campo é obrigatório",
            },
          },
        },
        automations: {
          automationRuleEncMessage: {
            message: "Mensagem",
            new_message: "Nova mensagem",
            add_message: "Adicionar mensagem",
            search: "Pesquise por uma mensagem",
            name: "Nome",
            enable: "Habilitar",
            exception: "Exceção",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            send: "Enviar",
            if: "Se",
            then: "Então",
            priority: "Prioridade",
            qtyMessageSendingAttempts: "Tentativas de reenvio",
            missing_status: "Status da Agenda",
            establishment: "Estabelecimento",
            initial_date: "Data de início",
            end_date: "Data de fim",
            individualIdentifier: "Identificador da pessoa física",
            ticketAutomationRuleEncMessageSectors: "Setores do atendimento",
            ticketAutomationRuleEncMessagePrescriptionSectors:
              "Setores da prescrição",
            ticketAutomationRuleEncMessageEncounterTypes:
              "Tipos de atendimento",
            ticketAutomationRuleEncMessageInProcClassifics: "Classificação",
            ticketAutomationRuleEncMessageMedProcTypes:
              "Tipos de procedimento interno",
            sendTypeEmrResult: "Resultado do laudo",
            templateGeneral: "Template",
            sendTypePasswordEmrResult: "Senha do laudo",
            individualIdentifierMessageHelper:
              "Os valores devem ser separados por vírgula",
            confirm: {
              title: "Deletar mensagem?",
              description: "Isso vai permanentemente deletar a mensagem",
            },
            errors: {
              name: "O nome é obrigatório",
              establishments: "O estabelecimento é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              templateGeneral: "O template é obrigatório",
            },
          },
          automationReceivedRules: {
            automation_received_rules: "Regras de recebimento",
            automation_received_rule: "Regra de recebimento",
            search: "Pesquise por uma regra de recebimento",
            new_automation_received_rule: "Nova regra de recebimento",
            name: "Nome",
            created_by: "Criado por",
            created_successfully: "Criado com sucesso",
            insurance: "Convênio / Categoria",
            price_insurance: "Convênio Preço",
            private_insurance: "Convênio Particular",
            cancelation_reasons: "Motivos de Cancelamento",
            slot: "Slot Sorteio",
            file: "Arquivos",
            days_ahead: "Dias a frente",
            messages: "Mensagens",
            custom_message: "Mensagens Customizadas",
            establishment: "Estabelecimento",
            add_automation_received_rule: "Adicionar Regra de Recebimento",
            tasy_orientation: "Orientação Tasy",
            ticket_default_doc: "Protocolos Padrão",
            offer_classification: "Classificação da Oferta",
            allowed_actions: "Ações Permitidas",
            preferences: "Preferências",
            unchosenProfessionalPriorities:
              "Prioridades de Profissional Não Escolhido",
            confirm: {
              title: "Deletar Regra de Recebimento?",
              description:
                "Isso vai permanentemente deletar a regra de recebimento",
            },
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            code: "Código",
            initial_date: "Data inicial",
            end_date: "Data final",
            when_error:
              "Transferir para (Quando ocorrer algum erro durante o fluxo):",
            when_finished: "Transferir para (Quando finalizar o agendamento):",
            transfer_message: "Mensagem de transferência",
            error_message: "Mensagem de transferência ao ocorrer um erro",
            automation: "Automação",
            enable: "Ativar",
            appointment_arrival_consultation: "Horário de Chegada da Consulta",
            appointment_arrival_exam: "Horário de Chegada do Exame",
            ticketAutRecRuleTasyOrientation: {
              ticket_autrecrule_tasy_orientation: "Orientação Tasy",
              new_ticket_autrecrule_tasy_orientation: "Nova Orientação Tasy",
              enable: "Habilitar",
              type_tasy_orientation: "Tipo de orientação Tasy",
              send_when: "Enviar quando",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              add_ticket_autrecrule_tasy_orientation:
                "Adicionar Orientação Tasy",
              confirm: {
                title: "Deletar orientação Tasy?",
                description:
                  "Isso vai permanentemente deletar a orientação Tasy",
              },
              errors: {
                type_tasy_orientation:
                  "O tipo de orientação Tasy é obrigatório",
                send_when: "O campo 'Enviar quando' é obrigatório",
              },
            },
            automationRecRuleTicketDefDoc: {
              ticket_default_doc: "Protocolo Padrão",
              new_ticket_default_doc: "Novo Protocolo Padrão",
              add_ticket_default_doc: "Adicionar Protocolo Padrão",
              send_when: "Enviar Quando",
              description: "Descrição",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              enable: "Ativar",
              ticketAutRecRuleTicketDefDocsInsurances: "Convênios",
              ticketAutRecRuleTicketDefDocsInternalProcedures:
                "Procedimentos Internos",
              procedure_caption: "Digite pelo menos 3 letras para buscar",
              ticketAutRecRuleTicketDefDocsCalendars: "Agendas",
              confirm: {
                title: "Deletar Protocolo Padrão?",
                description:
                  "Isso vai permanentemente deletar o Protocolo Padrão",
              },
              errors: {
                send_when: "O enviar quando é obrigatória",
                ticket_default_doc: "O protocolo padrão é obrigatório",
              },
            },
            automationReceivedDaysAhead: {
              days_ahead: "Dia a frente",
              new_days_ahead: "Novo  Dia a frente",
              add_days_ahead: "Adicionar  Dia a frente",
              qtd_days: "Quantidade de Dias",
              procedure_caption: "Digite pelo menos 3 letras para buscar",
              search_internal_procedures: "Pesquisar Procedimentos Internos",
              ticketAutomationReceivedDaysAheadCalendars: "Agendas",
              ticketAutomationReceivedDaysAheadInsurances: "Convênios",
              ticketAutomationReceivedDaysAheadProcedures: "Procedimentos",
              status: "Status",
              enable: "Ativar",
              active: "Ativo",
              inactive: "Inativo",
              if: "Se",
              then: "Então",
              limit_final_date: "Limitar data final da oferta",
              time_limit_type: "Tempo de limite",
              limit_days: "Quantidade de limite",
              confirm: {
                title: "Confirmar Dia a Frente",
                description: "Isso vai permanentemente deletar o Dia a Frente",
              },
              errors: {
                destination_calendar_file: "Local para salvar é obrigatório",
                ticketAutomationReceivedDaysAheadCalendars:
                  "A agenda é obrigatória",
                ticketAutomationReceivedDaysAheadInsurances:
                  "O convênio é obrigatória",
                ticketAutomationReceivedDaysAheadProcedures:
                  "O procedimento é obrigatório",
                qtd_days: "A quantidade de dias é obrigatória",
              },
            },
            automationReceivedConfFile: {
              file: "Arquivo",
              new_file: "Novo arquivo",
              add_file: "Adicionar arquivo",
              destination_calendar_file: "Local para salvar",
              display_order: "Ordem de exibição",
              displayOrder: "Ordem de exibição",
              wait_limit_time: "Tempo Máximo de Espera em Minutos",
              ticketAutomationReceivedConfFileCaleInsuranceTypes:
                "Tipos de Convênios",
              procedure_caption: "Digite pelo menos 3 letras para buscar",
              search_internal_procedures: "Pesquisar Procedimentos Internos",
              ticketAutomationReceivedConfFileCalendars: "Agendas",
              ticketAutomationReceivedConfFileCalePreferences:
                "Preferências da Agenda",
              ticketAutomationReceivedConfFileCaleProcedures: "Procedimentos",
              message: "Mensagem",
              messageErro: "Mensagem de erro",
              calendar_slot_sort_type: "Tipo de ordenação do slot",
              ticketAutomationReceivedConfFileCaleInsurances: "Convênios",
              confirm: {
                title: "Deletar Arquivo?",
                description: "Isso vai permanentemente deletar o Arquivo",
              },
              errors: {
                destination_calendar_file: "Local para salvar é obrigatório",
                ticketAutomationReceivedConfFileCalendars:
                  "A agenda é obrigatória",
                ticketAutomationReceivedConfFileCalePreferences:
                  "A preferência é obrigatória",
                ticketAutomationReceivedConfFileCaleProcedures:
                  "O procedimento é obrigatório",
                displayOrder: "A ordem de exibição é obrigatória",
                message: "A mensagem é obrigatória",
                messageError: "A mensagem de erro é obrigatória",
              },
            },
            automationReceivedCustomMessage: {
              custom_message: "Mensagem Customizada",
              new_custom_message: "Nova Mensagem Customizada",
              add_custom_message: "Adicionar Mensagem Customizada",
              message: "Mensagem",
              ticket_channel: "Quadro",
              ticket_channel_step: "Lista",
              ticketAutomationReceivedCustomMessageCalendars: "Agendas",
              ticketAutomationReceivedCaleExamGroupings:
                "Agrupamento de Agenda",
              confirm: {
                title: "Deletar Mensagem Customizada?",
                description:
                  "Isso vai permanentemente deletar a Mensagem Customizada",
              },
              errors: {
                message: "A mensagem é obrigatória",
                ticket_channel: "O quadro é obrigatório",
                ticket_channel_step: "A lista é obrigatória",
                ticketAutomationReceivedCaleExamGroupings:
                  "O agrupamento de agenda é obrigatório",
              },
            },
            automationReceivedRuleInsuranceCategory: {
              insurance: "Convênio",
              new_insurance: "Novo Convênio",
              enable: "Ativar",
              add_insurance: "Adicionar Convênio",
              insuranceExternalId: "ID Externo do Convênio",
              insuranceExternalName: "Nome do Convênio",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              confirm: {
                title: "Deletar Convênio?",
                description: "Isso vai permanentemente deletar o Convênio",
              },
              errors: {
                insurance_register: "O Convênio é obrigatório",
              },
            },
            automationReceivedRulePriceInsurance: {
              insurance: "Convênio Preço",
              new_insurance: "Novo Convênio Preço",
              enable: "Ativar",
              add_insurance: "Adicionar Convênio Preço",
              external_id: "ID Externo do Convênio",
              external_name: "Nome do Convênio",
              insurance_field: "Convênio",
              confirm: {
                title: "Deletar Convênio Preço?",
                description:
                  "Isso vai permanentemente deletar o Convênio Preço",
              },
              errors: {
                insurance_field: "O Convênio é obrigatório",
              },
            },
            automationReceivedRuleCancelationReason: {
              cancelation_reason: "Motivo de Cancelamento",
              new_cancelation_reason: "Novo Motivo de Cancelamento",
              add_cancelation_reason: "Adicionar Motivo de Cancelamento",
              external_id: "Codigo Externo",
              external_name: "Nome Externo",
              cancelation_reason_field: "Motivo de Cancelamento",
              confirm: {
                title: "Deletar Motivo de Cancelamento?",
                description:
                  "Isso vai permanentemente deletar o Motivo de Cancelamento",
              },
              errors: {
                cancelation_reason_field:
                  "O Motivo de Cancelamento e obrigatorio",
              },
            },
            automationReceivedRuleEstablishment: {
              establishment_id: "Id do Estabelecimento",
              establishment_name: "Nome Personalizado",
              original_establishment_name: "Nome do Estabelecimento",
              add_establishment: "Adicionar Estabelecimento",
              confirm_title: "Estabelecimento",
              confirm_description:
                "Tem certeza de que deseja excluir este estabelecimento permanentemente?",
              establishment: "Estabelecimento",
              new_establishment: "Novo estabelecimento",
              establishment_field: "Estabelecimentos",
              establishment_name_field: "Nome Personalizado",
            },
            automationReceivedMessagePrivateInsurance: {
              private_insurance: "Convênio Particular",
              new_private_insurance: "Novo Convênio Privado",
              add_private_insurance: "Adicionar Convênio Privado",
              external_private_id: "ID Externo do Convênio Particular",
              external_private_name: "Nome do Convênio Particular",
              confirm: {
                title: "Deletar Convênio Particular?",
                description:
                  "Isso vai permanentemente deletar o Convênio Particular",
              },
              errors: {
                external: "O Convênio Particular é obrigatório",
              },
            },
            automationReceivedSlot: {
              slot_schedule: "Slot Sorteio",
              new_slot_schedule: "Novo Slot Sorteio",
              add_slot_schedule: "Adicionar Slot Sorteio",
              enable: "Ativar",
              if: "Se",
              ticketAutomationReceivedSlotCalendars: "Agenda",
              priority: "Prioridade",
              then: "Então",
              slots_available: "Quantidade de Slots Disponíveis",
              calendar_slot_sort_type: "Forma de sorteio",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              confirm: {
                title: "Deletar Slot Sorteio?",
                description: "Isso vai permanentemente deletar o Slot Sorteio",
              },
              errors: {
                calendar_slot_sort_type: "A Forma de sorteio é obrigatório",
                ticketAutomationReceivedSlotCalendars: "A Agenda é obrigatória",
                slots_available:
                  "A Quantidade de Slots Disponíveis é obrigatório",
                priority: "A prioridade é obrigatória",
              },
            },
            automationReceivedMessages: {
              message: "Mensagem",
              new_message: "Nova Mensagem",
              add_message: "Adicionar Mensagem",
              search: "Pesquise por uma mensagem",
              active: "Ativo",
              inactive: "Inativo",
              status: "Status",
              enable: "Ativar",
              show_app_and_online_calendar: "Somente Agenda Online",
              if: "Se",
              then: "Então",
              return_days: "Dias de Retorno",
              calendar_classification: "Classificações de Agenda",
              preference: "Preferências",
              consultation_grouping_register: "Agrupamentos da Agenda",
              calendar_specialties: "Especialidades da Agenda",
              agendas: "Agendas",
              confirm: {
                title: "Deletar Mensagem?",
                description: "Isso vai permanentemente deletar a Mensagem",
              },
              errors: {
                return_days: "A quantidade de dias de retorno é obrigatória",
              },
            },
            ticketAutomationReceivedRuleOfferClassif: {
              offer_classification: "Classificação da Oferta",
              add_offer_classification: "Adicionar Classificação da Oferta",
              new_offer_classification: "Nova Classificação da Oferta",
              classifications: "Classificações",
              default_classification: "Classificação Padrão",
              require_turn_slot_classif: "Exige classificação no turno/slot",
              update_slot_classif:
                "Ao agendar, alterar a classificação no slot",
              confirm: {
                title: "Deletar Classificação da Oferta?",
                description:
                  "Isso vai permanentemente deletar a Classificação da Oferta",
              },
              errors: {
                classifications: "A classificação é obrigatória",
                default_classification: "A classificação padrão é obrigatória",
              },
            },
            ticketAutomationReceivedRuleAllowedAction: {
              allowed_action: "Ação Permitida",
              add_allowed_action: "Adicionar Ação Permitida",
              new_allowed_action: "Nova Ação Permitida",
              new_schedule: "Novo Agendamento",
              confirm_field: "Confirmar",
              cancel: "Cancelar",
              check_in: "Check-in",
              reschedule: "Reagendar",
              reschedule_fields_caption:
                "Informe nos campos abaixo as regras que serão usadas para o reagendamento de acordo com o tipo de agenda",
              featured_received_rule: "Regra de Recebimento com Destaque",
              return_received_rule: "Regra de Recebimento de Retorno",
              exam_received_rule: "Regra de Recebimento de Exames",
              consultation_received_rule: "Regra de Recebimento de Consultas",
              yes: "Sim",
              no: "Não",
              confirm: {
                title: "Deletar Ação Permitida?",
                description:
                  "Isso vai permanentemente deletar a Ação Permitida",
              },
            },
            appointmentArrival: {
              appointment_arrival_consultation:
                "Horário de Chegada da Consulta",
              new_appointment_arrival_consultation:
                "Novo Horário de Chegada da Consulta",
              add_appointment_arrival_consultation:
                "Adicionar Horário de Chegada da Consulta",
              appointment_arrival_exam: "Horário de Chegada do Exame",
              new_appointment_arrival_exam: "Novo Horário de Chegada do Exame",
              add_appointment_arrival_exam:
                "Adicionar Horário de Chegada do Exame",
              search_consultation:
                "Pesquise por um Horário de Chegada da Consulta",
              search_exam: "Pesquise por um Horário de Chegada da Exame",
              if: "Se",
              then: "Então",
              establishments: "Estabelecimentos",
              insurances: "Convênios",
              calendars: "Agendas",
              classifications: "Classificações de Agenda",
              internal_procedures: "Procedimentos Internos",
              procedure_caption: "Digite pelo menos 3 letras para buscar",
              appointment_arrival_rule: "Regra de Horário de Chegada",
              confirm: {
                title_consultation: "Deletar Horário de Chegada da Consulta?",
                description_consultation:
                  "Isso vai permanentemente deletar o Horário de Chegada da Consulta",
                title_exam: "Deletar Horário de Chegada do Exame?",
                description_exam:
                  "Isso vai permanentemente deletar o Horário de Chegada do Exame",
              },
              errors: {
                appointment_arrival_rule:
                  "A regra de horário de chegada é obrigatória",
              },
            },
            ticketAutomationReceivedRulePreference: {
              preference: "Preferência",
              add_preference: "Adicionar Preferência",
              new_preference: "Nova Preferência",
              enable: "Habilitar",
              active: "Ativo",
              inactive: "Inativo",
              medical_specialty: "Especialidade Médica",
              status: "Status",
              calendar_preferences: "Preferências",
              confirm: {
                title: "Deletar Preferência?",
                description: "Isso vai permanentemente deletar a Preferência",
              },
              errors: {
                medical_specialty: "A especialidade médica é obrigatória",
              },
            },
            ticketAutRecRuleUnchosenProfessionalRule: {
              unchosenProfessionalPriority:
                "Prioridade de Profissional Não Escolhido",
              new_unchosenProfessionalPriority:
                "Nova Prioridade de Profissional Não Escolhido",
              add_unchosenProfessionalPriority:
                "Adicionar Prioridade de Profissional Não Escolhido",
              status: "Status",
              active: "Ativo",
              inactive: "Inativo",
              enable: "Ativar",
              if: "Se",
              then: "Então",
              name: "Nome",
              priority: "Prioridade",
              initial_age: "Idade Inicial",
              final_age: "Idade Final",
              unchosen_professional_criterion: "Critério",
              specialties: "Especialidades",
              insurances: "Convênios",
              calendars: "Agendas",
              physicians: "Médicos",
              add_priority: "Adicionar Prioridade",
              confirm: {
                title: "Deletar Prioridade de Profissional Não Escolhido?",
                description:
                  "Isso vai permanentemente deletar a Prioridade de Profissional Não Escolhido",
              },
              errors: {
                name: "O nome é obrigatório",
                unchosen_professional_criterion: "O critério é obrigatório",
                offers: "Selecione ao menos uma agenda ou um médico",
                offer_priority: "A prioridade é obrigatória",
                offer_priority_duplicated:
                  "Prioridade já utilizada em outro item. Utilize outro valor",
              },
            },
          },
          templateGeneral: {
            title: "Template Geral",
            new: "Novo Template Geral",
            add: "Adicionar Template Geral",
            editor: "Editor",
            html: "HTML",
            insert_html: "Insira o html do {{section_name}}",
            content_header: "Cabeçalho",
            content_footer: "Rodapé",
            template_general_type: "Tipo de Template Geral",
            status: "Status",
            name: "Nome",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Ativar",
            confirm: {
              title: "Deletar Template Geral?",
              description: "Isso vai permanentemente deletar o Template Geral",
            },
            errors: {
              name: "O nome é obrigatório",
              templateGeneralType: "O tipo de template geral é obrigatório",
            },
          },
          automationMessageTicketDefaulDoc: {
            title: "Protocolo Padrão",
            new: "Novo protocolo padrão",
            add: "Adicionar protocolo padrão",
            send_when: "Enviar Quando",
            ticket_default_doc: "Protocolo Padrão",
            enable: "Ativar",
            description: "Descrição",
            schedules: "Agendamentos",
            insurances: "Convênios",
            internalProcedures: "Proc internos",
            active: "Ativo",
            inactive: "Inativo",
            status: "Status",
            schedulesMessageHelper:
              "Os valores devem ser separados por vírgula",
            insurancesMessageHelper:
              "Os valores devem ser separados por vírgula",
            internalProceduresMessageHelper:
              "Os valores devem ser separados por vírgula",
            confirm: {
              title: "Deletar o protocolo padrão?",
              description:
                "Isso vai permanentemente deletar o protocolo padrão",
            },
            errors: {
              ticket_default_doc: "O protocolo padrão é obrigatório",
              send_when: "O enviar quando é obrigatória",
            },
          },
          ticketAutomationMsgTicketAutTemplate: {
            title: "Template após Resposta",
            new: "Novo template após Resposta",
            add: "Adicionar template após Resposta",
            send_when: "Enviar Quando",
            ticket_automation_template: "Template",
            schedules: "Agendamentos",
            insurances: "Convênios",
            schedulesMessageHelper:
              "Os valores devem ser separados por vírgula",
            insurancesMessageHelper:
              "Os valores devem ser separados por vírgula",
            confirm: {
              title: "Deletar o Template após Resposta?",
              description:
                "Isso vai permanentemente deletar o template após Resposta",
            },
            errors: {
              ticket_automation_template: "O template é obrigatório",
              send_when: "O enviar quando é obrigatória",
              schedules: "Agendamentos ou Convênios é obrigatório",
              insurances: "Agendamentos ou Convênios é obrigatório",
            },
          },
          AutomationTasyOrientation: {
            title: "Orientação Tasy",
            new: "Novo orientação Tasy",
            add: "Adicionar orientação Tasy",
            send_when: "Enviar Quando",
            type_tasy_orientation: "Processo Tasy",
            enable: "Habilitar",
            active: "Ativo",
            inactive: "Inativo",
            status: "Status",
            confirm: {
              title: "Deletar a orientação Tasy?",
              description: "Isso vai permanentemente deletar a orientação Tasy",
            },
            errors: {
              send_when: "O enviar quando é obrigatória",
              type_tasy_orientation: "O Processo Tasy é obrigatório",
            },
          },
          automationRules: {
            automation_rules: "Regras de Envio",
            automation_rule: "Regra de Envio",
            new_automation_rule: "Nova regra de envio",
            search: "Pesquise por uma regra de envio",
            add_automation_rule: "Adicionar regra de envio",
            ticket_channels: "Quadros",
            ticket_channels_subtitle:
              "Caso não for informado nenhum quadro a regra estará disponível para todos os quadros",
            add_ticket_channels: "Quadros adicionados",
            automation_message_ticket_automation_template:
              "Template após Resposta",
            name: "Nome",
            automation: "Automação",
            created_by: "Criado por",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            enable: "Habilitar",
            event: "Evento",
            ticket_service: "Serviço de ticket(card)",
            action_after_24_hours: "Ação após 24 horas",
            select_action_after_24_hours: "Selecione a ação após 24 horas",
            initial_date: "Data de início",
            end_date: "Data de fim",
            whatsapp_template: "Template do WhatsApp",
            robot: "Robô",
            attendant: "Atendente",
            pendent: "Pendência de Envio",
            when_error: "Quando der algum erro ao disparar o template",
            when_blacklist: "Quando o contato estiver na blacklist",
            automation_message_ticket_defaul_doc: "Protocolo Padrão",
            automation_tasy_orientation: "Orientação Tasy",
            board: "Quadro",
            list: "Lista",
            time_rule: "Regra de tempo",
            automation_message: "Mensagem de automação",
            messages: "Mensagens",
            created_successfully: "Regra de automação criada com sucesso",
            confirm: {
              title: "Deletar regra de envio?",
              description: "Isso vai permanentemente deletar a regra de envio",
            },
            errors: {
              name: "O nome é obrigatório",
              ticket_automation: "A automação é obrigatória",
              ticket_event: "O evento é obrigatório",
              ticket_service: "O serviço de ticket(card) é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              ticket_automation_template:
                "O template do WhatsApp é obrigatório",
              ticket_channel_step_robot: "A lista para o robô é obrigatória",
              ticket_channel_step_attendant:
                "A lista para o atendente é obrigatória",
              ticket_channel_step_pendent:
                "A lista para a pendência de envio é obrigatória",
              action_after_24_hours: "Selecione a ação após 24 horas",
              initial_date_bigger:
                "A data de início deve ser menor que a data de fim",
              list: "A lista é obrigatória",
            },
          },
        },
        flows: {
          serviceWhatsapp: {
            title: "Você foi redirecionado para o gerenciador de fluxos",
            subtitle: "Para acessar novamente clique no botão abaixo",
            button: "Acessar",
          },
        },
      },
    },
    "4uESign": {
      page: {
        automations: {
          automationRules: {
            attendantTypeHelperText:
              "Os valores devem ser separados por vírgula",
            wordFile: "Arquivo word",
            model_file: "Arquivo modelo",
            download_model: "Baixar modelo",
            model_files: {
              guia_sp_sadt: "Guia SP-SADT",
              ficha_paciente: "Ficha do paciente",
            },
            active: "Ativo",
            inactive: "Inativo",
            automation_rules: "Regras de automação",
            automation_rule: "Regra de automação",
            establishment: "Estabelecimentos",
            esignAttendantType: "Tipo atendimento",
            insuranceType: "Tipo do convênio",
            external_medical_certificate_types: "Tipo de receita",
            header_footer_type: "Modelo padrão de cabeçalho e rodapé",
            esignStoragePlace: "Local de armazenamento",
            additionalData: "Dado adicional para salvar o arquivo",
            requiredSignatures: "Assinaturas exigidas",
            technicalManagerCode: "Código do responsável técnico",
            interoperability: "Interoperabilidade",
            signOnly: "Filtro de assinatura",
            periodInDays: "Período em dias",
            service: "Serviço",
            direction: "Direção",
            documents: "Documentos",
            document: "Documento",
            new_document: "Novo documento",
            edit_document: "Editar documento",
            new_service: "Novo serviço",
            edit_service: "Editar serviço",
            addVariables: "Adicionar variáveis",
            available_variables: "Variáveis disponíveis",
            available_variables_button: "Variáveis",
            available_variables_tooltip: "Visualizar variáveis disponíveis",
            available_variables_helper:
              "Use as variáveis abaixo no documento Word desta regra.",
            no_available_variables:
              "Nenhuma variável disponível para esta automação.",
            variables_load_error:
              "Não foi possível carregar as variáveis disponíveis.",
            variables_automation_not_found:
              "Não foi possível identificar a automação vinculada a esta regra.",
            copy_variable: "Copiar variável",
            close: "Fechar",
            try_again: "Tentar novamente",
            search: "Procure por uma regra de automação",
            document_search: "Procure por um documento",
            interroperability_search: "Procure por um serviço",
            name: "Nome",
            code: "Código",
            created_by: "Criado por",
            status: "Status",
            new_automation_rule: "Nova regra de automação",
            add_automation_rule: "Adicionar regra de automação",
            qrCodeEnable: "Habilitar QRCode",
            enable: "Habilitar",
            esign_automation: "Automação",
            priority: "Prioridade",
            initial_date: "Data de início",
            end_date: "Data de fim",
            observation: "Observação",
            tasy_automation_warning:
              "Esta automação irá agrupar todas as regras referentes a ficha de atendimento para coletar a assinatura uma única vez do paciente, então se tiver várias regras irá coletar uma única assinatura do paciente.",
            file_generation: "Da geração do arquivo e integração",
            file_type: "Tipo de Arquivo",
            add_service: "Adicionar serviço",
            add_document: "Adicionar documento",
            tabs: {
              general: "Dados Gerais",
              documents: "Documentos",
              interoperability: "Interoperabilidade",
            },
            order: "Ordem",
            header_pdf: "Cabeçalhos do PDF",
            footer_pdf: "Rodapé do PDF",
            body_pdf: "Corpo do pdf",
            created_successfully: "Regra de automação criada com sucesso",
            automation: "Automação",
            physicians: "Médicos",
            insuranceTypes: "Tipo do convênio",
            authorizationTypes: "Tipo de autorização",
            guideTypes: "Tipo de guia",
            authorizationStages: "Estágio da autorização",
            insurances: "Convênio",
            interroperability_delete: {
              title: "Deseja deletar esse serviço?",
              description: "Isso vai permanentemente deletar esse serviço",
            },
            document_delete: {
              title: "Deseja deletar esse documento?",
              description: "Isso vai permanentemente deletar esse documento",
            },
            confirm: {
              title: "Deletar regra de automação?",
              description:
                "Isso vai permanentemente deletar a regra de automação",
            },
            errors: {
              headerFooterType:
                "O modelo padrão de cabeçalho e rodapé é obrigatório",
              additionalInfo: "Dados adicional é obrigatório",
              name: "O nome é obrigatório",
              automation: "A automação é obrigatória",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              initial_date_bigger:
                "A data de início deve ser menor que a data de fim",
              priority: "A prioridade deve ser maior ou igual a 1",
              order: "A ordem deve ser maior ou igual a 1",
              requiredSignatures: "Pelo menos uma assinatura é obrigatória",
              requiredSignatures_empty:
                "Selecione pelo menos uma assinatura exigida",
              technicalManagerCode:
                "O código do responsável técnico é obrigatório",
              establishment: "O estabelecimento é obrigatório",
              physicians: "Selecione pelo menos um médico",
              insuranceTypes: "Selecione pelo menos um tipo de convênio",
              esignLocationSaveFile: "O local de armazenamento é obrigatório",
              service: "Serviço é obrigatório",
              direction: "Direção é obrigatória",
              signOnlyPeriod: "O período em dias é obrigatório",
              signOnly: "Filtro de assinatura é obrigatório",
            },
            media_files: "Documentos",
            add_media_file: "Adicionar documento",
            body: "Corpo do documento",
          },
          emailSendRules: {
            title: "Regras de envio de e-mail",
            form_title: "Regra de envio de e-mail",
            new: "Nova regra de envio de e-mail",
            add: "Adicionar regra de envio de e-mail",
            search: "Pesquise por uma regra de envio de e-mail",
            name: "Nome",
            initial_date: "Data de início",
            end_date: "Data de fim",
            subject: "Título",
            body: "Conteúdo",
            enable: "Habilitar",
            status: "Status",
            active: "Ativo",
            inactive: "Inativo",
            variables_button: "Variáveis",
            variables_tooltip: "Visualizar variáveis disponíveis",
            available_variables: "Variáveis disponíveis",
            copy_variable: "Copiar variável",
            close: "Fechar",
            overlap_error:
              "Já existe uma regra de envio de e-mail com vigência sobreposta.",
            variables: {
              patient_name: "Nome do paciente",
              encounter_number: "Número do atendimento",
            },
            confirm: {
              title: "Deletar regra de envio de e-mail?",
              description:
                "Isso vai permanentemente deletar a regra de envio de e-mail",
            },
            errors: {
              name: "O nome é obrigatório",
              initial_date: "A data de início é obrigatória",
              end_date: "A data de fim é obrigatória",
              subject: "O título é obrigatório",
              body: "O conteúdo é obrigatório",
              end_date_less:
                "A data de fim deve ser maior ou igual à data de início",
            },
          },
          signatureGroups: {
            title: "Grupos de Assinatura",
            edit: "Editar grupo de assinatura",
            name: "Nome",
            linkedRules: "Regras vinculadas",
            search: "Pesquise por um grupo de assinatura",
            errors: { name: "O nome é obrigatório" },
          },
        },
        logs: {
          forubusSignatureLogs: {
            identifier: "Identificador",
            signature_type: "Tipo de Assinatura",
            first_integration_id: "Identificador",
            first_integration_id_hint:
              "Pode ser o número da receita, do atestado ou do atendimento",
            document_code: "Código do Documento",
            ged_integration_id: "Integração GED",
            finish_date: "Data de Conclusão",
            search_placeholder: "Pesquisar...",
            view_details: "Ver detalhes",
            start_date: "Data inicial",
            end_date: "Data final",
            emailSend: {
              action: "E-mail ao paciente",
              title: "E-mail ao paciente",
              identification:
                "Documento {{documentCode}} • Atendimento {{encounterNumber}}",
              close: "Fechar",
              loading: "Consultando o status do e-mail...",
              not_sent: "E-mail não enviado",
              not_sent_description:
                "Ainda não há registro de envio de e-mail para este envelope.",
              load_error: "Não foi possível consultar o e-mail",
              load_error_description:
                "O status do envio não pôde ser carregado. Tente novamente.",
              retry: "Tentar novamente",
              status: "Status",
              statusValues: {
                pending: "Aguardando envio",
                sending: "Enviando",
                sent: "Enviado",
                error: "Erro no envio",
                unknown: "Status desconhecido",
              },
              send_details: "Detalhes do envio",
              recipient: "Destinatário",
              sent_at: "Data de envio",
              not_sent_yet: "Ainda não enviado",
              attachments_count: "Quantidade de anexos",
              attempts: "Número de tentativas",
              error_message: "Mensagem de erro",
              no_error_message: "Nenhuma mensagem de erro",
            },
            details: {
              title: "Detalhes da Assinatura",
              close: "Fechar",
              record_info: "Registro de assinatura digital",
              signed: "Assinado",
              pending: "Pendente",
              section_identification: "Identificação",
              section_integrations: "Integrações",
              section_dates: "Datas",
              section_qrcode: "QR Code",
              document_code: "Código do Documento",
              file_name: "Nome do Arquivo",
              file_path: "Caminho do Arquivo",
              mime_type: "Tipo MIME",
              file_size: "Tamanho do Arquivo",
              first_integration_id: "ID Receita / Atestado",
              second_integration_id: "Segunda Integração",
              third_integration_id: "Terceira Integração",
              ged_integration_id: "Integração GED",
              created: "Criado em",
              last_modified: "Última Modificação",
              send_date: "Data de Envio",
              finish_date: "Data de Conclusão",
              qr_code: "Dados do QR Code",
            },
          },
        },
      },
    },
  },
};

export default pt_BR;
